/** VERSION: 1.3.5. Please don't modify or unzip this content. It will be updated regularly **/
var BoostPFS = function (t) {
  function e(e) {
    for (var i, a, l = e[0], s = e[1], c = e[2], p = 0, f = []; p < l.length; p++) a = l[p], Object.prototype.hasOwnProperty.call(r, a) && r[a] && f.push(r[a][0]), r[a] = 0;
    for (i in s) Object.prototype.hasOwnProperty.call(s, i) && (t[i] = s[i]);
    for (u && u(e); f.length;) f.shift()();
    return o.push.apply(o, c || []), n()
  }

  function n() {
    for (var t, e = 0; e < o.length; e++) {
      for (var n = o[e], i = !0, l = 1; l < n.length; l++) {
        var s = n[l];
        0 !== r[s] && (i = !1)
      }
      i && (o.splice(e--, 1), t = a(a.s = n[0]))
    }
    return t
  }
  var i = {},
    r = {
      0: 0
    },
    o = [];

  function a(e) {
    if (i[e]) return i[e].exports;
    var n = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return t[e].call(n.exports, n, n.exports, a), n.l = !0, n.exports
  }
  a.m = t, a.c = i, a.d = function (t, e, n) {
    a.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    })
  }, a.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    })
  }, a.t = function (t, e) {
    if (1 & e && (t = a(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (a.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t)
      for (var i in t) a.d(n, i, function (e) {
        return t[e]
      }.bind(null, i));
    return n
  }, a.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default
    } : function () {
      return t
    };
    return a.d(e, "a", e), e
  }, a.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e)
  }, a.p = "";
  var l = window.webpackJsonpBoostPFS = window.webpackJsonpBoostPFS || [],
    s = l.push.bind(l);
  l.push = e, l = l.slice();
  for (var c = 0; c < l.length; c++) e(l[c]);
  var u = s;
  return o.push([171, 1]), n()
}({
  1: function (t, e, n) {
    "use strict";
    n(127), n(38);
    var i = n(2),
      r = {
        prefix: "pf",
        queryParams: {},
        instantSearchQueryParams: {},
        internalClick: !1,
        imutableFilterTree: ["page", "sort", "limit", "display", "_", "tab"],
        otherParams: ["page", "sort", "limit", "display", "tab"],
        hasFilterOptionParam: !1,
        scrollData: [],
        shopName: "",
        shopDomain: "",
        fileUrl: "",
        defaultCurrency: "",
        moneyFormat: "",
        collectionId: "",
        collectionTags: "",
        currentTags: "",
        defaultSorting: "",
        swatchExtension: "",
        productAvailable: !0,
        variantAvailable: !0,
        loadProductFirst: !1,
        searchTermKey: "q",
        suggestionCache: {},
        currentTerm: "",
        init: function () {
          var t = boostPFSConfig.shop,
            e = boostPFSConfig.general;
          r.shopName = t.name, r.shopDomain = t.domain, r.defaultCurrency = t.currency, r.moneyFormat = t.money_format, r.fileUrl = e.file_url, r.collectionId = e.collection_id, r.collectionTags = e.collection_tags, r.collectionCount = e.collection_count, r.currentTags = e.current_tags, r.defaultSorting = e.default_sort_by.trim(), r.swatchExtension = e.swatch_extension, r.productAvailable = i.a.getSettingValue("general.productAvailable"), r.variantAvailable = i.a.getSettingValue("general.variantAvailable"), i.a.getSettingValue("general.productAndVariantAvailable") && (r.productAvailable = !0, r.variantAvailable = !0), r.loadProductFirst = i.a.getSettingValue("general.loadProductFirst"), r.searchTermKey = i.a.getSettingValue("search.termKey"), r.mobileStyle = i.a.getSettingValue("general.filterTreeMobileStyle"), r.suggestionTypes = i.a.getSettingValue("search.suggestionTypes")
        }
      };
    e.a = r
  },
  171: function (t, e, n) {
    var i = n(59).default;
    window.BoostPFSFilterCallback = n(7).default.BoostPFSFilterCallback, window.BoostPFSInstantSearchCallback = n(74).default.BoostPFSInstantSearchCallback, window.jQuery || (window.jQuery = i.jQ), t.exports = i
  },
  2: function (t, e, n) {
    "use strict";
    n(34), n(48), n(19), n(37);
    var i = n(3),
      r = {
        general: {
          enableFilter: !0,
          filterTreeMobileStyle: "style2",
          filterTreeMobileStyleFullWidth: !1,
          filterHorizontalColumn: "1",
          showRefineBy: !0,
          separateRefineByFromFilter: !1,
          refineByHorizontalPosition: "bottom",
          changeMobileButtonLabel: !1,
          breakpointMobile: "767",
          showLoading: !1,
          showMobileLoading: !1,
          showLoadMoreLoading: !0,
          positionShowInfiniteLoading: 700,
          activeScrollToTop: !1,
          styleScrollToTop: "style1",
          showSingleOption: !0,
          showOutOfStockOption: !1,
          showFilterOptionCount: !0,
          requestInstantly: !1,
          capitalizeFilterOptionValues: !0,
          forceCapitalizeFilterOptionValues: !1,
          capitalizeFirstLetterFilterOptionValues: !1,
          collapseOnPCByDefault: !1,
          collapseOnMobileByDefault: !1,
          keepScrollState: !0,
          keepToggleState: !0,
          keepTabOpenState: !1,
          activeFilterScrollbarPC: !0,
          activeFilterScrollbarMobile: !0,
          scrollFirstLoadLength: 24,
          startViewMore: {
            list: 5,
            box: 3,
            swatch: 10
          },
          startViewMoreH: {
            list: 10,
            box: 20,
            swatch: 10
          },
          removePriceDecimal: !0,
          rangeSliderMoneyFormat: "",
          oneValueRangeSlider: !1,
          rangeSlidersStyle3: [],
          rangeSlidersSingleHandle: [],
          advancedRangeSliders: [],
          shortenPipsRange: !1,
          formatPipsRange: [{
            node: 1e3,
            symbol: "K",
            fix: 0,
            suffix: !1
          }, {
            node: 1e6,
            symbol: "M",
            fix: 2,
            suffix: !1
          }],
          enable3rdCurrencySupport: !1,
          imageExtension: ["jpg", "JPG", "png", "PNG", "jpeg", "JPEG", "gif", "GIF"],
          swatchStyle: "",
          swatchImageVersion: "1111111",
          removePrefixFromSwatchFile: !0,
          enableFilterOptionBoxStyle: !0,
          filterOptionBoxCharWidth: 14,
          openMultiLevelByDefault: [],
          multiLevelCollectionSelectType: "single",
          filterPrefixParam: "pf_",
          limit: 16,
          vendorParam: "pf_v_vendor",
          typeParam: "pf_pt_product_type",
          priceMode: "",
          tagMode: "",
          urlScheme: 1,
          isShortenUrlParam: !1,
          shortenUrlParamList: [],
          productAvailable: !1,
          variantAvailable: !1,
          availableAfterFiltering: !1,
          loadProductFirst: !0,
          loadProductFirstBestSelling: !1,
          enableKeepScrollbackPosition: !0,
          addCollectionToProductUrl: !0,
          showVariantImageBasedOnSelectedFilter: "",
          paginationType: "default",
          paginationTypeAdvanced: !0,
          activeLoadPreviousPage: !1,
          sessionStorageCurrentPreviousPage: "boostPFSCurrentPreviousPage",
          sessionStorageCurrentPage: "boostPFSCurrentPage",
          sessionStorageCurrentNextPage: "boostPFSCurrentNextPage",
          sessionStoragePreviousPageEvent: "boostPFSPreviousPageEvent",
          sortingList: ["best-selling", "relevance", "manual", "price-ascending", "price-descending", "title-ascending", "title-descending", "created-descending", "created-ascending"],
          customSortingList: "",
          extraSortingList: "",
          sortingAvailableFirst: !1,
          showLimitList: "4,8,12,16",
          defaultDisplay: "grid",
          collageNumber: 3,
          showPlaceholderProductList: !1,
          placeholderImageRatio: 1.4,
          placeholderProductGridItemClass: "",
          placeholderProductPerRow: 3,
          loadProductFromLiquid: !1,
          loadProductFromLiquidType: "ajax",
          otpProductItemClass: "",
          enableAjaxCart: !1,
          ajaxCartStyle: "slide",
          showAjaxCartOnAdd: !0,
          autoCloseMiniCart: !1,
          autoCloseMiniCartDuration: 2e3,
          selectOptionInProductItem: !1,
          selectOptionContainer: "",
          enableTrackingOrderRevenue: !0,
          enableSeo: !0,
          boostCollection: "boost-all"
        },
        search: {
          enableSearch: !0,
          enableSuggestion: !0,
          suggestionBlocks: [{
            type: "suggestions",
            label: "Suggestions",
            status: "active",
            number: 3
          }, {
            type: "collections",
            label: "Collections",
            status: "active",
            number: 2
          }, {
            type: "pages",
            label: "Pages",
            status: "active",
            number: 2
          }, {
            type: "products",
            label: "Products",
            status: "active",
            number: 3
          }],
          suggesionMaxItems: 10,
          suggestionDymLimit: 2,
          suggestionMinLength: 1,
          suggestionPosition: "",
          suggestionDelay: 200,
          suggestionWidth: "auto",
          suggestionTypes: [],
          suggestionStyle: "",
          suggestionStyle2MainContainerSelector: "header:first",
          suggestionStyle2ReverseProductBlock: !1,
          suggestionStyle2ProductPerRow: 3,
          suggestionMobileStyle: "style1",
          showSuggestionLoading: !0,
          showSuggestionProductVendor: !0,
          showSuggestionProductPrice: !0,
          showSuggestionProductSalePrice: !0,
          showSuggestionProductImage: !0,
          showSuggestionProductSku: !1,
          showSearchBtnMobile: !1,
          enableDefaultResult: !0,
          enableFuzzy: !0,
          productAvailable: !1,
          removePriceDecimal: !1,
          highlightSuggestionResult: !0,
          openProductNewTab: !1,
          suggestionMode: "prod",
          termKey: "q",
          skipFields: [],
          reduceMinMatch: !1,
          fullMinMatch: !1,
          enablePlusCharacterSearch: !1,
          fontSizeSuggestionHeader: "",
          bgSuggestionHeader: "",
          colorSuggestionHeader: "",
          enableFixHeadTitle: !0,
          searchPanelList: ["products", "collections", "pages"],
          searchPanelDefault: "products",
          searchPanelBlocks: {
            products: {
              label: "Products",
              pageSize: 25,
              active: !0
            },
            collections: {
              label: "Collections",
              pageSize: 25,
              active: !1
            },
            pages: {
              label: "Pages",
              pageSize: 25,
              active: !1
            }
          },
          suggestionNoResult: {
            search_terms: {
              label: '"Popular suggestions',
              status: !0,
              data: []
            },
            products: {
              label: "Products",
              status: !0,
              data: []
            }
          }
        },
        init: function () {
          var t = r;
          if ("undefined" != typeof boostPFSConfig && boostPFSConfig.hasOwnProperty("settings") && null !== boostPFSConfig.settings && (t = i.a.mergeObject(t, boostPFSConfig.settings)), "undefined" != typeof boostPFSAppConfig && Object.keys(boostPFSAppConfig).length > 0 && (t = i.a.mergeObject(t, boostPFSAppConfig)), "undefined" != typeof boostPFSThemeConfig && Object.keys(boostPFSThemeConfig).length > 0 && (t = i.a.mergeObject(t, boostPFSThemeConfig)), "undefined" != typeof boostPFSFilterConfig && Object.keys(boostPFSFilterConfig).length > 0 && (t = i.a.mergeObject(t, boostPFSFilterConfig)), "undefined" != typeof boostPFSInstantSearchConfig && Object.keys(boostPFSInstantSearchConfig).length > 0 && (t = i.a.mergeObject(t, boostPFSInstantSearchConfig)), "undefined" != typeof Shopify && Shopify.hasOwnProperty("locale") && t.hasOwnProperty("label") && t.hasOwnProperty("labelTranslations") && void 0 !== t.labelTranslations && t.labelTranslations.hasOwnProperty(Shopify.locale)) {
            var e = t.labelTranslations[Shopify.locale];
            t.label = i.a.mergeObject(t.label || {}, e)
          }
          r = t
        },
        getSettingValue: function (t) {
          var e = "";
          if (r.hasOwnProperty(t)) return r[t];
          if (t.indexOf(".") > -1)
            for (var n = t.split("."), i = 0; i < n.length; i++)
              if ("" == e) {
                if (!r.hasOwnProperty(n[i])) return "";
                e = r[n[i]]
              } else {
                if (!e.hasOwnProperty(n[i])) return "";
                e = e[n[i]]
              }
          return e
        }
      };
    e.a = r
  },
  22: function (t, e, n) {
    "use strict";
    n(14), n(15), n(16), n(10), n(17), n(18), n(11), n(62), n(19), n(13), n(20), n(57), n(12);
    var i = n(0),
      r = n.n(i),
      o = n(9),
      a = n(8),
      l = n(1),
      s = n(4),
      c = n(27),
      u = n(7);
    n(58);

    function p(t) {
      return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function f(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function h(t, e) {
      return !e || "object" !== p(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function y(t) {
      return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function d(t, e) {
      return (d = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var g = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = h(this, y(e).call(this))).$element = null, i.data = t, i.type = n, i.eventType = "init", i.isRenderPanelContent = !1, i.limit = 25, i.page = 1, i.active = t.active, i.type == e.Enum.PRODUCT ? (i.limit = Settings.getSettingValue("general.limit"), i.page = l.a.queryParams.page) : t.hasOwnProperty("pageSize") && (i.limit = parseInt(t.pageSize)), i
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && d(t, e)
      }(e, t), n = e, o = [{
        key: "Enum",
        get: function () {
          return {
            COLLECTION: "collections",
            PRODUCT: "products",
            PAGE: "pages"
          }
        }
      }], (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.searchResultPanelItem}}">\n\t\t\t\t<button>{{panelItemLabel}} ({{panelItemCount}})</button>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          var t = "";
          switch (this.type) {
          case e.Enum.COLLECTION:
            t = a.a.search.searchPanelCollection;
            break;
          case e.Enum.PAGE:
            t = a.a.search.searchPanelPage;
            break;
          default:
            t = a.a.search.searchPanelProduct
          }
          var n = this.data.hasOwnProperty("label") ? this.data.label : t;
          return this.getTemplate().replace(/{{panelItemLabel}}/g, n).replace(/{{panelItemCount}}/g, this.totalResult).replace(/{{class.searchResultPanelItem}}/g, s.a.searchResultPanelItem)
        }
      }, {
        key: "isActive",
        value: function () {
          return c.a.isPanelActive(this.type)
        }
      }, {
        key: "isRender",
        value: function () {
          return this.type == e.Enum.PRODUCT || this.active && this.totalResult && "init" == this.eventType
        }
      }, {
        key: "render",
        value: function () {
          this.$element = r()(this.compileTemplate()), this.isActive() && this.$element.addClass("boost-active")
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element && this.$element.on("click", this._onClickPanelItem.bind(this))
        }
      }, {
        key: "setData",
        value: function (t, n) {
          var i = 0;
          switch (this.eventType = n, this.type) {
          case e.Enum.COLLECTION:
            i = t.total_collection;
            break;
          case e.Enum.PAGE:
            i = t.total_page;
            break;
          default:
            i = t.total_product
          }
          this.totalResult = i, this.type == e.Enum.PRODUCT && (this.page = l.a.queryParams.page)
        }
      }, {
        key: "_onClickPanelItem",
        value: function (t) {
          t.preventDefault(), l.a.searchDisplay = this.type, u.default.setParam("limit", this.limit), u.default.setParam("page", this.page);
          var n = this.parent,
            i = n.parent.searchResultTotal;
          switch (this.isRenderPanelContent || this.type === e.Enum.PRODUCT || u.default.getFilterData("search", this._searchPanelCallback.bind(this)), this.$element.addClass("boost-active"), this.$element.siblings().removeClass("boost-active"), this.type) {
          case e.Enum.COLLECTION:
            n.showPanelCollection();
            break;
          case e.Enum.PAGE:
            n.showPanelPage();
            break;
          default:
            n.showPanelProduct()
          }
          i.setData(this.totalResult, this.type), i.refresh(), this.isRenderPanelContent = !0
        }
      }, {
        key: "_searchPanelCallback",
        value: function (t) {
          var n = this.parent.parent.collectionList,
            i = this.parent.parent.collectionListPagination,
            r = !!t.hasOwnProperty("total_collection") && t.total_collection;
          l.a.searchDisplay === e.Enum.PAGE && (n = this.parent.parent.pageList, i = this.parent.parent.pageListPagination, r = !!t.hasOwnProperty("total_page") && t.total_page), n.setData(t), n.refresh(), i.setData(t, r, this.limit, this.page), i.refresh()
        }
      }]) && f(n.prototype, i), o && f(n, o), e
    }(o.a);
    e.a = g
  },
  27: function (t, e, n) {
    "use strict";
    n(14), n(15), n(16), n(23), n(34), n(10), n(17), n(18), n(11), n(153), n(13), n(24), n(12);
    var i = n(0),
      r = n.n(i),
      o = n(9),
      a = n(2),
      l = n(3),
      s = n(6),
      c = (n(8), n(22)),
      u = n(4);

    function p(t) {
      return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function f(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function h(t, e) {
      return !e || "object" !== p(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function y(t) {
      return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function d(t, e) {
      return (d = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var g = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = h(this, y(e).call(this))).$element = r()(s.a.searchTopPanels), t.data = null, t.panelItems = [], t.eventType = "init", t.selector = {
          products: s.a.products,
          collections: s.a.collections,
          pages: s.a.pages,
          filterTree: s.a.filterTree,
          filterTreeMobileButton: s.a.filterTreeMobileButton,
          pagination: s.a.pagination,
          loadMore: s.a.loadMore,
          btnLoadPreviousPageWrapperSelector: s.a.btnLoadPreviousPageWrapperSelector,
          searchPanelsProductShow: s.a.searchPanelsProductShow,
          searchPanelsCollectionShow: s.a.searchPanelsCollectionShow,
          searchPanelsPageShow: s.a.searchPanelsPageShow
        }, t.settings = {
          searchPanelDefault: a.a.getSettingValue("search.searchPanelDefault"),
          searchPanelList: a.a.getSettingValue("search.searchPanelList"),
          searchPanelBlocks: a.a.getSettingValue("search.searchPanelBlocks")
        }, t.isFetchedFilterData = !1, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && d(t, e)
      }(e, t), n = e, o = [{
        key: "isPanelActive",
        value: function (t) {
          return !l.a.isSearchPage() || e.getPanelActive() == t
        }
      }, {
        key: "getPanelActive",
        value: function () {
          return Globals.hasOwnProperty("searchDisplay") && Object.values(c.a.Enum).indexOf(Globals.searchDisplay) > -1 ? Globals.searchDisplay : a.a.getSettingValue("search.searchPanelDefault")
        }
      }], (i = [{
        key: "init",
        value: function () {
          var t = this;
          this.panelItems = [], this.settings.searchPanelList.forEach((function (e) {
            var n = t.settings.searchPanelBlocks[e],
              i = new c.a(n, e);
            t.addComponent(i), t.panelItems.push(i)
          }))
        }
      }, {
        key: "isRender",
        value: function () {
          return l.a.isSearchPage() && this.isFetchedFilterData
        }
      }, {
        key: "render",
        value: function () {
          var t = [],
            n = 0;
          switch (this.panelItems.forEach((function (e) {
            t.push(e.$element), e.isRendered && n++
          })), this.$element.html(t), e.getPanelActive()) {
          case c.a.Enum.COLLECTION:
            this.showPanelCollection();
            break;
          case c.a.Enum.PAGE:
            this.showPanelPage();
            break;
          default:
            this.showPanelProduct()
          }
          this.$element.addClass("boost-pfs-search-panel-items-" + n)
        }
      }, {
        key: "hidePanelProduct",
        value: function () {
          r()(this.selector.products).addClass(u.a.hidden), r()(this.selector.filterTreeMobileButton).addClass(u.a.hidden), r()(this.selector.filterTree).addClass(u.a.hidden), r()(this.selector.pagination).addClass(u.a.hidden), r()(this.selector.loadMore).addClass(u.a.hidden), r()(this.selector.btnLoadPreviousPageWrapperSelector).addClass(u.a.hidden), r()(this.selector.searchPanelsProductShow).addClass(u.a.hidden)
        }
      }, {
        key: "hidePanelCollection",
        value: function () {
          r()(this.selector.collections).parent().addClass(u.a.hidden), r()(this.selector.searchPanelsCollectionShow).addClass(u.a.hidden)
        }
      }, {
        key: "hidePanelPage",
        value: function () {
          r()(this.selector.pages).parent().addClass(u.a.hidden), r()(this.selector.searchPanelsPageShow).addClass(u.a.hidden)
        }
      }, {
        key: "showPanelProduct",
        value: function () {
          this.hidePanelCollection(), this.hidePanelPage(), r()(this.selector.products).removeClass(u.a.hidden), r()(this.selector.filterTree).removeClass(u.a.hidden), r()(this.selector.filterTreeMobileButton).removeClass(u.a.hidden), r()(this.selector.pagination).removeClass(u.a.hidden), r()(this.selector.loadMore).removeClass(u.a.hidden), r()(this.selector.btnLoadPreviousPageWrapperSelector).removeClass(u.a.hidden), r()(this.selector.searchPanelsProductShow).removeClass(u.a.hidden)
        }
      }, {
        key: "showPanelCollection",
        value: function () {
          this.hidePanelProduct(), this.hidePanelPage(), r()(this.selector.collections).parent().removeClass(u.a.hidden), r()(this.selector.searchPanelsCollectionShow).removeClass(u.a.hidden)
        }
      }, {
        key: "showPanelPage",
        value: function () {
          this.hidePanelProduct(), this.hidePanelCollection(), r()(this.selector.pages).parent().removeClass(u.a.hidden), r()(this.selector.searchPanelsPageShow).removeClass(u.a.hidden)
        }
      }, {
        key: "setData",
        value: function (t, e) {
          this.isFetchedFilterData = !0, t && (this.data = t), this.eventType = e, this.panelItems.forEach((function (n) {
            n.setData(t, e)
          }))
        }
      }]) && f(n.prototype, i), o && f(n, o), e
    }(o.a);
    e.a = g
  },
  3: function (t, e, n) {
    "use strict";
    n(14), n(15), n(16), n(36), n(44), n(34), n(10), n(67), n(96), n(122), n(84), n(73), n(98), n(148), n(48), n(11), n(85), n(150), n(19), n(40), n(46), n(13), n(126), n(20), n(57), n(37), n(38), n(12);
    var i = n(0),
      r = n.n(i),
      o = n(2),
      a = n(1),
      l = {
        isFullWidthMobile: function () {
          return A.isMobile() && "style1" == o.a.getSettingValue("search.suggestionMobileStyle")
        },
        isStyle2: function () {
          return !A.isMobile() && "style2" === o.a.getSettingValue("search.suggestionStyle")
        }
      },
      s = {
        checkExistFilterOptionParam: function () {
          for (var t in Globals.queryParams)
            if (t.indexOf("pf_") > -1) return !0;
          return !1
        },
        encodeURIParamValue: function (t) {
          return encodeURIComponent(t).replace(/&/g, "%26").replace(/'/g, "%27").replace(/\*/g, "%2A")
        }
      },
      c = (n(128), n(8)),
      u = n(27),
      p = n(22);

    function f(t) {
      return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }
    var h = function () {
        return o.a.getSettingValue("general.paginationTypeAdvanced")
      },
      y = function () {
        return "load_more" == o.a.getSettingValue("general.paginationType")
      },
      d = function () {
        return "infinite" == o.a.getSettingValue("general.paginationType")
      },
      g = {
        getSortingList: function () {
          var t = o.a.getSettingValue("general.sortingList"),
            e = o.a.getSettingValue("general.customSortingList");
          if ("" != e)
            for (var n = (t = e.trim().split("|")).length - 1; n >= 0; n--) "" == t[n] && t.splice(n, 1);
          var i = o.a.getSettingValue("general.extraSortingList");
          if (i && (t = t.concat(i.split("|"))), A.isSearchPage()) {
            var r = A.findIndexArray("manual", t);
            r >= 0 && t.splice(r, 1)
          } else {
            var a = A.findIndexArray("relevance", t);
            a >= 0 && t.splice(a, 1)
          }
          for (var l = {}, s = 0; s < t.length; s++) {
            var u = c.a.sortingList[t[s]];
            if (i.length > 0 && i.indexOf(t[s]) > -1) {
              var p = t[s].replace(/-/g, "_");
              u = c.a[p]
            }
            l[t[s]] = u
          }
          return l
        },
        getProductMetafield: function (t, e, n) {
          if (t.hasOwnProperty("metafields")) {
            var i = t.metafields.filter((function (t) {
              return t.namespace == e && t.key == n
            }));
            if (void 0 !== i[0]) return i[0].value
          }
          return null
        },
        isAdvancedPaginationType: h,
        buildProductItemUrl: function (t, e) {
          var n = A.getWindowLocation().search.substring(1),
            i = window.location.pathname,
            r = i.split("/"),
            a = "object" === f(t) && t.hasOwnProperty("handle") ? t.handle : t;
          if (e = void 0 !== e ? e : o.a.getSettingValue("general.addCollectionToProductUrl")) {
            if ("/" == i || A.isSearchPage() || A.isVendorPage() || A.isTypePage()) return (l = r.indexOf(boostPFSAppConfig.general.current_locale) > -1 ? "/" + boostPFSAppConfig.general.current_locale + "/products/" : "/products/") + a;
            if (A.isTagPage()) {
              var l = r.indexOf(boostPFSAppConfig.general.current_locale) > -1 ? "/" + boostPFSAppConfig.general.current_locale + "/collections/" : "/collections/",
                s = r.indexOf("collections") + 1;
              return r.length >= 4 ? l + r[s] + "/products/" + a : "/products/" + a
            }
            if (n.indexOf("cache:") > -1) {
              var c = "all",
                u = n.split("&")[0].split("?")[0].split("collections/");
              return u.length > 1 && (c = u[1].indexOf("/") > -1 ? u[1].split("/")[0] : u[1]), "/products/" + a
            }
            s = r.indexOf("collections") + 1, l = r.indexOf(boostPFSAppConfig.general.current_locale) > -1 ? "/" + boostPFSAppConfig.general.current_locale + "/collections/" : "/collections/";
            return void 0 !== r[2] ? "/products/" + a : "/products/" + a
          }
          return r.indexOf(boostPFSAppConfig.general.current_locale) > -1 ? "/" + boostPFSAppConfig.general.current_locale + "/products/" + a : "/products/" + a
        },
        removePageParamFromUrl: function (t) {
          return a.a.queryParams.hasOwnProperty("page") && (t = t.replace("&page=" + a.a.queryParams.page, "").replace("?page=" + a.a.queryParams.page + "&", "?").replace("?page=" + a.a.queryParams.page, "")), t
        },
        removeCollectionScopeParamFromUrl: function (t) {
          return a.a.queryParams.hasOwnProperty("collection_scope") && (t = t.replace("&collection_scope=" + a.a.queryParams.collection_scope, "")), t
        },
        buildToolbarLink: function (t, e, n) {
          var i = A.getWindowLocation().href,
            r = t + "=" + e,
            o = t + "=" + n;
          if (i.indexOf("?" + t + "=") > -1) i = i.replace("?" + r, "?" + o);
          else {
            if (!u.a.isPanelActive(p.a.Enum.PRODUCT) && "page" == t && i.indexOf("&" + t + "=") > -1) {
              var l = i.split("&page=")[1];
              l.indexOf("&") > -1 && (l = l.split("&")[0]), i = i.replace("&page=" + l, "")
            }
            i.indexOf("&" + t + "=") > -1 ? i = i.replace("&" + r, "&" + o) : 0 === A.getWindowLocation().search.length ? i += "?" + o : i = i.replace("?", "?" + o + "&")
          }
          "page" == t && 1 == n && (i = i.replace("?page=1&", "?").replace("?page=1", ""));
          if (a.a.queryParams.hasOwnProperty("page") && -1 == ["display", "sort", "page", "limit"].indexOf(t)) {
            var s = "&page=" + a.a.queryParams.page;
            i = i.replace(s, "")
          }
          return i
        },
        isDefaultPaginationType: function () {
          return "default" == o.a.getSettingValue("general.paginationType")
        },
        isLoadMorePaginationType: y,
        isInfiniteLoadingPaginationType: d,
        isLoadPreviousPagePaginationType: function () {
          return (y() || d()) && h() && o.a.getSettingValue("general.activeLoadPreviousPage")
        },
        isNoFilterResult: function (t, e) {
          return t <= 0 && !("init" === e && o.a.getSettingValue("general.productAndVariantAvailable") && o.a.getSettingValue("general.availableAfterFiltering"))
        }
      };

    function m(t) {
      return (m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }
    var b = function (t, e) {
        null === t && (t = boostPFSConfig.general.no_image_url);
        e = void 0 !== e ? e : "large";
        for (var n = o.a.getSettingValue("general.imageExtension"), i = 0; i < n.length; i++) t = t.replace("." + n[i] + "?", "_" + e + "." + n[i] + "?");
        return t
      },
      v = function (t) {
        return '<span class="money">{{money}}</span>'.replace(/{{money}}/g, k(t))
      },
      S = function () {
        return r()("<p>" + boostPFSConfig.shop.money_format + "</p>").text().replace(/{{[^}]*}}/g, "")
      },
      O = function (t) {
        void 0 === t && (t = !1);
        var e = boostPFSAppConfig.general.current_currency.toLowerCase().trim(),
          n = o.a.getSettingValue("currencyRoundingRules"),
          i = n && e && n.hasOwnProperty(e) ? parseFloat(n[e]) : 0,
          a = !1;
        if (i > 0 && -1 !== r.a.inArray(i, [.25, .5, .75, .9, .95, .99, 1, 25, 50, 75, 90, 95, 99, 100, 250, 500, 750, 900, 950, 999, 1e3])) {
          a = .99;
          i > 100 ? a = 999 : i > 10 ? a = 99 : i > 1 && (a = 9), t && (a = i > 1 ? a + 1 : a + .01)
        }
        return a
      },
      T = function (t) {
        t = parseFloat(t).toFixed(2);
        var e = boostPFSAppConfig.general.current_currency.toLowerCase().trim(),
          n = o.a.getSettingValue("currencyRoundingRules"),
          i = n && e && n.hasOwnProperty(e) ? n[e] : 0,
          r = O(!0);
        if (r) {
          var a = parseFloat(i);
          t /= r, 1 == (a /= r) && (a = 0);
          var l = Math.floor(t);
          t = (t - l).toFixed(2) > a ? l + 1 : l, t *= r, 0 == a && (i = 0), t += parseFloat(i)
        }
        return t
      },
      P = null,
      w = function () {
        return L.getWindowLocation().href.includes("webcache.googleusercontent.com") ? L.getWindowLocation().search.indexOf("search?") > -1 : window.location.pathname.indexOf("/search") > -1
      },
      _ = function (t, e) {
        e || (e = L.getWindowLocation().href), t = t.replace(/[\[\]]/g, "\\$&");
        var n = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
        return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "" : null
      },
      C = function (t, e, n, i) {
        if (null != n) {
          for (var r = 0; r < e.length; r++)
            if (void 0 !== i && 0 == i && (e[r][n] = e[r][n].toLowerCase(), t = t.toLowerCase()), e[r][n] == t) return r
        } else
          for (r = 0; r < e.length; r++)
            if (void 0 !== i && 0 == i && (e[r] = e[r].toLowerCase(), t = t.toLowerCase()), e[r] == t) return r;
        return -1
      },
      k = function (t) {
        return r()("<p>" + t + "</p>").text()
      },
      E = function () {
        return "undefined" != typeof Shopify && Shopify.hasOwnProperty("currency") && Shopify.currency.hasOwnProperty("rate") && 1 != Shopify.currency.rate
      },
      I = function () {
        return o.a.hasOwnProperty("general") && o.a.general.hasOwnProperty("currencies") && o.a.general.currencies.length > 1 && E()
      },
      L = {
        escape: function (t, e) {
          return e = e ? "&#13;" : "\n", ("" + t).replace(/&/g, "&amp;").replace(/'/g, "&apos;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r\n/g, e).replace(/[\r\n]/g, e)
        },
        findIndexArray: C,
        getParam: _,
        getSearchTerm: function () {
          return _(a.a.searchTermKey)
        },
        getValueInObjectArray: function (t, e, n, i) {
          void 0 === n && (n = "key"), void 0 === i && (i = "values");
          var r = C(t, e, n);
          return r > -1 && e[r].hasOwnProperty(i) ? e[r][i] : ""
        },
        getFilePath: function (t, e, n) {
          e = void 0 !== e ? e : "png", n = void 0 !== n ? n : "";
          var i = a.a.fileUrl.split("?")[0];
          return i += t + "." + e + (n ? "?v=" + n : "")
        },
        getNumberDecimals: function (t) {
          var e = t.toString().split(".");
          return e.length > 1 ? e[1].length : 0
        },
        isMobile: function () {
          return P || (P = r()(window).width(), r()(window).on("resize", (function () {
            P = r()(window).width()
          }))), P <= o.a.getSettingValue("general.breakpointMobile")
        },
        isMobileDevice: function () {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        },
        isiOS: function () {
          return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
        },
        isSafari: function () {
          return /Safari/.test(navigator.userAgent)
        },
        isBackButton: function () {
          return window.performance && window.performance.navigation && 2 == window.performance.navigation.type
        },
        isCartPage: function () {
          return window.location.pathname.indexOf("/cart") > -1
        },
        isProductPage: function () {
          return window.location.pathname.indexOf("/products") > -1
        },
        isSearchPage: w,
        isVendorPage: function () {
          return window.location.pathname.indexOf("/collections/vendors") > -1
        },
        isTagPage: function () {
          return void 0 !== a.a.currentTags && null !== a.a.currentTags && a.a.currentTags.length > 0
        },
        isTypePage: function () {
          return window.location.pathname.indexOf("/collections/types") > -1
        },
        isGLHMobile: function () {
          return navigator && navigator.userAgent && navigator.userAgent.includes(atob("TGlnaHRob3VzZQ==")) && L.isMobile() && !L.isSearchPage()
        },
        mergeObject: function t(e, n) {
          for (var i in n) try {
            e[i] = n[i].constructor == Object ? t(e[i], n[i]) : n[i]
          } catch (t) {
            e[i] = n[i]
          }
          return e
        },
        optimizeImage: b,
        getFeaturedImage: function (t, e) {
          e = void 0 !== e ? e : "large";
          var n = b(boostPFSConfig.general.no_image_url, e);
          return t.length > 0 && (n = "object" === m(t[0]) ? b(t[0].src, e) : b(t[0], e)), n
        },
        slugify: function (t) {
          if (null == t || "object" == m(t)) return "";
          if ("string" != typeof t) {
            if ("function" != typeof t.toString) return "";
            t = t.toString()
          }
          t = t.toLowerCase();
          for (var e = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;", n = 0, i = e.length; n < i; n++) t = t.replace(new RegExp(e.charAt(n), "g"), "aaaaaeeeeeiiiiiooooouuuuunc--_---".charAt(n));
          for (var r = "ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž".length, o = 0; o < r; o++) t = t.replace(new RegExp("ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž".charAt(o), "g"), "AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz".charAt(o));
          for (var a = ["AE", "ae", "O", "o", "A", "a"], l = "ÆæØøÅå".length, s = 0; s < l; s++) t = t.replace(new RegExp("ÆæØøÅå".charAt(s), "g"), a[s]);
          return (t = t.replace(/'/g, "").replace(/"/g, "")).replace(/[\s\/]+/g, "-").replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, "-").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
        },
        capitalize: function (t, e, n) {
          n = void 0 !== n && n;
          return (e = void 0 !== e && e) && (t = t.toLowerCase()), n ? t.charAt(0).toUpperCase() + t.slice(1) : t.replace(/(?:^|\s)\S/g, (function (t) {
            return t.toUpperCase()
          }))
        },
        textify: function (t, e) {
          e = void 0 !== e ? e : "-";
          for (var n = t.split(e), i = "", r = 0; r < n.length; r++) i += n[r].charAt(0).toUpperCase() + n[r].slice(1), r < n.length - 1 && (i += " ");
          return i
        },
        stripHtml: k,
        stripScriptTag: function (t) {
          if (t) return t.replace(/<script[^>]*>.*?<\/script>/gi, "")
        },
        truncateByWord: function (t, e, n) {
          return void 0 === n && (n = "..."), t = t.split(" ").length > e ? t.split(" ").splice(0, e).join(" ") + n : t.split(" ").splice(0, e).join(" ")
        },
        removeDecimal: function (t, e) {
          e = void 0 !== e ? e : o.a.getSettingValue("general.decimalDelimiter");
          var n = new RegExp("(\\" + e + "\\d+)+", "gi");
          return t.replace(n, "")
        },
        formatMoney: function (t, e, n) {
          if (void 0 === e) e = a.a.moneyFormat;
          if (void 0 === n) n = !1;
          "string" == typeof t && (t = t.replace(".", ""));
          var i = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            o = e || "${{amount}}";

          function l(t, e) {
            return void 0 === t ? e : t
          }

          function s(t, e, i, r) {
            if (e = l(e, 2), i = l(i, ","), r = l(r, "."), isNaN(t) || null == t) return 0;
            var o = (t = parseFloat(t).toFixed(e)).split("."),
              a = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
              s = o[1] ? r + o[1] : "";
            return 1 == n ? (a + s).replace(/((\,00)|(\.00))$/g, "") : a + s
          }
          switch (o.match(r)[1]) {
          case "amount":
            i = s(t, 2);
            break;
          case "amount_no_decimals":
            i = s(t, 0);
            break;
          case "amount_with_comma_separator":
            i = s(t, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            i = s(t, 0, ".", ",");
            break;
          case "amount_with_space_separator_no_comma":
          default:
            i = s(t, 2)
          }
          return o = o.replace(r, i), v(o)
        },
        moneyWrapper: v,
        formatNumberWithSeparator: function (t, e, n, i, r) {
          isNaN(t) && (t = 0), isNaN(e) && (e = 0), i || (i = "." == n ? "," : ".");
          var o = (t = parseFloat(t).toFixed(e)).toString().split("."),
            a = o[0],
            l = o[1] ? o[1] : "";
          return n && (a = a.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n)), i && l && (l = r && /0+/.test(l) ? "" : i + l), a + l
        },
        getCurrency: S,
        removeCurrencySymbol: function (t) {
          t = r()("<p>" + t + "</p>").text();
          for (var e = S().split(" "), n = 0; n < e.length; n++) t = t.replace(e[n].trim(), "");
          return t.trim()
        },
        isShopifyActiveCurrency: E,
        isEnableShopifyMultipleCurrencies: I,
        roundedPrice: T,
        convertPriceBasedOnActiveCurrency: function (t, e) {
          if (void 0 === e && (e = !0), null === t) return t;
          if (!0 === I()) {
            var n = t * Shopify.currency.rate;
            t = e ? T(n) : n
          }
          return parseFloat(t)
        },
        revertPriceToDefaultCurrency: function (t, e) {
          if (!0 === I()) {
            if (t = T(t), e) {
              var n = O();
              n && (t -= n)
            }
            return (t /= Shopify.currency.rate).toFixed(8)
          }
          return t
        },
        reBuildUrlBaseOnLocale: function (t) {
          t = t.replace("https://", "").replace("http://", "");
          var e = o.a.getSettingValue("general.current_locale"),
            n = o.a.getSettingValue("general.published_locales"),
            i = Object.keys(n);
          if (i.indexOf(e) < 0 || 1 == n[e]) return t;
          var r = t.split("/");
          r.length > 1 && i.length && e.length && (i.indexOf(r[1]) > -1 ? r[1] = e : r.splice(1, 0, e));
          return r.join("/")
        },
        getWindowLocation: function () {
          for (var t = window.location.href.replace(/%3C/g, "&lt;").replace(/%3E/g, "&gt;"), e = [], n = 0; n < t.length; n++) e.push(t.charAt(n));
          var i = e.join("").split("&lt;").join("%3C").split("&gt;").join("%3E"),
            r = "",
            o = i.replace(/#.*$/, "");
          return o.split("?").length > 1 && (r = o.split("?")[1]).length > 0 && (r = "?" + r), {
            pathname: window.location.pathname,
            href: i,
            search: r
          }
        },
        setWindowLocation: function (t) {
          window.location.href = t
        },
        InstantSearch: l,
        isFullWidthMobile: l.isFullWidthMobile,
        isStyle2: l.isStyle2,
        FilterTree: s,
        checkExistFilterOptionParam: s.checkExistFilterOptionParam,
        encodeURIParamValue: s.encodeURIParamValue,
        FilterResult: g,
        buildProductItemUrl: g.buildProductItemUrl,
        removePageParamFromUrl: g.removePageParamFromUrl,
        removeCollectionScopeParamFromUrl: g.removeCollectionScopeParamFromUrl,
        buildToolbarLink: g.buildToolbarLink,
        isDefaultPaginationType: g.isDefaultPaginationType,
        isLoadMorePaginationType: g.isLoadMorePaginationType,
        isInfiniteLoadingPaginationType: g.isInfiniteLoadingPaginationType,
        isLoadPreviousPagePaginationType: g.isLoadPreviousPagePaginationType,
        getSortingList: g.getSortingList,
        getProductMetafield: g.getProductMetafield,
        isNoFilterResult: g.isNoFilterResult
      },
      A = e.a = L
  },
  39: function (t, e, n) {
    "use strict";
    n(14), n(15), n(16), n(36), n(23), n(44), n(10), n(56), n(48), n(11), n(19), n(40), n(46), n(13), n(20), n(57), n(37), n(55), n(38), n(24), n(12), n(103);
    var i = n(0),
      r = n.n(i),
      o = n(3),
      a = n(1),
      l = n(2),
      s = n(7),
      c = n(59),
      u = {},
      p = {},
      f = window.location.pathname,
      h = document.title,
      y = "",
      d = new Map,
      g = new Map,
      m = function () {
        var t = a.a.queryParams,
          e = window.location.protocol + "//" + window.location.hostname + f,
          n = o.a.getWindowLocation().search,
          i = new URLSearchParams(n),
          r = !1,
          s = l.a.getSettingValue("general.urlScheme");
        Object.keys(t).forEach((function (e) {
          var n = t[e];
          if (e.startsWith(a.a.prefix)) {
            var o = d.get(e);
            if (o || (o = e), i.delete(o), Array.isArray(n)) {
              switch (s) {
              case 0:
                break;
              case 2:
                i.set(o, n);
                break;
              case 1:
              default:
                n.forEach((function (t) {
                  i.append(o, t)
                }))
              }
              r = !0
            } else null != n && (i.set(o, n), r = !0)
          } else e == a.a.searchTermKey && "string" == typeof n ? i.set(e, n) : a.a.otherParams.includes(e) && (n == p[e] ? i.delete(e) : i.set(e, n))
        }));
        var c = [],
          u = !0,
          h = !1,
          y = void 0;
        try {
          for (var m, b = i.keys()[Symbol.iterator](); !(u = (m = b.next()).done); u = !0) {
            var v = m.value,
              S = g.get(v);
            S || (S = v), (S.startsWith(a.a.prefix) || a.a.imutableFilterTree.includes(S) || S == a.a.searchTermKey) && (t.hasOwnProperty(S) || c.push(v))
          }
        } catch (t) {
          h = !0, y = t
        } finally {
          try {
            u || null == b.return || b.return()
          } finally {
            if (h) throw y
          }
        }
        c.forEach((function (t) {
          i.delete(t)
        })), a.a.hasFilterOptionParam = r;
        var O = e,
          T = i.toString();
        return T && (2 == s && (T = T.replace(/%2C/g, ",")), O += "?" + T), O
      },
      b = {
        init: function () {
          y = o.a.getWindowLocation().href, p = {
            page: 1,
            limit: l.a.getSettingValue("general.limit"),
            sort: o.a.isSearchPage() ? "best-selling" : a.a.defaultSorting,
            display: l.a.getSettingValue("general.defaultDisplay"),
            tab: l.a.getSettingValue("general.searchPanelDefault")
          }, r()(window).on("popstate", b.onPopState), b.initShortenUrl()
        },
        initShortenUrl: function () {
          var t = l.a.getSettingValue("general.shortenUrlParamList");
          l.a.getSettingValue("general.isShortenUrlParam") && Array.isArray(t) && t.forEach((function (t) {
            if ("string" == typeof t) {
              var e = t.split(":");
              if (2 == e.length) {
                var n = e[0].trim(),
                  i = e[1].trim();
                n && i && (d.set(n, i), g.set(i, n))
              }
            }
          }))
        },
        updateAddressBar: function () {
          if (0 != l.a.getSettingValue("general.urlScheme") && window.history && "function" == typeof window.history.pushState) {
            var t = m(),
              e = JSON.parse(JSON.stringify(a.a.queryParams));
            a.a.queryParams = e, history.pushState({
              param: a.a.queryParams
            }, h, t), y = t;
            var n = new Event("boost-pfs-change-address-bar");
            window.dispatchEvent(n)
          }
        },
        buildAddressBarUrl: m,
        setAddressBarPathAfterFilter: function (t) {
          f = "string" == typeof t && t.startsWith("/") ? t : window.location.pathname
        },
        setWindowTitleAfterFilter: function (t) {
          h = "string" != typeof t || "" == t || t.includes("undefined") || t.includes("null") ? document.title : t
        },
        getHistoryState: function () {
          return u
        },
        onPopState: function (t) {
          u = t.originalEvent.state;
          var e = c.default.instance.filter,
            n = o.a.getWindowLocation().href,
            i = (n.includes("#") || y.includes("#")) && n.split("#")[0] == y;
          e && !i && (o.a.isSearchPage() && r()("." + Class.searchResultPanelItem).length > 0 && r()("." + Class.searchResultPanelItem).first().trigger("click"), e.filterLoadingIcon.setShow(!0), s.default.updateParamsFromUrl(), s.default.getFilterData("history", e.setData.bind(e)))
        },
        shortParamsMap: d,
        longParamMap: g
      };
    e.a = b
  },
  4: function (t, e, n) {
    "use strict";
    e.a = {
      filterTree: "boost-pfs-filter-tree",
      filterTreeVertical: "boost-pfs-filter-tree-v",
      filterTreeHorizontal: "boost-pfs-filter-tree-h",
      filterTreeOpenBody: "boost-pfs-filter-tree-open-body",
      filterTreeMobileButton: "boost-pfs-filter-tree-mobile-button",
      filterTreeMobileOpen: "boost-pfs-filter-tree-mobile-open",
      filterOptionsWrapper: "boost-pfs-filter-options-wrapper",
      filterOption: "boost-pfs-filter-option",
      filterOptionTitle: "boost-pfs-filter-option-title",
      filterOptionContent: "boost-pfs-filter-option-content",
      filterOptionContentInner: "boost-pfs-filter-option-content-inner",
      filterOptionItem: "boost-pfs-filter-option-item",
      filterOptionLabel: "boost-pfs-filter-option-label",
      filterOptionRange: "boost-pfs-filter-option-range",
      filterRefineByWrapper: "boost-pfs-filter-refine-by-wrapper",
      filterRefineBy: "boost-pfs-filter-refine-by",
      filterSelectedItems: "boost-pfs-filter-refine-by-items",
      filterSelectedItemsMobile: "boost-pfs-filter-refine-by-items-mobile",
      filterOptionHidden: "boost-pfs-filter-option-hidden",
      filterOptionOpenList: "boost-pfs-filter-option-open-list",
      filterOptionCloseList: "boost-pfs-filter-option-close-list",
      filterOptionItemList: "boost-pfs-filter-option-item-list",
      filterOptionItemListSingleList: "boost-pfs-filter-option-item-list-single-list",
      filterOptionItemListMultipleList: "boost-pfs-filter-option-item-list-multiple-list",
      filterOptionItemListBox: "boost-pfs-filter-option-item-list-box",
      filterOptionItemListSwatch: "boost-pfs-filter-option-item-list-swatch",
      filterOptionItemListRating: "boost-pfs-filter-option-item-list-rating",
      filterOptionItemListMultiLevelTag: "boost-pfs-filter-option-item-list-multi-level-tag",
      filterOptiontemListMultiLevelCollections: "boost-pfs-filter-option-item-list-multi-level-collections",
      filterOptionItemStar: "boost-pfs-filter-icon-star",
      filterOptionItemStarActive: "boost-pfs-filter-icon-star-active",
      filterHasViewMore: "boost-pfs-filter-has-view-more",
      filterOptionViewMore: "boost-pfs-filter-option-view-more-action",
      filterOptionViewLess: "boost-pfs-filter-option-view-less-action",
      filterOptionViewMoreList: "boost-pfs-filter-view-more-list-action",
      filterHasSearchBox: "boost-pfs-filter-has-searchbox",
      filterOptionShowSearchBox: "boost-pfs-filter-option-show-search-box",
      filterHasScrollbar: "boost-pfs-filter-has-scrollbar",
      filterNoScrollbar: "boost-pfs-filter-no-scrollbar",
      button: "boost-pfs-filter-button",
      clearButton: "boost-pfs-filter-clear",
      clearAllButton: "boost-pfs-filter-clear-all",
      applyButton: "boost-pfs-filter-apply-button",
      applyAllButton: "boost-pfs-filter-apply-all-button",
      closeFilterButton: "boost-pfs-filter-close",
      showResultFilterButton: "boost-pfs-filter-show-result",
      collectionHeader: "boost-pfs-filter-collection-header",
      collectionDescription: "boost-pfs-filter-collection-description",
      collectionImage: "boost-pfs-filter-collection-image",
      collectionHasImage: "boost-pfs-filter-collection-has-image",
      collectionNoImage: "boost-pfs-filter-collection-no-image",
      filterOptionTooltip: "boost-pfs-filter-option-tooltip",
      searchBox: "boost-pfs-search-box",
      searchResultHeader: "boost-pfs-search-result-header",
      searchResultNumber: "boost-pfs-search-result-number",
      searchResultPanels: "boost-pfs-search-result-panel-controls",
      searchResultPanelItem: "boost-pfs-search-result-panel-item",
      searchSuggestion: "boost-pfs-search-suggestion",
      searchSuggestionWrapper: "boost-pfs-search-suggestion-wrapper",
      searchSuggestionHeader: "boost-pfs-search-suggestion-header",
      searchSuggestionGroup: "boost-pfs-search-suggestion-group",
      searchSuggestionItem: "boost-pfs-search-suggestion-item",
      searchSuggestionMobile: "boost-pfs-search-suggestion-mobile",
      searchSuggestionLoading: "boost-pfs-search-suggestion-loading",
      searchSuggestionOpen: "boost-pfs-search-suggestion-open",
      searchSuggestionMobileOpen: "boost-pfs-search-suggestion-mobile-open",
      searchUiAutocompleteItem: "boost-pfs-ui-item",
      searchSuggestionBtnSubmitMobile: "boost-pfs-search-submit-mobile",
      searchSuggestionBtnCloseMobile: "boost-pfs-search-btn-close-suggestion",
      searchSuggestionBtnClearMobile: "boost-pfs-search-btn-clear-suggestion",
      searchSuggestionNoTabIndex: "boost-pfs-search-no-tabindex",
      productLoadMore: "boost-pfs-filter-load-more",
      productWrapLoading: "boost-pfs-filter-product-loading",
      buttonLoadPreviousPageSelector: "boost-pfs-filter-btn-load-previous-page",
      productDisplayType: "boost-pfs-filter-display",
      filterResultItem: "boost-pfs-search-result-list-item",
      filterSkeleton: "boost-pfs-filter-skeleton",
      filterProductSkeleton: "boost-pfs-filter-product-skeleton",
      filterSkeletonText: "boost-pfs-filter-skeleton-text",
      filterSkeletonButton: "boost-pfs-filter-skeleton-button",
      atcForm: "boost-pfs-addtocart-product-form",
      atcAvailable: "boost-pfs-addtocart-available",
      atcSelectOptions: "boost-pfs-addtocart-select-options",
      atcSoldOut: "boost-pfs-addtocart-sold-out",
      adaWrapper: "boost-pfs-ada",
      mobileButtonOpen: "boost-pfs-filter-tree-mobile-button-open",
      mobileDetectiOS: "boost-pfs-filter-mobile-detect-ios",
      hidden: "boost-hidden"
    }
  },
  41: function (t, e, n) {
    "use strict";
    n(14), n(15), n(16), n(26), n(10), n(17), n(18), n(11), n(13), n(12);
    var i = n(0),
      r = n.n(i),
      o = n(9),
      a = n(6),
      l = n(2);
    n(27), n(22);

    function s(t) {
      return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function c(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function u(t, e) {
      return !e || "object" !== s(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function p(t) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function f(t, e) {
      return (f = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var h = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = u(this, p(e).call(this))).data = null, t.totalProduct = null, t.paginationType = "", t.$loadMore = r()(a.a.loadMore), t.settings = {
          limit: l.a.getSettingValue("general.limit"),
          showLoading: l.a.getSettingValue("general.showLoading"),
          showLoadMoreLoading: l.a.getSettingValue("general.showLoadMoreLoading")
        }, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && f(t, e)
      }(e, t), n = e, o = [{
        key: "Type",
        get: function () {
          return {
            DEFAULT: "default",
            LOAD_MORE: "load_more",
            INFINITE: "infinite"
          }
        }
      }], (i = [{
        key: "isRender",
        value: function () {
          return null !== this.data
        }
      }, {
        key: "setData",
        value: function (t) {
          t && (this.data = t), this.totalProduct = this.parent.totalProduct, this.paginationType = l.a.getSettingValue("general.paginationType")
        }
      }, {
        key: "showLoading",
        value: function () {
          this.settings.showLoadMoreLoading && !1 === this.settings.showLoading && this.$loadMore.find(a.a.loadMoreLoading).show()
        }
      }, {
        key: "hideLoading",
        value: function () {
          this.settings.showLoadMoreLoading && this.$loadMore.find(a.a.loadMoreLoading).hide()
        }
      }]) && c(n.prototype, i), o && c(n, o), e
    }(o.a);
    e.a = h
  },
  5: function (t, e, n) {
    "use strict";
    e.a = {
      Status: {
        ACTIVE: "active",
        DISABLED: "disabled"
      },
      FilterType: {
        COLLECTION: "collection",
        VENDOR: "vendor",
        PRODUCT_TYPE: "product_type",
        TITLE: "title",
        PRICE: "price",
        VARIANTS_PRICE: "variants_price",
        PERCENT_SALE: "percent_sale",
        REVIEW_RATINGS: "review_ratings",
        WEIGHT: "weight",
        STOCK: "stock",
        TAG: "tag",
        MULTI_LEVEL_TAG: "multi_level_tag"
      },
      SelectType: {
        SINGLE: "single",
        MULTIPLE: "multiple"
      },
      DisplayType: {
        LIST: "list",
        BOX: "box",
        RANGE: "range",
        SWATCH: "swatch",
        RATING: "rating",
        SUB_CATEGORY: "sub_category",
        MULTI_LEVEL_COLLECTIONS: "multi_level_collections",
        MULTI_LEVEL_TAG: "multi_level_tag"
      },
      ValueType: {
        ALL: "all",
        SPECIFIC: "specific"
      },
      SortType: {
        KEY_ASCENDING: "key-asc",
        KEY_DESCENDING: "key-desc",
        DOC_COUNT_ASCENDING: "doc_count-asc",
        DOC_COUNT_DESCENDING: "doc_count-desc"
      },
      ShowMoreType: {
        NONE: "none",
        SCROLLBAR: "scrollbar",
        VIEWMORE: "viewmore",
        VIEWMORE_SCROLLBAR: "viewmore_scrollbar"
      }
    }
  },
  51: function (t, e, n) {
    "use strict";
    n(48);
    var i = {
      getApiUrl: function (t) {
        var e = boostPFSConfig.api.filterUrl;
        switch (t) {
        case "search":
          e = boostPFSConfig.api.searchUrl;
          break;
        case "suggestion":
          e = boostPFSConfig.api.suggestionUrl;
          break;
        case "analytics":
          e = boostPFSConfig.api.analyticsUrl
        }
        return e
      },
      setApiLocaleParams: function (t) {
        return Settings.general.hasOwnProperty("published_locales") && Object.keys(Settings.general.published_locales).length > 1 && void 0 !== Settings.general.current_locale && (t.locale = Settings.getSettingValue("general.current_locale")), t
      }
    };
    e.a = i
  },
  58: function (t, e, n) {
    "use strict";
    n(14), n(15), n(16), n(26), n(10), n(17), n(18), n(11), n(13), n(12);
    var i = n(0),
      r = n.n(i),
      o = n(41),
      a = n(6),
      l = n(7),
      s = n(1);
    n(22), n(27);

    function c(t) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function u(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function p(t, e) {
      return !e || "object" !== c(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function f(t) {
      return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function h(t, e) {
      return (h = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var y = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = p(this, f(e).call(this))).$element = r()(a.a.pagination), t.$buttomElement = r()(a.a.bottomPagination), t.$productList = r()(a.a.products), t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && h(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {
          return ""
        }
      }, {
        key: "isRender",
        value: function () {
          return null !== this.data
        }
      }, {
        key: "render",
        value: function () {
          r()(a.a.pagination).html(this.compileTemplate())
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element.show(), this.$element.find("a").unbind("click"), this.$element.find("a").on("click", this._onClickEvent.bind(this))
        }
      }, {
        key: "_onClickEvent",
        value: function (t) {
          t.preventDefault(), s.a.internalClick = !0;
          var e = r()(t.currentTarget).attr("href");
          l.default.updateParamsFromUrl(e), l.default.applyFilter("page"), r()("body,html").animate({
            scrollTop: this.$productList.offset().top - 50
          }, 600)
        }
      }]) && u(n.prototype, i), o && u(n, o), e
    }(o.a);
    e.a = y
  },
  59: function (t, e, n) {
    "use strict";
    n.r(e);
    n(14), n(15), n(16), n(36), n(10), n(17), n(18), n(11), n(19), n(13), n(57), n(12);
    var i = n(0),
      r = n.n(i),
      o = n(2),
      a = n(8),
      l = n(1),
      s = n(6),
      c = n(39),
      u = (n(128), n(23), n(34), n(127), n(62), n(24), n(3)),
      p = (n(26), n(48), n(40), n(20), n(38), n(194), n(4)),
      f = n(9),
      h = n(74),
      y = {
        ResultType: {
          ALL_EMPTY: "all_empty",
          TOTAL_PRODUCT: "total_product",
          PREV_TOTAL_PRODUCT: "prev_total_product",
          SUGGESTIONS: "suggestions",
          COLLECTIONS: "collections",
          PRODUCTS: "products",
          PAGES: "pages",
          DID_YOU_MEAN: "did_you_mean",
          REDIRECT: "redirect",
          QUERY: "query",
          SUGGEST_QUERY: "suggest_query",
          EVENT_TYPE: "event_type"
        },
        Mobile: {
          SuggestionType: {
            FULL_SCREEN: "style1",
            STYLE_2: "style2"
          }
        }
      };
    n(150), n(126), n(37);

    function d(t) {
      return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function g(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function m(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function b(t, e) {
      return !e || "object" !== d(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function v(t) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function S(t, e) {
      return (S = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var O = function (t) {
      function e() {
        return g(this, e), b(this, v(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && S(t, e)
      }(e, t), n = e, (i = [{
        key: "_highlightSuggestionResult",
        value: function (t, e) {
          if (o.a.getSettingValue("search.highlightSuggestionResult") && e.length > 1 && t) {
            var n, i = function (t) {
                return new RegExp(t.replace(/([\(\)\{\}\[\]\.\+\-\=\\\/])/g, "\\$&"), "ig")
              },
              r = e.split(" "),
              a = r.length;
            for (n = 0; n < a; n++) {
              var l = i(r[n]),
                s = t.match(l);
              if (null !== s && s.length > 0) {
                var c, u = (s = s.filter((function (t, e) {
                  return s.indexOf(t) == e && "" != t
                }))).length;
                for (c = 0; c < u; c++) s[c].length > 1 && (l = i(s[c]), t = t.replace(l, "<b>" + s[c] + "</b>"))
              }
            }
          }
          return t
        }
      }]) && m(n.prototype, i), r && m(n, r), e
    }(f.a);

    function T(t) {
      return (T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function P(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function w(t, e) {
      return !e || "object" !== T(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function _(t) {
      return (_ = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function C(t, e) {
      return (C = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var k = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = w(this, _(e).call(this))).data = "", t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && C(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedData}}">\n\t\t\t\t<a href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          if (!this.isShow) return "";
          var t = u.a.escape(l.a.currentTerm),
            e = u.a.reBuildUrlBaseOnLocale("/search?" + l.a.searchTermKey + "=" + u.a.encodeURIParamValue(this.data)),
            n = this._highlightSuggestionResult(this.data, t);
          return this.getTemplate().replace(/{{escapedBlockType}}/g, u.a.escape(this.parent.type)).replace(/{{escapedData}}/g, u.a.escape(this.data)).replace(/{{class.searchSuggestionItem}}/g, p.a.searchSuggestionItem).replace(/{{class.searchUiAutocompleteItem}}/g, p.a.searchUiAutocompleteItem).replace(/{{searchLink}}/g, e).replace(/{{highlightedSuggestionResult}}/g, n)
        }
      }, {
        key: "render",
        value: function () {
          if (this.data) {
            this.$element = r()(this.compileTemplate());
            var t = u.a.escape(this.data),
              e = u.a.escape(this.parent.type);
            this.$element.data("ui-autocomplete-item", {
              label: e + ": " + t,
              value: t
            })
          } else this.$element = null
        }
      }, {
        key: "setData",
        value: function (t) {
          this.data = t, this.isShow = !!this.data
        }
      }]) && P(n.prototype, i), o && P(n, o), e
    }(O);

    function E(t) {
      return (E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function I(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function L(t, e) {
      return !e || "object" !== E(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function A(t) {
      return (A = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function F(t, e) {
      return (F = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var R = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = L(this, A(e).call(this))).id = "", t.title = "", t.imageUrl = "", t.url = "", t.sku = "", t.label = "", t.vendor = "", t.isShow = !1, t
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && F(t, e)
      }(e, t), n = e, a = [{
        key: "tempType",
        get: function () {
          return {
            SKU: "sku",
            VENDOR: "vendor",
            IMAGE: "thumb",
            PRICE: "regular_price",
            PRICE_SALE: "sale_price"
          }
        }
      }], (i = [{
        key: "getTemplate",
        value: function (t) {
          switch (t) {
          case e.tempType.IMAGE:
            return '\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-left">\n\t\t\t\t\t\t<img src="{{imageUrl}}" alt="{{escapedTitle}}">\n\t\t\t\t\t</div>\n\t\t\t\t';
          case e.tempType.SKU:
            return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>\n\t\t\t\t';
          case e.tempType.VENDOR:
            return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>\n\t\t\t\t';
          case e.tempType.PRICE:
            return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-price">\n\t\t\t\t\t\t<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t';
          case e.tempType.PRICE_SALE:
            return '\n\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-price">\n\t\t\t\t\t\t<s>{{compareAtPrice}}</s>&nbsp;\n\t\t\t\t\t\t<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>\n\t\t\t\t\t</p>\n\t\t\t\t';
          default:
            return '\n\t\t\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}">\n\t\t\t\t\t\t<a href="{{url}}" {{newTabAttribute}}>\n\t\t\t\t\t\t\t{{itemProductImage}}\n\t\t\t\t\t\t\t<div class="{{class.searchSuggestion}}-right">\n\t\t\t\t\t\t\t\t<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>\n\t\t\t\t\t\t\t\t{{itemProductSku}}\n\t\t\t\t\t\t\t\t{{itemProductVendor}}\n\t\t\t\t\t\t\t\t{{itemProductPrice}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t'
          }
        }
      }, {
        key: "compileTemplate",
        value: function () {
          if (this.isShow) {
            var t = u.a.escape(l.a.currentTerm),
              n = "";
            o.a.getSettingValue("search.showSuggestionProductImage") && this.imageUrl.length && (n = (n = this.getTemplate(e.tempType.IMAGE)).replace(/{{imageUrl}}/g, this.imageUrl));
            var i = this.customizeProductTitle();
            i = this._highlightSuggestionResult(i, t);
            var r = "";
            o.a.getSettingValue("search.showSuggestionProductSku") && this.sku.length && (r = (r = this.getTemplate(e.tempType.SKU)).replace(/{{sku}}/g, this.sku));
            var a = "";
            o.a.getSettingValue("search.showSuggestionProductVendor") && this.vendor.length && (a = (a = this.getTemplate(e.tempType.VENDOR)).replace(/{{vendor}}/g, this.vendor));
            var s = this.compileSuggestionProductPrice(),
              c = o.a.getSettingValue("search.openProductNewTab") ? 'target="_blank"' : "";
            return this.getTemplate().replace(/{{id}}/g, this.id).replace(/{{escapedBlockType}}/g, u.a.escape(this.parent.type)).replace(/{{url}}/g, this.url).replace(/{{newTabAttribute}}/g, c).replace(/{{itemProductImage}}/g, n).replace(/{{title}}/g, i).replace(/{{escapedTitle}}/g, u.a.escape(i)).replace(/{{itemProductSku}}/g, r).replace(/{{itemProductVendor}}/g, a).replace(/{{itemProductPrice}}/, s).replace(/{{class.searchSuggestion}}/g, p.a.searchSuggestion).replace(/{{class.searchSuggestionItem}}/g, p.a.searchSuggestionItem).replace(/{{class.searchUiAutocompleteItem}}/g, p.a.searchUiAutocompleteItem)
          }
          return ""
        }
      }, {
        key: "render",
        value: function () {
          if (this.isShow) {
            this.$element = r()(this.compileTemplate());
            var t = u.a.escape(this.parent.type),
              e = u.a.escape(this.title);
            this.$element.data("ui-autocomplete-item", {
              label: t + ": " + e,
              value: e
            })
          } else this.$element = null
        }
      }, {
        key: "setData",
        value: function (t) {
          t ? (this.data = t, this.id = t.id, this.title = t.title, this.imageUrl = t.images_info.length > 0 ? u.a.optimizeImage(t.images_info[0].src, "200x") : boostPFSConfig.general.no_image_url, this.url = u.a.buildProductItemUrl(t, !1), this.sku = t.skus && t.skus.length > 0 ? t.skus[0] : "", this.label = t.label, this.vendor = t.vendor, this.isShow = !0) : (this.data = null, this.id = "", this.title = "", this.imageUrl = "", this.url = "", this.sku = "", this.label = "", this.vendor = "", this.isShow = !1)
        }
      }, {
        key: "compileSuggestionProductPrice",
        value: function () {
          this.prepareSuggestionProductPriceData();
          var t = this.data.compare_at_price_min > this.data.price_min,
            n = u.a.formatMoney(this.data.price_min),
            i = "";
          this.data && this.data.compare_at_price_min && (i = u.a.formatMoney(this.data.compare_at_price_min), o.a.getSettingValue("search.removePriceDecimal") && (n = u.a.removeDecimal(n), i = u.a.removeDecimal(i)));
          var r = "";
          return o.a.getSettingValue("search.showSuggestionProductPrice") && (r = t && o.a.getSettingValue("search.showSuggestionProductSalePrice") ? this.getTemplate(e.tempType.PRICE_SALE) : this.getTemplate(e.tempType.PRICE)), r.replace(/{{regularPrice}}/g, n).replace(/{{compareAtPrice}}/g, i)
        }
      }, {
        key: "customizeProductTitle",
        value: function () {
          return this.title
        }
      }, {
        key: "prepareSuggestionProductPriceData",
        value: function () {
          var t = this,
            e = o.a.getSettingValue("general.currencies");
          if (void 0 !== e && e.length > 1) {
            var n = o.a.getSettingValue("general.current_currency").toLowerCase().trim();
            ["price_min", "price_max", "compare_at_price_min", "compare_at_price_max"].forEach((function (e) {
              var i = e + "_" + n;
              void 0 !== t.data[i] && (t.data[e] = t.data[i])
            }))
          }
        }
      }]) && I(n.prototype, i), a && I(n, a), e
    }(O);

    function j(t) {
      return (j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function $(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function B(t, e) {
      return !e || "object" !== j(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function x(t) {
      return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function M(t, e) {
      return (M = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var D = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = B(this, x(e).call(this))).data = "", t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && M(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}">\n\t\t\t\t<a href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          if (!this.isShow) return "";
          this.searchTerm = u.a.escape(l.a.currentTerm);
          var t = u.a.reBuildUrlBaseOnLocale("/collections/" + this.data.handle),
            e = this._highlightSuggestionResult(this.data.title, this.searchTerm);
          return this.getTemplate().replace(/{{escapedBlockType}}/g, u.a.escape(this.parent.type)).replace(/{{escapedDataTitle}}/g, u.a.escape(this.data.title)).replace(/{{escapedDataId}}/g, u.a.escape(this.data.id)).replace(/{{class.searchSuggestionItem}}/g, p.a.searchSuggestionItem).replace(/{{class.searchUiAutocompleteItem}}/g, p.a.searchUiAutocompleteItem).replace(/{{searchLink}}/g, t).replace(/{{highlightedSuggestionResult}}/g, e)
        }
      }, {
        key: "render",
        value: function () {
          if (this.data) {
            this.$element = r()(this.compileTemplate());
            var t = u.a.escape(this.data.title),
              e = u.a.escape(this.parent.type) + ": " + t;
            this.$element.data("ui-autocomplete-item", {
              label: e,
              value: t
            })
          } else this.$element = null
        }
      }, {
        key: "setData",
        value: function (t) {
          this.data = t, this.isShow = !!this.data
        }
      }]) && $(n.prototype, i), o && $(n, o), e
    }(O);

    function V(t) {
      return (V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function N(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function U(t, e) {
      return !e || "object" !== V(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function q(t) {
      return (q = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function H(t, e) {
      return (H = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var W = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = U(this, q(e).call(this))).data = "", t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && H(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}">\n\t\t\t\t<a href="{{searchLink}}">{{highlightedSuggestionResult}}</a>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          if (!this.isShow) return "";
          var t = u.a.escape(l.a.currentTerm),
            e = u.a.reBuildUrlBaseOnLocale(this.data.url),
            n = this._highlightSuggestionResult(this.data.title, t);
          return this.getTemplate().replace(/{{escapedBlockType}}/g, u.a.escape(this.parent.type)).replace(/{{escapedDataTitle}}/g, u.a.escape(this.data.title)).replace(/{{class.searchSuggestionItem}}/g, p.a.searchSuggestionItem).replace(/{{class.searchUiAutocompleteItem}}/g, p.a.searchUiAutocompleteItem).replace(/{{searchLink}}/g, e).replace(/{{highlightedSuggestionResult}}/g, n)
        }
      }, {
        key: "render",
        value: function () {
          if (this.data) {
            this.$element = r()(this.compileTemplate());
            var t = u.a.escape(this.data.title),
              e = u.a.escape(this.parent.type);
            this.$element.data("ui-autocomplete-item", {
              label: e + ": " + t,
              value: t
            })
          } else this.$element = null
        }
      }, {
        key: "setData",
        value: function (t) {
          this.data = t, this.isShow = !!this.data
        }
      }]) && N(n.prototype, i), o && N(n, o), e
    }(O);

    function G(t) {
      return (G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function z(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function K(t, e) {
      return !e || "object" !== G(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Y(t) {
      return (Y = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Q(t, e) {
      return (Q = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var J = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = K(this, Y(e).call(this))).data = "", t.$element = null, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Q(t, e)
      }(e, t), n = e, o = [{
        key: "tempType",
        get: function () {
          return {
            LINK: "link",
            SEPARATOR: "separator",
            STRONG: "strong",
            P: "p"
          }
        }
      }], (i = [{
        key: "getTemplate",
        value: function (t) {
          switch (t) {
          case e.tempType.LINK:
            return '\n\t\t\t\t\t<a href="{{url}}">{{content}}</a>\n\t\t\t\t';
          case e.tempType.SEPARATOR:
            return "\n\t\t\t\t\t<span>,</span>&nbsp;\n\t\t\t\t";
          case e.tempType.STRONG:
            return "\n\t\t\t\t\t<strong>{{content}}</strong>\n\t\t\t\t";
          case e.tempType.P:
            return "\n\t\t\t\t\t<p>{{content}}</p>\n\t\t\t\t";
          default:
            return '\n\t\t\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</li>\n\t\t\t\t'
          }
        }
      }, {
        key: "compileTemplate",
        value: function () {
          var t = this;
          if (this.isShow) {
            var n = "";
            "" != this.dymList && this.dymList.length > 0 && this.dymList.forEach((function (i, r) {
              var o = "/search?" + l.a.searchTermKey + "=" + u.a.encodeURIParamValue(i);
              n += t.getTemplate(e.tempType.LINK).replace(/{{url}}/g, o).replace(/{{content}}/g, i), r < t.dymList.length - 1 && (n += t.getTemplate(e.tempType.SEPARATOR))
            }));
            var i = "";
            if (this.suggestQuery != l.a.currentTerm) {
              if (0 == this.totalProduct) {
                var r = this.getTemplate(e.tempType.STRONG).replace(/{{content}}/g, l.a.currentTerm);
                i += "<p>" + a.a.error.noSuggestionProducts.replace(/{{ terms }}/g, r) + "</p>"
              }
              if ("" != this.suggestQuery) {
                var o = "/search?" + l.a.searchTermKey + "=" + u.a.encodeURIParamValue(this.suggestQuery),
                  s = this.getTemplate(e.tempType.LINK).replace(/{{url}}/g, o).replace(/{{content}}/g, this.suggestQuery),
                  c = a.a.suggestion.suggestQuery.replace(/{{ terms }}/g, s);
                i += this.getTemplate(e.tempType.P).replace(/{{content}}/g, c)
              }
              "" != n && (i += this.getTemplate(e.tempType.P).replace(/{{content}}/g, a.a.suggestion.didYouMean.replace(/{{ terms }}/g, n)))
            }
            return this.getTemplate().replace(/{{dymContent}}/g, i).replace(/{{class.searchSuggestion}}/g, p.a.searchSuggestion).replace(/{{class.searchSuggestionItem}}/g, p.a.searchSuggestionItem)
          }
          return ""
        }
      }, {
        key: "render",
        value: function () {
          this.isShow ? this.$element = r()(this.compileTemplate()) : this.$element = null
        }
      }, {
        key: "setData",
        value: function (t) {
          if (this.data = t, this.isShow = !1, t) {
            this.productData = u.a.getValueInObjectArray(y.ResultType.PRODUCTS, this.data), this.suggestQuery = u.a.getValueInObjectArray(y.ResultType.SUGGEST_QUERY, this.data);
            var e = u.a.getValueInObjectArray(y.ResultType.TOTAL_PRODUCT, this.data),
              n = u.a.getValueInObjectArray(y.ResultType.PREV_TOTAL_PRODUCT, this.data);
            this.totalProduct = "" !== n && e > 0 ? n : e, this.dymList = u.a.getValueInObjectArray(y.ResultType.DID_YOU_MEAN, this.data), this.dymList && this.dymList.length > 0 && (this.isShow = !0)
          } else this.productData = [], this.suggestQuery = "", this.totalProduct = 0, this.prevTotalProduct = "", this.dymList = ""
        }
      }]) && z(n.prototype, i), o && z(n, o), e
    }(f.a);

    function Z(t) {
      return (Z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function X(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function tt(t, e) {
      return !e || "object" !== Z(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function et(t) {
      return (et = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function nt(t, e) {
      return (nt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var it = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = tt(this, et(e).call(this))).type = t.type, n.status = t.status, n.maxSuggesionItems = t.number, n.label = t.label, n.notFoundLabel = t.label, n.isShow = !1, n.isShowDYM = !1, n.type && n.type === y.ResultType.PRODUCTS && (n.blockDym = new J), n.settings = {
          suggesionMaxItems: o.a.getSettingValue("search.suggesionMaxItems")
        }, n
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && nt(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          switch (this.type) {
          case y.ResultType.SUGGESTIONS:
            this.maxSuggesionItems = this.settings.suggesionMaxItems;
            for (var t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new k);
            break;
          case y.ResultType.PRODUCTS:
            for (this.maxSuggesionItems = this.settings.suggesionMaxItems, t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new R);
            break;
          case y.ResultType.COLLECTIONS:
            for (t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new D);
            break;
          case y.ResultType.PAGES:
            for (t = 0; t < this.maxSuggesionItems; t++) this.addComponent(new W)
          }
        }
      }, {
        key: "getTemplate",
        value: function (t) {
          switch (t) {
          case "dym":
            return '\n\t\t\t\t\t<li class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</li>\n\t\t\t\t';
          default:
            return '\n\t\t\t\t\t<li class="{{class.searchSuggestionGroup}}" data-group="{{type}}" aria-label="{{label}}">\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}">{{label}}</li>\n\t\t\t\t\t\t\t{{resultItems}}\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</li>\n\t\t\t\t'
          }
        }
      }, {
        key: "compileTemplate",
        value: function () {
          if (!("active" == this.status && this.isShow || this._isShowDYM())) return "";
          var t = this.isAllEmpty ? this.notFoundLabel : this.label;
          return this.getTemplate().replace(/{{type}}/g, this.type).replace(/{{label}}/g, t).replace(/{{class.searchSuggestionHeader}}/g, p.a.searchSuggestionHeader).replace(/{{class.searchSuggestionGroup}}/g, p.a.searchSuggestionGroup).replace(/{{resultItems}}/g, "")
        }
      }, {
        key: "render",
        value: function () {
          var t = this;
          this.$element = r()(this.compileTemplate()), this.type && this.type === y.ResultType.PRODUCTS && (this.blockDym.render(), this.blockDym.$element && (this.$element = r()(this.compileTemplate()), this.$element.find("> ul").append(this.blockDym.$element))), this.children.forEach((function (e) {
            e.$element && t.$element.find("> ul").append(e.$element)
          }))
        }
      }, {
        key: "_isShowDYM",
        value: function () {
          return this.isShowDYM && this.type == y.ResultType.PRODUCTS
        }
      }, {
        key: "setData",
        value: function (t, e) {
          this.data = t, this.isAllEmpty = e, t.hasOwnProperty("notFoundLabel") && (this.notFoundLabel = t.notFoundLabel), this.children.forEach((function (e, n) {
            t && t.length > n ? e.setData(t[n]) : e.setData(null)
          })), this.blockDym && (this.blockDym.setData(this.parent.data), this.isShowDYM = this.blockDym.isShow), this.isShow = t && t.length > 0
        }
      }]) && X(n.prototype, i), a && X(n, a), e
    }(f.a);

    function rt(t) {
      return (rt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ot(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function at(t, e) {
      return !e || "object" !== rt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function lt(t) {
      return (lt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function st(t, e) {
      return (st = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ct = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = at(this, lt(e).call(this))).data = "", t.$element = null, t
      }
      var n, i, s;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && st(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.searchSuggestionHeader}}-view-all {{class.searchSuggestionHeader}}" aria-label="View All">\n\t\t\t\t<a href="{{viewAllUrl}}">{{label.suggestion.viewAll}}</a>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          if ("" !== u.a.getValueInObjectArray("suggest_query", this.data)) return "";
          var t = u.a.getValueInObjectArray("total_product", this.data),
            e = u.a.getValueInObjectArray("suggest_total_product", this.data);
          "" !== e && (t = e);
          var n = o.a.getSettingValue("search.suggestionBlocks"),
            i = u.a.getValueInObjectArray("products", n, "type", "number");
          if (0 == t || t <= i) return "";
          var r = u.a.reBuildUrlBaseOnLocale("/search?" + l.a.searchTermKey + "=" + u.a.encodeURIParamValue(l.a.currentTerm));
          return this.getTemplate().replace(/{{class.searchSuggestionHeader}}/g, p.a.searchSuggestionHeader).replace(/{{label.suggestion.viewAll}}/g, a.a.suggestion.viewAll).replace(/{{ count }}/g, t).replace(/{{viewAllUrl}}/g, r)
        }
      }, {
        key: "render",
        value: function () {
          this.$element = r()(this.compileTemplate())
        }
      }, {
        key: "setData",
        value: function (t) {
          this.data = t || null
        }
      }]) && ot(n.prototype, i), s && ot(n, s), e
    }(f.a);

    function ut(t) {
      return (ut = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function pt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ft(t, e) {
      return !e || "object" !== ut(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ht(t) {
      return (ht = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function yt(t, e) {
      return (yt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var dt = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = ft(this, ht(e).call(this))).$element = null, t
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && yt(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.searchSuggestionLoading}}">\n\t\t\t\t<ul>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div class="{{class.searchSuggestionLoading}}-img"></div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div class="{{class.searchSuggestionLoading}}-img"></div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li>\n\t\t\t\t\t\t<div class="{{class.searchSuggestionLoading}}-img"></div>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.searchSuggestionLoading}}/g, p.a.searchSuggestionLoading)
        }
      }, {
        key: "isRender",
        value: function () {
          return o.a.getSettingValue("search.showSuggestionLoading")
        }
      }, {
        key: "render",
        value: function () {
          this.$element = r()(this.compileTemplate())
        }
      }]) && pt(n.prototype, i), a && pt(n, a), e
    }(f.a);

    function gt(t) {
      return (gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function mt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function bt(t, e) {
      return !e || "object" !== gt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function vt(t) {
      return (vt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function St(t, e) {
      return (St = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ot = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = bt(this, vt(e).call(this))).$element = null, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && St(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.searchSuggestion}}-no-result {{class.searchSuggestionItem}}" data-label="No Results: {{searchTerm}}" data-value="{{searchTerm}}" aria-label="No Results">\n\t\t\t\t<span>{{noResultLabel}}</span>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          var t = u.a.escape(l.a.currentTerm),
            e = a.a.error.noSuggestionResult.replace(/{{ terms }}/g, "<strong>" + t + "</strong>");
          return this.getTemplate().replace(/{{class.searchSuggestion}}/g, p.a.searchSuggestion).replace(/{{class.searchSuggestionItem}}/g, p.a.searchSuggestionItem).replace(/{{searchTerm}}/g, t).replace(/{{noResultLabel}}/g, e)
        }
      }, {
        key: "render",
        value: function () {
          this.hasRedirect ? this.$element = null : this.$element = r()(this.compileTemplate())
        }
      }, {
        key: "setData",
        value: function (t) {
          t ? (this.data = t, this.hasRedirect = u.a.getValueInObjectArray(y.ResultType.REDIRECT, this.data)) : (this.data = null, this.hasRedirect = !1)
        }
      }]) && mt(n.prototype, i), o && mt(n, o), e
    }(f.a);

    function Tt(t) {
      return (Tt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Pt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function wt(t, e) {
      return !e || "object" !== Tt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function _t(t) {
      return (_t = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ct(t, e) {
      return (Ct = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var kt = function (t) {
      function e(t, n) {
        var i;
        ! function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = wt(this, _t(e).call(this))).searchInputId = t, i.isLoading = !1, i.isFirstLoad = !0, i.blocks = [], i.loadingBlock = null;
        var a = "." + p.a.searchSuggestionWrapper + '[data-search-box-id="' + i.searchInputId + '"]';
        return i.selector = {
          wrapper: a,
          popover: a + " ." + p.a.searchSuggestion + "-popover",
          loading: a + " ." + p.a.searchSuggestion + "-loading"
        }, i.$scriptInstantSearchNotFoundJson = r()("#boost-pfs-instant-search-products-not-found-json"), i.$searchInputElement = n, i.$instantSearchResult = null, i.$wrapper = null, i.$popoverElement = null, i.$loadingElement = null, i.suggestionDirection = i._getSuggestionDirection(), i.position = "", i.settings = {
          suggestionNoResult: o.a.getSettingValue("search.suggestionNoResult")
        }, i
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ct(t, e)
      }(e, t), n = e, a = [{
        key: "isActive",
        value: function () {
          return !0
        }
      }], (i = [{
        key: "init",
        value: function () {
          var t = this;
          this.loadingBlock = new dt, this.addComponent(this.loadingBlock), this.blockSettings = o.a.getSettingValue("search.suggestionBlocks"), this._applyFilterBlockSettings(), this.blockSettings.forEach((function (e) {
            var n = new it(e);
            t.addComponent(n), t.blocks.push(n)
          }));
          var e = new ct;
          this.addComponent(e), this.blockViewAll = e;
          var n = new Ot;
          this.addComponent(n), this.blockEmpty = n
        }
      }, {
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<div class="{{class.searchSuggestionWrapper}}" data-search-box-id="{{searchInputId}}">\n\t\t\t\t<div class="{{class.searchSuggestion}}-popover" data-direction="{{suggestionDirection}}"></div>\n\t\t\t</div>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{searchInputId}}/g, this.searchInputId).replace(/{{suggestionDirection}}/g, this.suggestionDirection).replace(/{{class.searchSuggestionWrapper}}/g, p.a.searchSuggestionWrapper).replace(/{{class.searchSuggestion}}/g, p.a.searchSuggestion)
        }
      }, {
        key: "_applyFilterBlockSettings",
        value: function () {}
      }, {
        key: "render",
        value: function () {
          if (this.isFirstLoad) {
            var t = this.compileTemplate();
            this.appendToSelector = "body", this._applyFilterAutocompleteAppendElement(), r()(this.appendToSelector).append(t), this.$wrapper = r()(this.selector.wrapper), this.$popoverElement = r()(this.selector.popover), this.isFirstLoad = !1
          } else this.$instantSearchResult.siblings().show(), this.isLoading ? (this._renderSuggestionLoading(), this._renderWrapper()) : (this._renderWrapper(), this._renderSuggestion())
        }
      }, {
        key: "_applyFilterAutocompleteAppendElement",
        value: function () {}
      }, {
        key: "_renderWrapper",
        value: function () {
          var t = u.a.InstantSearch.isFullWidthMobile() ? p.a.searchSuggestionMobile : "";
          "" !== t && this.$wrapper.addClass(t);
          var e = this._setSuggestionPosition();
          e.setSuggetionPosition(), e.setSuggetionPopoverPosition();
          var n = "";
          n = "auto" == o.a.getSettingValue("search.suggestionWidth") || u.a.isMobile() ? this.$searchInputElement.outerWidth() : o.a.getSettingValue("search.suggestionWidth"), this.$wrapper.outerWidth(n)
        }
      }, {
        key: "_setSuggestionPosition",
        value: function () {
          var t = this,
            e = u.a.InstantSearch.isFullWidthMobile() ? "top" : "top+12";
          if ("left" == this.suggestionDirection) {
            this.$wrapper.position({
              my: "left " + e,
              at: "left bottom",
              of : this.$searchInputElement[0]
            });
            var n = function () {
                t.$instantSearchResult.position({
                  my: "left " + e,
                  at: "left bottom",
                  of : t.$searchInputElement[0]
                })
              },
              i = function () {
                t.$popoverElement.position({
                  my: "left+20 top-8" + e,
                  at: "left bottom",
                  of : t.$searchInputElement[0]
                })
              }
          } else this.$wrapper.position({
            my: "right " + e,
            at: "right bottom",
            of : this.$searchInputElement[0]
          }), n = function () {
            t.$instantSearchResult.position({
              my: "right " + e,
              at: "right bottom",
              of : t.$searchInputElement[0]
            })
          }, i = function () {
            t.$popoverElement.position({
              my: "right-20 top-8",
              at: "right bottom",
              of : t.$searchInputElement[0]
            })
          };
          return {
            setSuggetionPosition: n,
            setSuggetionPopoverPosition: i
          }
        }
      }, {
        key: "_renderSuggestion",
        value: function () {
          if (this.$instantSearchResult && this.$instantSearchResult.attr("data-search-box", this.id), this.data) {
            var t = [];
            u.a.getValueInObjectArray(y.ResultType.ALL_EMPTY, this.data) ? this.blockEmpty.$element ? (t.push(this.blockEmpty.$element), this.blocks.forEach((function (e) {
              t.push(e.$element)
            }))) : this.$wrapper.hide() : (this.blocks.forEach((function (e) {
              t.push(e.$element)
            })), t.push(this.blockViewAll.$element)), this.$instantSearchResult.append(t)
          }
        }
      }, {
        key: "_renderSuggestionLoading",
        value: function () {
          this.loadingBlock.$element && !r()(this.selector.loading).length && (this.$instantSearchResult.children().hide(), this.$instantSearchResult.prepend(this.loadingBlock.$element), this.$loadingElement = r()(this.selector.loading), this.$wrapper.addClass(p.a.searchSuggestionOpen), this.$instantSearchResult.show(), this.$loadingElement.show())
        }
      }, {
        key: "_getSuggestionDirection",
        value: function () {
          var t = o.a.getSettingValue("search.suggestionPosition");
          if ("" != t) return t;
          var e = r()(window).width() / 2;
          return this.$searchInputElement.offset().left < e ? "left" : "right"
        }
      }, {
        key: "setData",
        value: function (t, e, n) {
          var i = this;
          if (this.$instantSearchResult = t, this.data = e, this.isLoading = n, this.data) {
            var r = u.a.getValueInObjectArray(y.ResultType.ALL_EMPTY, this.data),
              o = [];
            this.$scriptInstantSearchNotFoundJson.length && (o = JSON.parse(this.$scriptInstantSearchNotFoundJson.html())), this.blocks.forEach((function (t) {
              var e = u.a.getValueInObjectArray(t.type, i.data);
              r && (t.type == y.ResultType.PRODUCTS && o.hasOwnProperty("products") && i.settings.suggestionNoResult.products.status ? (i._preparePopularProducts(o.products), e = o.products, t.notFoundLabel = i.settings.suggestionNoResult.products.label) : t.type == y.ResultType.SUGGESTIONS && o.hasOwnProperty("search_terms") && i.settings.suggestionNoResult.search_terms.status && (e = o.search_terms, t.notFoundLabel = i.settings.suggestionNoResult.search_terms.label)), t.setData(e, r)
            })), this.blockEmpty.setData(this.data), this.blockViewAll.setData(this.data)
          }
        }
      }, {
        key: "_preparePopularProducts",
        value: function (t) {
          return t.forEach((function (t) {
            var e = [];
            t.media.forEach((function (t) {
              "image" == t.media_type && e.push({
                id: t.id,
                position: t.position,
                src: t.src,
                width: t.width,
                height: t.height
              })
            })), t.images_info = e, t.price /= 100, t.price_min /= 100, t.price_max /= 100, t.compare_at_price /= 100, t.compare_at_price_min /= 100, t.compare_at_price_max /= 100
          })), t
        }
      }]) && Pt(n.prototype, i), a && Pt(n, a), e
    }(f.a);
    n(198), n(73);

    function Et(t) {
      return (Et = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function It(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Lt(t, e) {
      return !e || "object" !== Et(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function At(t) {
      return (At = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ft(t, e) {
      return (Ft = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Rt = function (t) {
      function e(t, n) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), Lt(this, At(e).call(this, t, n))
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ft(t, e)
      }(e, t), n = e, a = [{
        key: "isActive",
        value: function () {
          return !u.a.isMobile() && "style2" === o.a.getSettingValue("search.suggestionStyle")
        }
      }], (i = [{
        key: "_applyFilterBlockSettings",
        value: function () {
          if (this.blockSettings[0].type !== y.ResultType.PRODUCTS) {
            var t = this.blockSettings.findIndex((function (t) {
                return t.type == y.ResultType.PRODUCTS
              })),
              e = this.blockSettings[t];
            this.blockSettings.splice(t, 1), o.a.getSettingValue("search.suggestionStyle2ReverseProductBlock") ? this.blockSettings.push(e) : this.blockSettings.unshift(e)
          }
        }
      }, {
        key: "_applyFilterAutocompleteAppendElement",
        value: function (t) {
          this.appendToSelector = o.a.getSettingValue("search.suggestionStyle2MainContainerSelector") || "header:first"
        }
      }, {
        key: "_renderWrapper",
        value: function () {
          var t = u.a.InstantSearch.isFullWidthMobile() ? p.a.searchSuggestionMobile : "";
          if ("" !== t && this.$wrapper.addClass(t), this.$wrapper.length) {
            var e = p.a.searchSuggestionWrapper + "-" + o.a.getSettingValue("search.suggestionStyle");
            this.$wrapper.addClass(e).addClass(e + "-width-fullwidth").addClass(p.a.searchSuggestion + "-products-per-row-" + o.a.getSettingValue("search.suggestionStyle2ProductPerRow")).addClass(p.a.searchSuggestion + "-reverse-product-block-" + o.a.getSettingValue("search.suggestionStyle2ReverseProductBlock"))
          }
          var n = this._setSuggestionPosition();
          n.setSuggetionPosition(), n.setSuggetionPopoverPosition(), r()(window).resize((function () {
            n.setSuggetionPopoverPosition()
          }))
        }
      }]) && It(n.prototype, i), a && It(n, a), e
    }(kt);

    function jt(t) {
      return (jt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function $t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Bt(t, e) {
      return !e || "object" !== jt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function xt(t) {
      return (xt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Mt(t, e) {
      return (Mt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Dt = function (t) {
        function e() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (t = Bt(this, xt(e).call(this))).data = "", t.isBoundEvents = !1, t.isOpen = !1, t.inputMobileId = s.a.searchBoxMobile.substr(1), t.searchBox = null, t.selector = {
            searchInput: s.a.searchBoxMobile,
            clearButton: "." + p.a.searchSuggestionBtnClearMobile,
            closebutton: "." + p.a.searchSuggestionBtnCloseMobile,
            submitButton: "." + p.a.searchSuggestionBtnSubmitMobile,
            topPanel: "." + p.a.searchSuggestion + "-mobile-top-panel",
            overlay: "." + p.a.searchSuggestion + "-mobile-overlay",
            searchInputs: 'input[name="' + o.a.getSettingValue("search.termKey") + '"]'
          }, t
        }
        var n, i, c;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Mt(t, e)
        }(e, t), n = e, c = [{
          key: "isActive",
          value: function () {
            return !0
          }
        }, {
          key: "tempType",
          get: function () {
            return {
              SEARCH_BTN: "search_btn",
              DEFAULT: "default"
            }
          }
        }], (i = [{
          key: "getTemplate",
          value: function (t) {
            switch (t) {
            case e.tempType.SEARCH_BTN:
              return '\n\t\t\t\t\t<a href="javascript:;" class="{{class.searchSuggestionBtnSubmitMobile}}"><span>Submit</span></a>\n\t\t\t\t';
            default:
              return '\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-mobile-overlay"></div>\n\t\t\t\t\t<div class="{{class.searchSuggestion}}-mobile-top-panel">\n\t\t\t\t\t\t<form action="/search" method="get">\n\t\t\t\t\t\t\t<button type="button" class="{{class.searchSuggestionBtnCloseMobile}}"><-</button>\n\t\t\t\t\t\t\t{{btnSearch}}\n\t\t\t\t\t\t\t<input type="text" name="{{searchTermKey}}" placeholder="{{searchBoxPlaceholder}}" id="{{searchId}}" />\n\t\t\t\t\t\t\t<button type="button" class="{{class.searchSuggestionBtnClearMobile}}">X</button>\n\t\t\t\t\t\t</form>\n\t\t\t\t\t</div>\n\t\t\t\t'
            }
          }
        }, {
          key: "compileTemplate",
          value: function () {
            var t = "";
            return o.a.getSettingValue("search.showSearchBtnMobile") && (t = this.getTemplate(e.tempType.SEARCH_BTN)), this.getTemplate().replace(/{{btnSearch}}/g, t).replace(/{{searchTermKey}}/g, o.a.getSettingValue("search.termKey")).replace(/{{searchBoxPlaceholder}}/g, a.a.suggestion.searchBoxPlaceholder).replace(/{{searchId}}/g, this.inputMobileId).replace(/{{class.searchSuggestion}}/g, p.a.searchSuggestion).replace(/{{class.searchSuggestionBtnSubmitMobile}}/g, p.a.searchSuggestionBtnSubmitMobile).replace(/{{class.searchSuggestionBtnCloseMobile}}/g, p.a.searchSuggestionBtnCloseMobile).replace(/{{class.searchSuggestionBtnClearMobile}}/g, p.a.searchSuggestionBtnClearMobile)
          }
        }, {
          key: "render",
          value: function () {
            r()("body").append(this.compileTemplate())
          }
        }, {
          key: "isBindEvents",
          value: function () {
            return !this.isBoundEvents
          }
        }, {
          key: "bindEvents",
          value: function () {
            this.$searchInput = r()(this.selector.searchInput), this.$clearButtonElement = r()(this.selector.clearButton), this.$closebuttonElement = r()(this.selector.closebutton), this.$submitButtonElement = r()(this.selector.submitButton), this.$topPanelElement = r()(this.selector.topPanel), this.$overlayElement = r()(this.selector.overlay), this.searchBox = new Jt(this.inputMobileId, this.$searchInput), this.searchBox.refresh(), this.$closebuttonElement.on("click", this.closeInstantSearchMobile.bind(this, !0)), this.$clearButtonElement.on("click", this.clearInstantSearchMobile.bind(this)), this.$searchInputs = r()(this.selector.searchInputs), this.$searchInputs.on("click", this._onClickSearchBox.bind(this)).on("focus", this._onFocusSearchBox.bind(this)).on("keyup", this._onTypeSearchBoxEvent.bind(this)), this.$targetInput = null, this.isBoundEvents = !0
          }
        }, {
          key: "_onClickSearchBox",
          value: function (t) {
            u.a.isFullWidthMobile() && (this.$targetInput && "" !== this.$targetInput.val() && this.$searchInputs.val(this.$targetInput.val()), this.$searchInput && "" !== this.$searchInput.val() && this.openSuggestionMobile())
          }
        }, {
          key: "_onFocusSearchBox",
          value: function (t) {
            u.a.isFullWidthMobile() && (r()(t.target).is(this.$searchInput) || (this.$targetInput = r()(t.target), this.showSearchBoxMobile(), this.$searchInput.trigger("click")))
          }
        }, {
          key: "_onTypeSearchBoxEvent",
          value: function (t) {
            u.a.InstantSearch.isFullWidthMobile() && (this.searchBox.instantSearchResult.$wrapper.show(), "" == t.target.value ? (this.closeInstantSearchMobile(), this.$clearButtonElement.hide()) : this.$clearButtonElement.show())
          }
        }, {
          key: "showSearchBoxMobile",
          value: function () {
            var t = this;
            this.isOpen = !0, this.onClickOutsideSuggestionMobileEvent(), this.scrollSuggestionMobileEvent(), "" == this.$searchInput.val() ? this.$clearButtonElement.hide() : this.$clearButtonElement.show(), this.$searchInput.is(":focus") || (this.$topPanelElement.show(), this.$overlayElement.show(), r()("[tabindex=-1]").removeAttr("tabindex").addClass(p.a.searchSuggestionNoTabIndex), u.a.isMobile() && r()("[data-open=true]").length > 0 && r()("[data-open=true]").attr("data-open", !1), setTimeout((function () {
              t.$searchInput.focus()
            }), 100), this.afterShowSearchBoxMobile())
          }
        }, {
          key: "closeInstantSearchMobile",
          value: function (t) {
            this.$searchInput.autocomplete("close"), this.searchBox.instantSearchResult.$wrapper.hide(), (t = void 0 !== t && t) && (this.$topPanelElement.hide(), this.$overlayElement.hide()), this._setValueAllSearchBoxes(), r()("." + p.a.searchSuggestionNoTabIndex).attr("tabindex", -1), r()("body").hasClass(p.a.searchSuggestionMobileOpen) && r()("body").removeClass(p.a.searchSuggestionMobileOpen), this.afterCloseInstantSearchMobile(t)
          }
        }, {
          key: "clearInstantSearchMobile",
          value: function () {
            this.$clearButtonElement.hide(), l.a.currentTerm = "", this._setValueAllSearchBoxes(), this.closeInstantSearchMobile(), this.$searchInput.focus()
          }
        }, {
          key: "afterCloseInstantSearchMobile",
          value: function (t) {}
        }, {
          key: "_setValueAllSearchBoxes",
          value: function (t) {
            t = void 0 !== t ? searchTerm : l.a.currentTerm, this.$searchInputs.val(t)
          }
        }, {
          key: "onClickOutsideSuggestionMobileEvent",
          value: function () {
            var t = this;
            r()(document).on("touchstart", (function (e) {
              var n = r()("." + p.a.searchSuggestion + "-mobile-top-panel");
              !n.is(e.target) && 0 == n.has(e.target).length && t.searchBox && 0 == t.searchBox.instantSearchResult.$wrapper.has(e.target).length && t.closeInstantSearchMobile(!0)
            }))
          }
        }, {
          key: "scrollSuggestionMobileEvent",
          value: function () {
            var t = this;
            r()(document).on("touchmove", (function (e) {
              t.$searchInput.is(":focus") && t.$searchInput.blur()
            }))
          }
        }, {
          key: "afterShowSearchBoxMobile",
          value: function () {}
        }, {
          key: "openSuggestionMobile",
          value: function () {
            this.beforeOpenSuggestionMobile(), r()("body").hasClass(p.a.searchSuggestionMobileOpen) || r()("body").addClass(p.a.searchSuggestionMobileOpen), this.showSearchBoxMobile(), this.$searchInput.autocomplete("search"), this.searchBox.instantSearchResult.$wrapper.show(), r()("html,body").scrollTop(), this.afterOpenSuggestionMobile()
          }
        }, {
          key: "beforeOpenSuggestionMobile",
          value: function () {}
        }, {
          key: "afterOpenSuggestionMobile",
          value: function () {}
        }]) && $t(n.prototype, i), c && $t(n, c), e
      }(f.a),
      Vt = {
        InstantSearchResult: kt,
        InstantSearchResultStyle2: Rt,
        InstantSearchMobile: Dt
      },
      Nt = {
        instantSearchResult: function (t, e) {
          var n = o.a.getSettingValue("search.suggestionStyle"),
            i = "InstantSearchResult" + u.a.capitalize(n, !0, !0);
          return Vt[i] && Vt[i].isActive() || (i = "InstantSearchResult"), new Vt[i](t, e)
        },
        instantSearchMobile: function () {
          var t = o.a.getSettingValue("search.suggestionMobileStyle");
          "style1" == t && (t = "");
          var e = "InstantSearchMobile" + u.a.capitalize(t, !0, !0);
          return Vt[e] && Vt[e].isActive() || (e = "InstantSearchMobile"), new Vt[e]
        }
      },
      Ut = function () {
        "string" != typeof l.a.currentTerm && (l.a.currentTerm = l.a.currentTerm.toString()), l.a.currentTerm = l.a.currentTerm.trim();
        var t = "";
        l.a.suggestionCache.hasOwnProperty(l.a.currentTerm) && l.a.suggestionCache[l.a.currentTerm].forEach((function (e) {
          "redirect" == e.key && e.values && (t = (t = (t = e.values).replace("https://" + l.a.shopDomain, "")).replace("http://" + l.a.shopDomain, ""))
        }));
        return t
      },
      qt = {
        getSearchRedirectUrl: Ut,
        checkForSearchRedirect: function (t) {
          if (t.data("search-submit")) {
            t.removeData("search-submit");
            var e = Ut();
            e ? u.a.setWindowLocation(e) : t.closest("form").trigger("submit", [!0])
          }
        }
      };

    function Ht(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }
    var Wt = function () {
      function t(e) {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, t), this.autocomplete = e, this.init()
      }
      var e, n, i;
      return e = t, (n = [{
        key: "init",
        value: function () {
          var t = this.autocomplete.menu,
            e = "." + p.a.searchSuggestionItem + "." + p.a.searchUiAutocompleteItem;
          return t._setOption("items", e), t._setOption("blur", this._blur.bind(t)), t.isFirstItem = this._isFirstItem.bind(t), t.isLastItem = this._isLastItem.bind(t), t._move = this._move.bind(t), this.autocomplete
        }
      }, {
        key: "_blur",
        value: function (t, e) {
          e.item && r()(e.item).removeClass("selected")
        }
      }, {
        key: "_isFirstItem",
        value: function () {
          return !!this.active && !this.element.find(this.options.items).index(this.active)
        }
      }, {
        key: "_isLastItem",
        value: function () {
          if (this.active) {
            var t = this.element.find(this.options.items),
              e = t.index(this.active) + 1;
            return !(t.length - e)
          }
          return !1
        }
      }, {
        key: "_move",
        value: function (t, e, n) {
          var i, r = this.element.find(this.options.items);
          if (this.active)
            if ("first" === t || "last" === t);
            else {
              var o = 0;
              o = "next" == t ? r.index(this.active) + 1 : r.index(this.active) - 1, i = r.eq(o)
            }
          i && i.length && this.active || (i = this.element.find(this.options.items)[e]()), i.addClass("selected"), this.focus(n, i)
        }
      }]) && Ht(e.prototype, n), i && Ht(e, i), t
    }();

    function Gt(t) {
      return (Gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function zt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Kt(t, e) {
      return !e || "object" !== Gt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Yt(t) {
      return (Yt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Qt(t, e) {
      return (Qt = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Jt = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = Kt(this, Yt(e).call(this))).id = t, i.autocomplete = null, i.instantSearchResult = null, i.isRendered = !1, i.isBoundEvents = !1, i.$element = n || r()("#" + i.id), i.$searchForm = i.$element.closest("form"), i.$uiMenuElement = null, i
      }
      var n, i, s;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Qt(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          this.instantSearchResult = Nt.instantSearchResult(this.id, this.$element), this.addComponent(this.instantSearchResult)
        }
      }, {
        key: "isRender",
        value: function () {
          return !this.isRendered
        }
      }, {
        key: "render",
        value: function () {
          var t = u.a.getParam(l.a.searchTermKey);
          this.$element.val(t).addClass(p.a.searchBox).attr("id", this.id).attr("data-search-box", this.id).attr("aria-live", "assertive").attr("aria-label", a.a.suggestion.searchBoxPlaceholder).attr("placeholder", a.a.suggestion.searchBoxPlaceholder), this.isRendered = !0
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvents
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element.autocomplete({
            appendTo: this.instantSearchResult.selector.wrapper,
            minLength: o.a.getSettingValue("search.suggestionMinLength"),
            delay: o.a.getSettingValue("search.suggestionDelay"),
            classes: {
              "ui-autocomplete": p.a.searchSuggestion
            },
            source: this._bindAutoCompleteSource.bind(this),
            response: this._bindAutoCompleteResponse.bind(this),
            position: {
              using: function () {
                return !1
              }
            },
            focus: this.onFocusAutocomplete.bind(this),
            select: this.onSelectAutocomplete.bind(this),
            open: this.onOpenAutocomplete.bind(this),
            close: this.onCloseAutocomplete.bind(this)
          }), this.autocomplete = this.$element.autocomplete("instance"), this.$uiMenuElement = this.autocomplete.menu.element, this.autocomplete._renderMenu = this._bindAutoCompleteRenderMenu.bind(this), this.autocomplete._resizeMenu = this._bindAutoCompleteResizeMenu.bind(this), this.autocomplete = new Wt(this.autocomplete), this.$element.on("click", this._onClickSearchBox.bind(this)).on("focus", this._onFocusSearchBox.bind(this)).on("keyup", this._onTypeSearchBoxEvent.bind(this)), this.$searchForm.length && this.$searchForm.on("submit", this._onSubmit.bind(this)), this.isBoundEvents = !0
        }
      }, {
        key: "_bindAutoCompleteSource",
        value: function (t, e) {
          window.suggestionCallback = e, l.a.currentTerm = t.term;
          var n = t.term.trim().replace(/\s+/g, " ");
          if ("" != (n = encodeURIComponent(n))) {
            var i = this.autocomplete.menu.element;
            if (this.instantSearchResult.setData(i, null, !0), this.instantSearchResult.refresh(), n in l.a.suggestionCache) return void window.suggestionCallback(l.a.suggestionCache[n]);
            h.default.getSuggestionData(n, 0, "suggest")
          }
        }
      }, {
        key: "_bindAutoCompleteResponse",
        value: function (t, e) {
          var n = e.content,
            i = u.a.getValueInObjectArray("query", n),
            r = u.a.getValueInObjectArray("event_type", n),
            o = u.a.getValueInObjectArray("suggest_query", n),
            a = u.a.getValueInObjectArray("local_cache", n);
          u.a.getValueInObjectArray("redirect", n), 25 == Object.keys(l.a.suggestionCache).length && (l.a.suggestionCache = {}), i in l.a.suggestionCache || "suggest_dym" == r || (l.a.suggestionCache[i] = n), "" == o || "suggest" != r || a || h.default.getSuggestionData(o, 0, "suggest_dym", i), qt.checkForSearchRedirect(this.$element)
        }
      }, {
        key: "_bindAutoCompleteRenderMenu",
        value: function (t, e) {
          this.instantSearchResult.setData(r()(t), e, !1), this.instantSearchResult.refresh()
        }
      }, {
        key: "_bindAutoCompleteResizeMenu",
        value: function () {
          this.customizeInstantSearch()
        }
      }, {
        key: "customizeInstantSearch",
        value: function () {}
      }, {
        key: "onFocusAutocomplete",
        value: function (t, e) {
          return this.autocomplete.widget(), !(!e.item || void 0 === e.item.label)
        }
      }, {
        key: "onOpenAutocomplete",
        value: function (t, e) {
          var n = this;
          u.a.isiOS() && r()("." + p.a.searchSuggestionItem + " a").on("touchstart", (function () {
            n.isScrolling = !1
          })).on("touchmove", (function () {
            n.isScrolling = !0
          })).on("touchend", (function (t) {
            n.isScrolling || (window.location = r()(t.currentTarget).attr("href"))
          })), u.a.InstantSearch.isFullWidthMobile() && !r()("body").hasClass(p.a.searchSuggestionMobileOpen) && r()("body").addClass(p.a.searchSuggestionMobileOpen), this.instantSearchResult.$wrapper.addClass(p.a.searchSuggestionOpen)
        }
      }, {
        key: "onCloseAutocomplete",
        value: function (t, e) {
          "test" == o.a.getSettingValue("search.suggestionMode") || u.a.InstantSearch.isFullWidthMobile() ? this.instantSearchResult.$instantSearchResult.show() : this.instantSearchResult.$instantSearchResult.siblings().hide(), this.instantSearchResult.$wrapper.removeClass(p.a.searchSuggestionOpen)
        }
      }, {
        key: "onSelectAutocomplete",
        value: function (t, e) {
          var n = this.autocomplete.widget().find("." + p.a.searchSuggestionItem + ".selected");
          if (n.length) {
            var i = n.find("> a");
            i.length && u.a.setWindowLocation(i.eq(0).attr("href"))
          }
          return !1
        }
      }, {
        key: "_onClickSearchBox",
        value: function (t) {
          "" != this.$element.val() && (u.a.InstantSearch.isFullWidthMobile() || this.$element.data("ui-autocomplete") && this.$element.autocomplete("search", this.$element.val()))
        }
      }, {
        key: "_onFocusSearchBox",
        value: function (t) {}
      }, {
        key: "_onTypeSearchBoxEvent",
        value: function (t) {
          l.a.currentTerm = t.target.value
        }
      }, {
        key: "_onSubmit",
        value: function (t, e) {
          if (!e) {
            t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault(), l.a.currentTerm = this.$element.val(), !l.a.currentTerm && t && t.target && (l.a.searchTerm = t.target.value);
            var n = qt.getSearchRedirectUrl();
            l.a.suggestionCache.hasOwnProperty(l.a.currentTerm.toString().trim()) ? n ? u.a.setWindowLocation(n) : this.$searchForm.trigger("submit", [!0]) : this.$element.data("search-submit", !0)
          }
        }
      }]) && zt(n.prototype, i), s && zt(n, s), e
    }(f.a);
    n(103);

    function Zt(t) {
      return (Zt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Xt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function te(t, e) {
      return !e || "object" !== Zt(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ee(t) {
      return (ee = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ne(t, e) {
      return (ne = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ie = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = te(this, ee(e).call(this))).data = null, t.id = null, t.totalProduct = null, t.$element = null, t.$productList = r()(s.a.products), t.settings = {
          enableKeepScrollbackPosition: o.a.getSettingValue("general.enableKeepScrollbackPosition")
        }, t
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ne(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          window.BoostOTP && BoostOTP.OTPButtons.init(this)
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return ""
        }
      }, {
        key: "render",
        value: function () {
          if (!this.$element || 0 == this.$element.length)
            if (this.parent.isRender()) {
              var t = this.compileTemplate();
              t && "string" == typeof t && (this.$element = r()(t))
            } else {
              var e = o.a.getSettingValue("general.otpProductItemClass");
              this.$element = e ? this.$productList.children(e).eq(this.index) : this.$productList.children().eq(this.index)
            }
          this.$element && (this.$element.attr("data-id", this.id), this.$element.data("page", l.a.queryParams.page), window.BoostOTP && BoostOTP.OTPButtons.render(this))
        }
      }, {
        key: "bindEvents",
        value: function () {
          this._bindKeepScrollbackPositionEvent(), window.BoostOTP && BoostOTP.OTPButtons.bindEvents(this)
        }
      }, {
        key: "_bindKeepScrollbackPositionEvent",
        value: function () {
          if (this.$element && this.settings.enableKeepScrollbackPosition)
            if (u.a.isMobileDevice()) {
              var t = !1;
              this.$element.on("touchstart", (function () {
                t = !1
              })).on("touchmove", (function () {
                t = !0
              })).on("touchend", this._onClickKeepPositionEvent.bind(this, t))
            } else this.$element.on("click", this._onClickKeepPositionEvent.bind(this, !1))
        }
      }, {
        key: "_onClickKeepPositionEvent",
        value: function (t, e) {
          if (!t && this.id) {
            var n = new URL(u.a.getWindowLocation().href),
              i = {
                productId: this.id,
                page: this.$element.data("page")
              };
            null !== n.searchParams.get("page") && n.searchParams.delete("page"), i.page > 1 && u.a.FilterResult.isAdvancedPaginationType() && n.searchParams.append("page", i.page), window.history.replaceState(i, "", n.toString().replace(/\+/g, "%20"))
          }
        }
      }, {
        key: "setData",
        value: function (t, e) {
          this.data = t, this.id = t.id, this.index = e, this.totalProduct = this.parent.totalProduct
        }
      }]) && Xt(n.prototype, i), a && Xt(n, a), e
    }(f.a);

    function re(t) {
      return (re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function oe(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ae(t, e) {
      return !e || "object" !== re(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function le(t) {
      return (le = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function se(t, e) {
      return (se = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ce = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), ae(this, le(e).call(this))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && se(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {
          throw Error("Missing buildProductGridItem function in theme lib")
        }
      }]) && oe(n.prototype, i), r && oe(n, r), e
    }(ie);

    function ue(t) {
      return (ue = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function pe(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function fe(t, e) {
      return !e || "object" !== ue(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function he(t) {
      return (he = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ye(t, e) {
      return (ye = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var de = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), fe(this, he(e).call(this))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ye(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {
          throw Error("Missing buildProductListItem function in theme lib")
        }
      }]) && pe(n.prototype, i), r && pe(n, r), e
    }(ie);

    function ge(t) {
      return (ge = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function me(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function be(t, e) {
      return !e || "object" !== ge(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ve(t) {
      return (ve = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Se(t, e) {
      return (Se = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Oe = function (t) {
        function e() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), be(this, ve(e).call(this))
        }
        var n, i, r;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Se(t, e)
        }(e, t), n = e, (i = [{
          key: "compileTemplate",
          value: function () {
            throw Error("Missing buildProductCollageItem function in theme lib")
          }
        }]) && me(n.prototype, i), r && me(n, r), e
      }(ie),
      Te = (n(44), n(67), n(84), n(85), n(46), n(22)),
      Pe = n(27);

    function we(t) {
      return (we = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function _e(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ce(t, e) {
      return !e || "object" !== we(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ke(t) {
      return (ke = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ee(t, e) {
      return (Ee = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ie = function (t) {
        function e() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (t = Ce(this, ke(e).call(this))).data = null, t.totalProduct = null, t.$element = r()(s.a.products), t.settings = {
            loadProductFromLiquid: o.a.getSettingValue("general.loadProductFromLiquid"),
            loadProductFromLiquidType: o.a.getSettingValue("general.loadProductFromLiquidType"),
            sessionStoragePreviousPageEvent: o.a.getSettingValue("general.sessionStoragePreviousPageEvent"),
            themeId: o.a.getSettingValue("general.theme_id"),
            productAndVariantAvailable: o.a.getSettingValue("general.productAndVariantAvailable"),
            sortingAvailableFirst: o.a.getSettingValue("general.sortingAvailableFirst")
          }, t
        }
        var n, i, c;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Ee(t, e)
        }(e, t), n = e, c = [{
          key: "Enum",
          get: function () {
            return {
              itemStyle: {
                GRID: "grid",
                LIST: "list",
                COLLAGE: "collage"
              },
              loadProductType: {
                JS: "js",
                AJAX: "ajax",
                SYNC: "sync"
              }
            }
          }
        }], (i = [{
          key: "isRender",
          value: function () {
            return null != this.data && Pe.a.isPanelActive(Te.a.Enum.PRODUCT) && (!l.a.loadProductFirst || u.a.isSearchPage() || u.a.isVendorPage() || u.a.isTagPage() || u.a.isTypePage() || "best-selling" === l.a.defaultSorting && !o.a.getSettingValue("general.loadProductFirstBestSelling") || this.settings.productAndVariantAvailable || this.settings.sortingAvailableFirst || l.a.loadProductFirst && (l.a.hasFilterOptionParam || "init" != this.eventType))
          }
        }, {
          key: "getNoResultTemplate",
          value: function () {
            return '\n\t\t\t<div class="boost-pfs-filter-message"><p><em>{{content}}</em></p></div>\n\t\t'
          }
        }, {
          key: "render",
          value: function () {
            this._catchError(), this.totalProduct > 0 && (this.settings.loadProductFromLiquid ? this.buildProductListDataFromLiquid() : this.buildProductList())
          }
        }, {
          key: "bindEvents",
          value: function () {
            this._bindKeepScrollbackPositionEvent()
          }
        }, {
          key: "setData",
          value: function (t) {
            var e = this;
            if (this.data = t, this.totalProduct = this.parent.totalProduct, this.prepareProductData(), this.eventType = this.parent.eventType, this.children = [], this.productItems = [], this.ajaxPage = 0, this.totalProduct > 0) {
              var n = this._getProductItemClass();
              t.forEach((function (t, i) {
                var r = new n;
                e.addComponent(r), r.setData(t, i), e.productItems.push(r)
              }))
            }
          }
        }, {
          key: "_getProductItemClass",
          value: function () {
            switch (l.a.queryParams.display) {
            case e.Enum.itemStyle.LIST:
              return de;
            case e.Enum.itemStyle.COLLAGE:
              return Oe;
            default:
              return ce
            }
          }
        }, {
          key: "buildProductListDataFromLiquid",
          value: function () {
            u.a.isDefaultPaginationType() || "page" != this.eventType || r()(window).off("scroll"), this.settings.loadProductFromLiquidType == e.Enum.loadProductType.SYNC ? this._getProductListHtmlBySync() : this._getProductListHtmlByAjax()
          }
        }, {
          key: "prepareProductData",
          value: function () {
            var t = this,
              e = this.data;
            return Array.isArray(e) ? (e.forEach((function (e) {
              var n = [];
              e.options_with_values.forEach((function (t) {
                n.push(t.name)
              })), e.options = n;
              var i = !0;
              if (e.variants && e.variants.length > 0) {
                var r = e.variants[0];
                r.hasOwnProperty("fulfillment_service") && "gift_card" == r.fulfillment_service && (i = !1)
              }
              e.price_min = u.a.convertPriceBasedOnActiveCurrency(e.price_min, i), e.price_max = u.a.convertPriceBasedOnActiveCurrency(e.price_max, i), e.compare_at_price_min = u.a.convertPriceBasedOnActiveCurrency(e.compare_at_price_min, i), e.compare_at_price_max = u.a.convertPriceBasedOnActiveCurrency(e.compare_at_price_max, i), e.variants.forEach((function (t) {
                var e = [],
                  n = t.merged_options;
                if (Array.isArray(n)) {
                  for (var r = 0; r < n.length; r++) {
                    var o = n[r].split(":");
                    t["option" + (parseInt(r) + 1)] = o[1], t["option_" + o[0]] = o[1], e.push(o[1])
                  }
                  t.options = e
                }
                if (null != t.compare_at_price) {
                  var a = parseFloat(t.compare_at_price);
                  a = u.a.convertPriceBasedOnActiveCurrency(a, i), t.compare_at_price = a
                }
                var l = parseFloat(t.price);
                l = u.a.convertPriceBasedOnActiveCurrency(l, i), t.price = l
              })), e.description = e.body_html, e.featured_image = Array.isArray(e.images) && e.images.length > 0 ? e.images[0] : boostPFSConfig.general.no_image_url, e = t.showVariantImageBasedOnSelectedFilter(e)
            })), e) : []
          }
        }, {
          key: "showVariantImageBasedOnSelectedFilter",
          value: function (t) {
            var e = o.a.getSettingValue("general.showVariantImageBasedOnSelectedFilter");
            if (e && "string" == typeof e && Array.isArray(t.variants) && t.variants.length > 1 && l.a.queryParams && Array.isArray(l.a.queryParams[e]) && l.a.queryParams[e].length > 0)
              for (var n = l.a.queryParams[e], i = 0; i < n.length; i++) {
                for (var r = !1, a = e.split("_"), s = a[a.length - 1] + ":" + n[i], c = 0; c < t.variants.length; c++) {
                  var u = t.variants[c];
                  if (r = Array.isArray(u.merged_options) && u.merged_options.includes(s) && u.image) {
                    t.featured_image = u.image, Array.isArray(t.images_info) && t.images_info.sort((function (t, e) {
                      return e.src == u.image ? 1 : -1
                    })), Array.isArray(t.images) && t.images.sort((function (t, e) {
                      return e == u.image ? 1 : -1
                    }));
                    break
                  }
                }
                if (r) break
              }
            return t
          }
        }, {
          key: "buildProductList",
          value: function () {
            var t = [];
            this.productItems.forEach((function (e) {
              t.push(e.$element)
            })), this.$element.removeAttr("data-boost-sort"), (u.a.isDefaultPaginationType() || !u.a.isDefaultPaginationType() && "page" != this.eventType) && (this.$element.html(""), r()(window).unbind("scroll")), u.a.isLoadPreviousPagePaginationType() && parseInt(window.sessionStorage.getItem(this.settings.sessionStoragePreviousPageEvent)) ? this.$element.prepend(t) : this.$element.append(t), this.settings.loadProductFromLiquid && this.settings.loadProductFromLiquidType == e.Enum.loadProductType.AJAX && this.afterRender()
          }
        }, {
          key: "buildExtrasProductListByAjax",
          value: function (t, e, n, i, o, a) {
            o || (o = 0), a || (a = []), (!i || i > 20) && (i = 20);
            for (var l = i * o, s = Math.min(t.length, i * (o + 1)), c = [], u = l; u < s; u++) c.push(t[u].handle);
            var p = "/collections/all/" + c.join("+") + "?view=" + e;
            r.a.ajax({
              type: "GET",
              url: p,
              success: function (r) {
                this._onExtraProductListAjaxSuccess(t, e, n, i, o, r, a)
              }.bind(this)
            })
          }
        }, {
          key: "_getProductListHtmlByAjax",
          value: function () {
            this.isFetchedAjaxProductData = !1, this.$element.addClass(p.a.productWrapLoading);
            for (var t = 20 * this.ajaxPage, e = Math.min(this.data.length, 20 * (this.ajaxPage + 1)), n = [], i = t; i < e; i++) n.push(this.data[i].handle);
            var o = n.join("+");
            r.a.ajax({
              type: "GET",
              url: "/collections/all/" + o + "?view=boost-pfs-product-item",
              success: this._onProductListAjaxSuccess.bind(this)
            })
          }
        }, {
          key: "_getProductListHtmlBySync",
          value: function () {
            var t = this.settings.themeId,
              e = !1;
            this.productItems.forEach((function (n, i) {
              e || (n.data.html && n.data.html.value && t && t == n.data.html.theme_id ? (n.data.html = n.data.html.value, n.refresh()) : e = !0)
            })), e ? this._getProductListHtmlByAjax() : this.buildProductList()
          }
        }, {
          key: "_onProductListAjaxSuccess",
          value: function (t) {
            var e = this,
              n = [];
            try {
              /<\!--.*?-->/.test(t) && (t = t.replace(/<\!--.*?-->/g, "")), n = JSON.parse(t).products
            } catch (t) {
              throw new Error("Could not parse json from collection.boost-pfs-product-item.liquid")
            }
            n.forEach((function (t) {
              e.data.forEach((function (e, n) {
                e.id == t.id && (e.html = t.html.value)
              }))
            }));
            for (var i = 20 * this.ajaxPage, r = i; r < i + n.length; r++) this.productItems.forEach((function (t) {
              t.id == e.data[r].id ? (t.setData(e.data[r]), t.refresh()) : e.productItems.forEach((function (t) {
                t.bindEvents()
              }))
            }));
            0 == this.ajaxPage && (u.a.isDefaultPaginationType() || "page" !== this.eventType) && this.$element.html(""), this.buildProductList(), 20 * (this.ajaxPage + 1) < this.data.length ? (this.ajaxPage++, this._getProductListHtmlByAjax()) : (this.isFetchedAjaxProductData = !0, this.parent.pagination.refresh(), this.parent.productPlaceholder.refresh(), this.$element.removeClass(p.a.productWrapLoading))
          }
        }, {
          key: "_onExtraProductListAjaxSuccess",
          value: function (t, e, n, i, r, o, a) {
            try {
              /<\!--.*?-->/.test(o) && (o = o.replace(/<\!--.*?-->/g, "")), a = a.concat(JSON.parse(o).products)
            } catch (t) {
              throw new Error("Could not parse json from " + e + ": " + t.message)
            }
            i * r < t.length - 1 ? (r++, this.buildExtrasProductListByAjax(t, e, n, i, r, a)) : "function" == typeof n && n(a)
          }
        }, {
          key: "_bindKeepScrollbackPositionEvent",
          value: function () {
            if (("init" == this.eventType || "history" == this.eventType) && void 0 !== window.history && (history.scrollRestoration = "manual", null !== history.state && history.state.hasOwnProperty("productId"))) {
              var t = new URL(u.a.getWindowLocation().href),
                e = history.state.productId;
              if (null !== e) {
                var n = this.$element.find("[data-id=" + e + "]").first();
                n.length > 0 && r()("html, body").animate({
                  scrollTop: n.offset().top
                }, 0), setTimeout((function () {
                  window.history.replaceState("", "", t.toString().replace(/\+/g, "%20"))
                }), 500)
              }
            }
          }
        }, {
          key: "_catchError",
          value: function () {
            if (u.a.isNoFilterResult(this.totalProduct, this.eventType)) {
              var t = a.a.error.noProducts;
              if (u.a.checkExistFilterOptionParam() ? t = a.a.error.noFilterResult : u.a.isSearchPage() && (t = a.a.error.noSearchResult), "" !== t) {
                var e = this.getNoResultTemplate().replace(/{{content}}/g, t);
                this.$element.html(e)
              }
            }
          }
        }]) && _e(n.prototype, i), c && _e(n, c), e
      }(f.a),
      Le = n(58),
      Ae = n(7);

    function Fe(t) {
      return (Fe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Re(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function je(t, e) {
      return !e || "object" !== Fe(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function $e(t) {
      return ($e = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Be(t, e) {
      return (Be = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var xe = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = je(this, $e(e).call(this))).$element = r()(s.a.topDisplayType), t.selector = {
          productDisplayTypeItem: "." + p.a.productDisplayType + "-item",
          productDisplayTypeGrid: "." + p.a.productDisplayType + "-grid",
          productDisplayTypeList: "." + p.a.productDisplayType + "-list"
        }, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Be(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {}
      }, {
        key: "render",
        value: function () {
          this.$element.html(this.compileTemplate()), this.$element.length && (this.$element.find(this.selector.productDisplayTypeList).removeClass("active"), this.$element.find(this.selector.productDisplayTypeGrid).removeClass("active"), "list" == l.a.queryParams.display ? this.$element.find(this.selector.productDisplayTypeList).addClass("active") : "grid" == l.a.queryParams.display && this.$element.find(this.selector.productDisplayTypeGrid).addClass("active"))
        }
      }, {
        key: "bindEvents",
        value: function () {
          r()(s.a.topDisplayType + " a").on("click", this._onClickEvent.bind(this))
        }
      }, {
        key: "_onClickEvent",
        value: function (t) {
          t.preventDefault(), l.a.internalClick = !0;
          var e = r()(t.currentTarget);
          e.siblings().removeClass("active"), e.addClass("active");
          var n = e.data("display");
          if (n) Ae.default.setParam("display", n);
          else {
            var i = e.attr("href");
            Ae.default.updateParamsFromUrl(i)
          }
          Ae.default.applyFilter("display")
        }
      }]) && Re(n.prototype, i), o && Re(n, o), e
    }(f.a);

    function Me(t) {
      return (Me = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function De(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ve(t, e) {
      return !e || "object" !== Me(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Ne(t) {
      return (Ne = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ue(t, e) {
      return (Ue = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var qe = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), Ve(this, Ne(e).call(this))
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ue(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {}
      }, {
        key: "render",
        value: function () {
          r()(s.a.topSorting).html(this.compileTemplate());
          var t = r()(s.a.topSorting + " select");
          t.length && t.val(l.a.queryParams.sort)
        }
      }, {
        key: "bindEvents",
        value: function () {
          r()(s.a.topSorting + " select").change((function (t) {
            Ae.default.setParam("sort", r()(this).val()), Ae.default.setParam("page", 1), Ae.default.applyFilter("sort")
          }))
        }
      }]) && De(n.prototype, i), o && De(n, o), e
    }(f.a);

    function He(t) {
      return (He = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function We(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ge(t, e) {
      return !e || "object" !== He(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ze(t) {
      return (ze = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ke(t, e) {
      return (Ke = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ye = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), Ge(this, ze(e).call(this))
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ke(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {}
      }, {
        key: "render",
        value: function () {
          r()(s.a.topShowLimit).html(this.compileTemplate());
          var t = r()(s.a.topShowLimit + " select");
          t.length && t.val(Globals.queryParams.limit)
        }
      }, {
        key: "bindEvents",
        value: function () {
          r()(s.a.topShowLimit + " select").change((function (t) {
            Ae.default.setParam("limit", r()(this).val()), Ae.default.applyFilter()
          }))
        }
      }]) && We(n.prototype, i), o && We(n, o), e
    }(f.a);

    function Qe(t) {
      return (Qe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Je(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ze(t, e) {
      return !e || "object" !== Qe(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Xe(t) {
      return (Xe = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function tn(t, e) {
      return (tn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var en = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = Ze(this, Xe(e).call(this))).data = null, l.a.currentTerm = u.a.getSearchTerm(), t.$searchResultHeader = r()("." + p.a.searchResultHeader), t.$searchResultNumber = r()("." + p.a.searchResultNumber), t
      }
      var n, i, s;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && tn(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          l.a.currentTerm && (this.searchTerm = u.a.escape(l.a.currentTerm.trim()))
        }
      }, {
        key: "compileSEOTitleTemplate",
        value: function () {
          var t = this.data.total_product <= 1 ? a.a.search.seoTitleOne : a.a.search.seoTitleOther;
          return t && (t = t.replace(/{{ count }}/g, this.data.total_product).replace(/{{ terms }}/g, this.searchTerm)), t
        }
      }, {
        key: "compileSearchResultHeader",
        value: function () {
          if (this.searchTerm) var t = this.data.total_product > 0 ? a.a.search.resultHeader : a.a.search.resultEmpty;
          else t = a.a.search.generalTitle;
          return t.replace(/{{ terms }}/g, this.searchTerm)
        }
      }, {
        key: "compileSearchResultNumber",
        value: function () {
          var t = "";
          return this.searchTerm && (t = a.a.search.resultNumber), t.replace(/{{ count }}/g, "<strong>" + this.data.total_product + "</strong>").replace(/{{ terms }}/g, "<strong>" + this.searchTerm + "</strong>")
        }
      }, {
        key: "isRender",
        value: function () {
          return !!this.data
        }
      }, {
        key: "render",
        value: function () {
          this._buildSEOTitle(), this._buildSearchResultHeader(), this._buildSearchResultNumber()
        }
      }, {
        key: "setData",
        value: function (t) {
          t && (this.data = t)
        }
      }, {
        key: "_buildSEOTitle",
        value: function () {
          if (o.a.getSettingValue("search.enableFixHeadTitle")) {
            var t = this.compileSEOTitleTemplate();
            t && this.searchTerm && "" !== this.searchTerm && (document.title = t.replace(/&quot;/g, '"'))
          }
        }
      }, {
        key: "_buildSearchResultHeader",
        value: function () {
          var t = this.compileSearchResultHeader();
          this.$searchResultHeader.html(t)
        }
      }, {
        key: "_buildSearchResultNumber",
        value: function () {
          var t = this.compileSearchResultNumber();
          this.$searchResultNumber.html(t)
        }
      }]) && Je(n.prototype, i), s && Je(n, s), e
    }(f.a);

    function nn(t) {
      return (nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function rn(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function on(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function an(t, e) {
      return !e || "object" !== nn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ln(t) {
      return (ln = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function sn(t, e) {
      return (sn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var cn = function (t) {
      function e() {
        return rn(this, e), an(this, ln(e).apply(this, arguments))
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && sn(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {
          return ""
        }
      }, {
        key: "buildBreadcrumb",
        value: function () {
          if (this.collectionData = this.parent.collectionData, this.collectionData && this.collectionData.collection) {
            var t = r()(s.a.breadcrumb);
            t.length && t.html(this.compileTemplate())
          }
        }
      }]) && on(n.prototype, i), o && on(n, o), e
    }(f.a);

    function un(t) {
      return (un = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function pn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function fn(t, e) {
      return !e || "object" !== un(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function hn(t) {
      return (hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function yn(t, e) {
      return (yn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var dn = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = fn(this, hn(e).call(this))).data = null, t.defaultCollectionData = {
          collection: {
            description: "",
            handle: o.a.getSettingValue("general.collection_handle"),
            title: a.a.collectionAll
          }
        }, t.collectionData = {}, t.$collectionHeader = r()("." + p.a.collectionHeader), t.$collectionDescription = r()("." + p.a.collectionDescription), t.$collectionImage = r()("." + p.a.collectionImage), t
      }
      var n, i, s;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && yn(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          this.breadcrumb = new cn, this.addComponent(this.breadcrumb)
        }
      }, {
        key: "isRender",
        value: function () {
          return !!this.data && "collection" == this.parent.eventType
        }
      }, {
        key: "render",
        value: function () {
          var t = window.location.pathname;
          if (t && "/" != t) {
            if ("/collections/all" == t) this.collectionData = this.defaultCollectionData;
            else if (u.a.isVendorPage() || u.a.isTypePage()) this.collectionData = {
              collection: {
                description: "",
                handle: "",
                title: u.a.getSearchTerm()
              }
            };
            else if (!u.a.isSearchPage()) {
              var e = u.a.getWindowLocation().href.split("?")[0] + "?view=desc";
              r.a.ajax({
                method: "GET",
                url: e,
                dataType: "json",
                success: this._onGetCollectionDataSuccess.bind(this),
                error: this._onGetCollectionDataError.bind(this)
              })
            }
            this._buildPageInfo()
          }
        }
      }, {
        key: "setData",
        value: function (t) {
          t && (this.data = t)
        }
      }, {
        key: "_buildPageInfo",
        value: function () {
          this.breadcrumb && this.breadcrumb.buildBreadcrumb(), this.buildCollectionDetail(), this.buildDocumentInfo()
        }
      }, {
        key: "buildCollectionDetail",
        value: function () {
          if (void 0 !== this.collectionData && this.collectionData.hasOwnProperty("collection")) {
            var t = this.collectionData.collection,
              e = t.hasOwnProperty("title") && "" != t.title ? t.title : null,
              n = t.hasOwnProperty("description") && "" != t.description ? t.description : null,
              i = t.hasOwnProperty("image") && t.image && t.image.src ? t.image.src : null;
            e ? this.$collectionHeader.html(e).show() : this.$collectionHeader.hide(), n ? this.$collectionDescription.html(n).show() : this.$collectionDescription.hide(), i ? this.$collectionImage.attr("src", i).css("background-image", "url(" + i + ")").removeClass(p.a.collectionNoImage).addClass(p.a.collectionHasImage) : this.$collectionImage.attr("src", "").css("background-image", "none").removeClass(p.a.collectionHasImage).addClass(p.a.collectionNoImage)
          }
        }
      }, {
        key: "buildDocumentInfo",
        value: function () {
          if (void 0 !== this.collectionData && this.collectionData.hasOwnProperty("collection")) {
            var t = this.collectionData.collection.title + " - " + l.a.shopName;
            document.title = t
          }
        }
      }, {
        key: "_onGetCollectionDataSuccess",
        value: function (t) {
          this.collectionData = t, this._buildPageInfo()
        }
      }, {
        key: "_onGetCollectionDataError",
        value: function () {
          this.collectionData = this.defaultCollectionData, this._buildPageInfo()
        }
      }]) && pn(n.prototype, i), s && pn(n, s), e
    }(f.a);

    function gn(t) {
      return (gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function mn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function bn(t, e) {
      return !e || "object" !== gn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function vn(t) {
      return (vn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Sn(t, e) {
      return (Sn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var On = function (t) {
        function e() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (t = bn(this, vn(e).call(this))).selecor = {
            robots: 'meta[content="noindex,nofollow"]'
          }, t.currentCollection = boostPFSConfig.general.collection_handle, t.settings = {
            boostCollection: o.a.getSettingValue("general.boostCollection")
          }, t
        }
        var n, i, a;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Sn(t, e)
        }(e, t), n = e, (i = [{
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<meta name="robots" content="noindex,nofollow">\n\t\t'
          }
        }, {
          key: "compileTemplate",
          value: function () {
            return this.getTemplate()
          }
        }, {
          key: "isRender",
          value: function () {
            return o.a.getSettingValue("general.enableSeo") && !r()(this.selecor.robots).length && (0 == this.currentCollection.indexOf(this.settings.boostCollection) || u.a.checkExistFilterOptionParam() || l.a.queryParams.q && !u.a.isSearchPage())
          }
        }, {
          key: "render",
          value: function () {
            r()("head").append(this.compileTemplate())
          }
        }]) && mn(n.prototype, i), a && mn(n, a), e
      }(f.a),
      Tn = n(41);

    function Pn(t) {
      return (Pn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function wn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function _n(t, e) {
      return !e || "object" !== Pn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Cn(t) {
      return (Cn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function kn(t, e) {
      return (kn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var En = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = _n(this, Cn(e).call(this))).$loadMoreContainer = null, t.$defaultElement = r()(s.a.pagination), t.$element = r()(s.a.loadMore), t.selector = {
          loadMoreButton: "." + p.a.productLoadMore + "-button",
          loadMoreTotal: s.a.loadMore + "-total"
        }, r.a.extend(t.settings, {
          sessionStorageCurrentNextPage: o.a.getSettingValue("general.sessionStorageCurrentNextPage"),
          sessionStoragePreviousPageEvent: o.a.getSettingValue("general.sessionStoragePreviousPageEvent")
        }), t
      }
      var n, i, c;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && kn(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function (t) {
          switch (t) {
          case "total":
            return '\n\t\t\t\t\t<div class="{{class.productLoadMore}}-total">{{progressLable}}</div>\n\t\t\t\t';
          default:
            return '\n\t\t\t\t\t{{loadMoreProgress}}\n\t\t\t\t\t<div class="{{class.productLoadMore}}-button-container">\n\t\t\t\t\t\t<button aria-label="{{label.loadMore}}" class="{{class.productLoadMore}}-button">{{label.loadMore}}</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="{{class.productLoadMore}}-loading" style="display: none;">\n\t\t\t\t\t\t<div class="{{class.productLoadMore}}-icon"></div>\n\t\t\t\t\t</div>\n\t\t\t\t'
          }
        }
      }, {
        key: "compileTemplate",
        value: function () {
          var t = this.compileTotalTemplate();
          l.a.queryParams.page || (l.a.queryParams.page = 1);
          var e = this.totalProduct - l.a.queryParams.page * l.a.queryParams.limit;
          return e = Math.min(e, l.a.queryParams.limit), this.getTemplate().replace(/{{loadMoreProgress}}/g, t).replace(/{{label.loadMore}}/g, a.a.loadMore).replace(/{{class.productLoadMore}}/g, p.a.productLoadMore).replace(/{{ amountProduct }}/g, e)
        }
      }, {
        key: "compileTotalTemplate",
        value: function () {
          u.a.isLoadPreviousPagePaginationType() && "page" == this.parent.eventType ? this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage)) : this.nextPage = l.a.queryParams.page;
          var t = (this.nextPage - 1) * l.a.queryParams.limit + 1,
            e = r()(s.a.products + " > *:not(script):not(style)").length;
          e && (t -= e - l.a.queryParams.limit);
          var n = (this.nextPage - 1) * l.a.queryParams.limit + 1 + this.data.products.length - 1;
          return this.getTemplate("total").replace(/{{progressLable}}/g, a.a.loadMoreTotal).replace(/{{ from }}/g, t).replace(/{{ to }}/g, n).replace(/{{ total }}/g, this.totalProduct).replace(/{{class.productLoadMore}}/g, p.a.productLoadMore)
        }
      }, {
        key: "render",
        value: function () {
          this.$defaultElement.empty();
          var t = l.a.queryParams,
            e = this.compileTemplate();
          if (this.$element.html(e), r()(s.a.loadMoreButtonContainer).length > 0) {
            var n = this.compileTotalTemplate();
            r()(this.selector.loadMoreTotal).replaceWith(n)
          }
          this.$loadMoreContainer = r()(s.a.loadMoreButtonContainer), this.hideLoading();
          var i = Math.ceil(this.totalProduct / t.limit);
          parseInt(t.page) < i ? (this.$element.show(), this.$loadMoreContainer.show()) : this.$element.hide()
        }
      }, {
        key: "bindEvents",
        value: function () {
          u.a.isLoadPreviousPagePaginationType() ? this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage)) : this.nextPage = l.a.queryParams.page, this.$element.find(this.selector.loadMoreButton).off("click").on("click", this._onClickEvent.bind(this))
        }
      }, {
        key: "_onClickEvent",
        value: function (t) {
          if (t.preventDefault(), this.$loadMoreContainer.hide(), this.showLoading(), this.nextPage++, l.a.internalClick = !0, Ae.default.setParam("limit", this.settings.limit), Ae.default.setParam("page", this.nextPage), u.a.FilterResult.isAdvancedPaginationType()) u.a.isLoadPreviousPagePaginationType() && (window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, this.nextPage), window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 0)), Ae.default.applyFilter("page");
          else {
            var e = Tc.instance.filter;
            Ae.default.getFilterData("page", e.setData.bind(e))
          }
        }
      }]) && wn(n.prototype, i), c && wn(n, c), e
    }(Tn.a);

    function In(t) {
      return (In = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ln(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function An(t, e) {
      return !e || "object" !== In(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Fn(t) {
      return (Fn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Rn(t, e) {
      return (Rn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var jn = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = An(this, Fn(e).call(this))).$element = r()(s.a.bottomPagination), r.a.extend(t.settings, {
          positionShowInfiniteLoading: o.a.getSettingValue("general.positionShowInfiniteLoading"),
          sessionStorageCurrentNextPage: o.a.getSettingValue("general.sessionStorageCurrentNextPage"),
          sessionStoragePreviousPageEvent: o.a.getSettingValue("general.sessionStoragePreviousPageEvent")
        }), t
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Rn(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<div class="{{class.productLoadMore}}-loading" style="display: none;">\n\t\t\t\t<div class="{{class.productLoadMore}}-icon"></div>\n\t\t\t</div>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.productLoadMore}}/g, p.a.productLoadMore)
        }
      }, {
        key: "isRender",
        value: function () {
          return null !== this.data && Pe.a.isPanelActive(Te.a.Enum.PRODUCT)
        }
      }, {
        key: "render",
        value: function () {
          if (this.$element.empty(), this.$element.show(), 0 == this.$loadMore.find(s.a.loadMoreLoading).length) {
            var t = this.compileTemplate();
            this.$loadMore.prepend(t), this.$loadMore.show()
          }
          this.hideLoading()
        }
      }, {
        key: "bindEvents",
        value: function () {
          u.a.isLoadPreviousPagePaginationType() ? this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage)) : this.nextPage = l.a.queryParams.page, this.totalProduct > this.settings.limit * this.nextPage && (this.scrolling = !1, this.scrollToBottom = !1, this.$element.length > 0 && r()(window).on("scroll", this._onScrollEvent.bind(this)))
        }
      }, {
        key: "_onScrollEvent",
        value: function (t) {
          if (t.preventDefault(), t.stopPropagation(), r()(s.a.products).hasClass(p.a.productWrapLoading) || !Pe.a.isPanelActive(Te.a.Enum.PRODUCT)) return !1;
          this._isScrollToBottom() && this._loadMoreProducts()
        }
      }, {
        key: "_isScrollToBottom",
        value: function () {
          var t = r()(window).height() * (r()(window).height() / r()(document).outerHeight()),
            e = parseInt(this.$element.offset().top),
            n = parseInt(r()(window).scrollTop()) + t + parseInt(this.settings.positionShowInfiniteLoading);
          return r()(window).scrollTop() + r()(window).height() + t >= r()(document).outerHeight() - 100 && (this.scrollToBottom = !0), !this.scrolling && this.data.products.length > 0 && (n >= e || n < e && this.scrollToBottom)
        }
      }, {
        key: "_loadMoreProducts",
        value: function () {
          this.showLoading(), this.scrolling = !0, this.nextPage++;
          var t = Math.ceil(this.totalProduct / this.settings.limit);
          if (this.nextPage <= t)
            if (l.a.internalClick = !0, Ae.default.setParam("limit", this.settings.limit), Ae.default.setParam("page", this.nextPage), u.a.FilterResult.isAdvancedPaginationType()) u.a.isLoadPreviousPagePaginationType() && (window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, this.nextPage), window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 0)), Ae.default.applyFilter("page");
            else {
              var e = Tc.instance.filter;
              Ae.default.getFilterData("page", e.setData.bind(e))
            }
        }
      }]) && Ln(n.prototype, i), a && Ln(n, a), e
    }(Tn.a);

    function $n(t) {
      return ($n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Bn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function xn(t, e) {
      return !e || "object" !== $n(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Mn(t) {
      return (Mn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Dn(t, e) {
      return (Dn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Vn = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = xn(this, Mn(e).call(this))).$wrapper = r()(s.a.btnLoadPreviousPageWrapperSelector), t.$element = r()(s.a.btnLoadPreviousPageSelector), r.a.extend(t.settings, {
          sessionStorageCurrentPreviousPage: o.a.getSettingValue("general.sessionStorageCurrentPreviousPage"),
          sessionStorageCurrentPage: o.a.getSettingValue("general.sessionStorageCurrentPage"),
          sessionStorageCurrentNextPage: o.a.getSettingValue("general.sessionStorageCurrentNextPage"),
          sessionStoragePreviousPageEvent: o.a.getSettingValue("general.sessionStoragePreviousPageEvent")
        }), t
      }
      var n, i, c;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Dn(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<div class="{{class.buttonLoadPreviousPageSelector}}">\n\t\t\t\t<a href="javascript:void(0)" aria-label="{{label.loadPreviousPage}}" class="js-{{class.buttonLoadPreviousPageSelector}}">{{label.loadPreviousPage}}</a>\n\t\t\t</div>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.buttonLoadPreviousPageSelector}}/g, p.a.buttonLoadPreviousPageSelector).replace(/{{label.loadPreviousPage}}/g, a.a.loadPreviousPage)
        }
      }, {
        key: "isRender",
        value: function () {
          return this.data && u.a.isLoadPreviousPagePaginationType() && "page" != this.parent.eventType
        }
      }, {
        key: "render",
        value: function () {
          this.$element.length || (this.$element = r()(this.compileTemplate()), this.$wrapper.html(this.$element));
          var t = Math.ceil(this.totalProduct / l.a.queryParams.limit),
            e = l.a.queryParams.page,
            n = t > 1 && e > 1;
          window.sessionStorage.setItem(this.settings.sessionStorageCurrentPreviousPage, e), window.sessionStorage.setItem(this.settings.sessionStorageCurrentPage, e), window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, e), window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 1), n ? this.$wrapper.show() : this.$wrapper.hide()
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return u.a.isLoadPreviousPagePaginationType()
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element.unbind("click"), this.$element.on("click", this._onClickEvent.bind(this))
        }
      }, {
        key: "_onClickEvent",
        value: function (t) {
          t.preventDefault();
          var e = l.a.queryParams.page;
          if (null !== window.sessionStorage.getItem(this.settings.sessionStorageCurrentPreviousPage) ? this.currentPreviousPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentPreviousPage)) : this.currentPreviousPage = e, this.currentPreviousPage < 2) return this.$wrapper.hide(), !1;
          l.a.internalClick = !0, Ae.default.setParam("limit", this.settings.limit), this.currentPreviousPage--, window.sessionStorage.setItem(this.settings.sessionStorageCurrentPreviousPage, this.currentPreviousPage), window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 1), Ae.default.setParam("page", this.currentPreviousPage), Ae.default.applyFilter("page"), this.currentPreviousPage < 2 && this.$wrapper.hide()
        }
      }]) && Bn(n.prototype, i), c && Bn(n, c), e
    }(Tn.a);

    function Nn(t) {
      return (Nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Un(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function qn(t, e) {
      return !e || "object" !== Nn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Hn(t) {
      return (Hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Wn(t, e) {
      return (Wn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Gn = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), i = qn(this, Hn(e).call(this)), t || (t = s.a.searchPagePagination), i.type = n, i.$element = r()(t), i.$productList = r()(s.a.products), i.filterResult = i.parent, i
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Wn(t, e)
      }(e, t), n = e, (i = [{
        key: "isRender",
        value: function () {
          return l.a.hasOwnProperty("searchDisplay") && l.a.searchDisplay === this.type
        }
      }, {
        key: "render",
        value: function () {
          this.$element.html(this.compileTemplate())
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element.show(), this.$element.find("a").unbind("click"), this.$element.find("a").on("click", this._onClickEvent.bind(this))
        }
      }, {
        key: "setData",
        value: function (t, e, n, i) {
          t && (this.data = t);
          var r = this.parent.searchResultPanels.children,
            o = this.type;
          this.panelItem = r.find((function (t) {
            return t.type == o
          })), this.totalProduct = e, this.limit = n, this.page = i, this.paginationType = Settings.getSettingValue("general.paginationType")
        }
      }, {
        key: "_onClickEvent",
        value: function (t) {
          t.preventDefault(), l.a.internalClick = !0;
          var e = r()(t.currentTarget).attr("href");
          Ae.default.updateParamsFromUrl(e), Ae.default.setParam("limit", this.limit), Ae.default.getFilterData("search", this.panelItem._searchPanelCallback.bind(this.panelItem)), r()("body,html").animate({
            scrollTop: this.$productList.offset().top - 50
          }, 600)
        }
      }]) && Un(n.prototype, i), o && Un(n, o), e
    }(Le.a);

    function zn(t) {
      return (zn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Kn(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Yn(t, e) {
      return !e || "object" !== zn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Qn(t) {
      return (Qn = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Jn(t, e) {
      return (Jn = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Zn = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = Yn(this, Qn(e).call(this))).$productList = r()(s.a.products), t.$element = [], t.isFetchedProductData = !1, t.settings = {
          showPlaceholderProductList: o.a.getSettingValue("general.showPlaceholderProductList"),
          placeholderImageRatio: o.a.getSettingValue("general.placeholderImageRatio"),
          productGridClass: o.a.getSettingValue("custom.product_grid_class"),
          placeholderProductGridItemClass: o.a.getSettingValue("general.placeholderProductGridItemClass"),
          productsPerRow: o.a.getSettingValue("custom.products_per_row"),
          placeholderProductPerRow: o.a.getSettingValue("general.placeholderProductPerRow"),
          sessionStoragePreviousPageEvent: o.a.getSettingValue("general.sessionStoragePreviousPageEvent")
        }, t
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Jn(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          this.eventType = this.parent.eventType, Ae.default.addBeforeApplyFilter(this.renderBeforeApplyFilter.bind(this))
        }
      }, {
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<div class="{{wrapperClass}} {{class.filterProductSkeleton}}">\n\t\t\t\t<div class="{{class.filterProductSkeleton}}-image" style="padding-top: {{paddingTop}}%"></div>\n\t\t\t\t<div class="{{class.filterProductSkeleton}}-meta">\n\t\t\t\t\t<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}"></span>\n\t\t\t\t\t<span class="{{class.filterSkeletonText}} {{class.filterSkeleton}}-width1"></span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return void 0 !== l.a.queryParams.display && "grid" != l.a.queryParams.display && this.compileTemplateExtra ? this.compileTemplateExtra() : this.compileTemplateGridType()
        }
      }, {
        key: "compileTemplateGridType",
        value: function () {
          var t = parseFloat(this.settings.placeholderImageRatio),
            e = t > 0 ? t : 1.4,
            n = "";
          return "" == (n = this.settings.productGridClass && "" !== this.settings.productGridClass ? this.settings.productGridClass : this.settings.placeholderProductGridItemClass) && (n = this.$productList.find("> *").length > 0 ? this.$productList.find("> *").first().attr("class") : p.a.filterSkeleton + "-def-width"), this.getTemplate().replace(/{{class.filterProductSkeleton}}/g, p.a.filterProductSkeleton).replace(/{{class.filterSkeleton}}/g, p.a.filterSkeleton).replace(/{{class.filterSkeletonText}}/g, p.a.filterSkeletonText).replace(/{{paddingTop}}/g, 100 * e).replace(/{{wrapperClass}}/g, n)
        }
      }, {
        key: "compileTemplateExtra",
        value: function () {
          return !1
        }
      }, {
        key: "isRender",
        value: function () {
          return this.settings.showPlaceholderProductList && Pe.a.isPanelActive(Te.a.Enum.PRODUCT) && (!l.a.loadProductFirst || u.a.isSearchPage() || u.a.isVendorPage() || u.a.isTagPage() || u.a.isTypePage() || "best-selling" === l.a.defaultSorting && !o.a.getSettingValue("general.loadProductFirstBestSelling") || o.a.getSettingValue("general.productAndVariantAvailable") || o.a.getSettingValue("general.sortingAvailableFirst") || l.a.loadProductFirst && (l.a.hasFilterOptionParam || "init" != this.eventType))
        }
      }, {
        key: "render",
        value: function () {
          var t = this.settings.productsPerRow || this.settings.placeholderProductPerRow,
            e = this.compileTemplate();
          this.$element = [];
          for (var n = 0; n < t; n++) this.$element.push(r()(e));
          var i = this.parent.productList,
            o = i.settings.loadProductFromLiquid && i.settings.loadProductFromLiquidType == ProductList.Enum.loadProductType.AJAX;
          this.isFetchedProductData ? o && !i.isFetchedAjaxProductData || this.setHide() : this.setShow()
        }
      }, {
        key: "renderBeforeApplyFilter",
        value: function (t) {
          this.eventType = t, this.refresh()
        }
      }, {
        key: "setData",
        value: function (t) {
          t && this.isRender() && (this.isFetchedProductData = !0)
        }
      }, {
        key: "setShow",
        value: function () {
          this.$productList.addClass(p.a.productWrapLoading), this.$productList.css("min-height", this.$productList.height()), (u.a.isDefaultPaginationType() || !u.a.isDefaultPaginationType() && "page" !== this.eventType) && this.$productList.html(""), u.a.isLoadPreviousPagePaginationType() && parseInt(window.sessionStorage.getItem(this.settings.sessionStoragePreviousPageEvent)) ? this.$productList.prepend(this.$element) : this.$productList.append(this.$element)
        }
      }, {
        key: "setHide",
        value: function () {
          var t = this;
          this.$productList.find("." + p.a.filterProductSkeleton).remove(), setTimeout((function () {
            t.$productList.removeClass(p.a.productWrapLoading), t.$productList.css("min-height", 0)
          })), this.isFetchedProductData = !1
        }
      }]) && Kn(n.prototype, i), a && Kn(n, a), e
    }(f.a);

    function Xn(t) {
      return (Xn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ti(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ei(t, e) {
      return !e || "object" !== Xn(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ni(t) {
      return (ni = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ii(t, e) {
      return (ii = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }

    function ri(t) {
      return (ri = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function oi(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ai(t, e) {
      return !e || "object" !== ri(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function li(t) {
      return (li = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function si(t, e) {
      return (si = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ci = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), ai(this, li(e).call(this))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && si(t, e)
      }(e, t), n = e, r = [{
        key: "Enum",
        get: function () {
          return {
            tempType: {
              ITEM: "collection_item",
              IMAGE: "image"
            }
          }
        }
      }], (i = [{
        key: "getTemplate",
        value: function (t) {
          switch (t) {
          case e.Enum.tempType.IMAGE:
            return '\n\t\t\t\t\t<div class="{{class.filterResultItem}}-image">\n\t\t\t\t\t\t<img src="{{itemThumbSrc}}" alt="{{itemTitle}}" />\n\t\t\t\t\t</div>\n\t\t\t\t';
          default:
            return '\n\t\t\t\t\t<div class="{{class.filterResultItem}} {{class.filterResultItem}}-collection">\n\t\t\t\t\t\t<a href="{{itemUrl}}" aria-label="{{itemTitle}}" title="{{itemTitle}}">\n\t\t\t\t\t\t\t{{itemThumbnail}}\n\t\t\t\t\t\t\t<div class="{{class.filterResultItem}}-content">\n\t\t\t\t\t\t\t\t<h3 class="{{class.filterResultItem}}-title">{{itemTitle}}</h3>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t'
          }
        }
      }]) && oi(n.prototype, i), r && oi(n, r), e
    }(function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = ei(this, ni(e).call(this))).data = null, t.id = null, t.index = 0, t.$element = null, t.displayImage = !0, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ii(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {
          var t = "/collections/" + this.data.handle,
            e = "",
            n = "";
          return this.displayImage && (this.data.image && this.data.image.hasOwnProperty("src") && "" !== this.data.image.src && (n = u.a.optimizeImage(this.data.image.src, "200x")), n.length > 0 && (e = this.getTemplate(ci.Enum.tempType.IMAGE))), this.getTemplate().replace(/{{itemThumbnail}}/g, e).replace(/{{itemThumbSrc}}/g, n).replace(/{{class.filterResultItem}}/g, p.a.filterResultItem).replace(/{{itemUrl}}/g, t).replace(/{{itemTitle}}/g, u.a.escape(this.data.title))
        }
      }, {
        key: "render",
        value: function () {
          this.$element = r()(this.compileTemplate())
        }
      }, {
        key: "setData",
        value: function (t, e) {
          this.data = t, this.id = t.id, this.index = e, this.displayImage = this.parent.panelData.hasOwnProperty("displayImage") && this.parent.panelData.displayImage
        }
      }]) && ti(n.prototype, i), o && ti(n, o), e
    }(f.a));

    function ui(t) {
      return (ui = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function pi(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function fi(t, e) {
      return !e || "object" !== ui(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function hi(t) {
      return (hi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function yi(t, e) {
      return (yi = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var di = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = fi(this, hi(e).call(this))).$element = r()(s.a.collections), t.data = null, t.totalCollection = 0, t.settings = {
          searchPanelBlocks: Settings.getSettingValue("search.searchPanelBlocks")
        }, t.panelData = {}, t.settings.searchPanelBlocks.hasOwnProperty(Te.a.Enum.COLLECTION) && (t.panelData = t.settings.searchPanelBlocks[Te.a.Enum.COLLECTION]), t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && yi(t, e)
      }(e, t), n = e, (i = [{
        key: "isRender",
        value: function () {
          return null != this.data && Pe.a.isPanelActive(Te.a.Enum.COLLECTION)
        }
      }, {
        key: "render",
        value: function () {
          var t = [];
          this.collectionItems.forEach((function (e) {
            t.push(e.$element)
          })), this.$element.html(""), this.$element.append(t)
        }
      }, {
        key: "setData",
        value: function (t) {
          var e = this;
          t && t.collections && t.collections.length && (this.data = t.collections, this.totalCollection = t.total_collection ? t.total_collection : 0, this.collectionItems = [], this.data.forEach((function (t, n) {
            var i = new ci;
            e.addComponent(i), i.setData(t), e.collectionItems.push(i)
          })))
        }
      }]) && pi(n.prototype, i), o && pi(n, o), e
    }(f.a);

    function gi(t) {
      return (gi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function mi(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function bi(t, e) {
      return !e || "object" !== gi(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function vi(t) {
      return (vi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Si(t, e) {
      return (Si = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }

    function Oi(t) {
      return (Oi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ti(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Pi(t, e) {
      return !e || "object" !== Oi(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function wi(t) {
      return (wi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function _i(t, e) {
      return (_i = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ci = function (t) {
      function e() {
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), Pi(this, wi(e).call(this))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && _i(t, e)
      }(e, t), n = e, r = [{
        key: "Enum",
        get: function () {
          return {
            tempType: {
              ITEM: "page_item",
              IMAGE: "image"
            }
          }
        }
      }], (i = [{
        key: "getTemplate",
        value: function (t) {
          switch (t) {
          case e.Enum.tempType.IMAGE:
            return '\n\t\t\t\t\t<div class="{{class.filterResultItem}}-image">\n\t\t\t\t\t\t<img src="{{itemThumbSrc}}" alt="{{itemTitle}}" />\n\t\t\t\t\t</div>\n\t\t\t\t';
          default:
            return '\n\t\t\t\t\t<div class="{{class.filterResultItem}} {{class.filterResultItem}}-page">\n\t\t\t\t\t\t<a href="{{itemUrl}}" aria-label="{{itemTitle}}" title="{{itemTitle}}">\n\t\t\t\t\t\t\t{{itemThumbnail}}\n\t\t\t\t\t\t\t<div class="{{class.filterResultItem}}-content">\n\t\t\t\t\t\t\t\t<h3 class="{{class.filterResultItem}}-title">{{itemTitle}}</h3>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t'
          }
        }
      }]) && Ti(n.prototype, i), r && Ti(n, r), e
    }(function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = bi(this, vi(e).call(this))).data = null, t.id = null, t.index = 0, t.$element = null, t.displayImage = !0, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Si(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {
          var t = this.data.hasOwnProperty("url") ? this.data.url : "#",
            e = "",
            n = "";
          return this.displayImage && (this.data.image && this.data.image.hasOwnProperty("src") && "" !== this.data.image.src && (n = u.a.optimizeImage(this.data.image.src, "200x")), n.length > 0 && (e = this.getTemplate(Ci.Enum.tempType.IMAGE))), this.getTemplate().replace(/{{itemThumbnail}}/g, e).replace(/{{itemThumbSrc}}/g, n).replace(/{{class.filterResultItem}}/g, p.a.filterResultItem).replace(/{{itemUrl}}/g, t).replace(/{{itemTitle}}/g, u.a.escape(this.data.title))
        }
      }, {
        key: "render",
        value: function () {
          this.$element = r()(this.compileTemplate())
        }
      }, {
        key: "setData",
        value: function (t, e) {
          this.data = t, this.id = t.id, this.index = e, this.displayImage = this.parent.panelData.hasOwnProperty("displayImage") && this.parent.panelData.displayImage
        }
      }]) && mi(n.prototype, i), o && mi(n, o), e
    }(f.a));

    function ki(t) {
      return (ki = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ei(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ii(t, e) {
      return !e || "object" !== ki(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Li(t) {
      return (Li = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ai(t, e) {
      return (Ai = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Fi = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = Ii(this, Li(e).call(this))).$element = r()(s.a.pages), t.data = null, t.totalPage = 0, t.settings = {
          searchPanelBlocks: Settings.getSettingValue("search.searchPanelBlocks")
        }, t.panelData = {}, t.settings.searchPanelBlocks.hasOwnProperty(Te.a.Enum.PAGE) && (t.panelData = t.settings.searchPanelBlocks[Te.a.Enum.PAGE]), t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ai(t, e)
      }(e, t), n = e, (i = [{
        key: "isRender",
        value: function () {
          return null != this.data && Pe.a.isPanelActive(Te.a.Enum.PAGE)
        }
      }, {
        key: "render",
        value: function () {
          var t = [];
          this.pageItems.forEach((function (e) {
            t.push(e.$element)
          })), this.$element.html(""), this.$element.append(t)
        }
      }, {
        key: "setData",
        value: function (t) {
          var e = this;
          t && t.pages && t.pages.length && (this.data = t.pages, this.totalPage = t.total_page ? t.total_page : 0, this.pageItems = [], this.data.forEach((function (t, n) {
            var i = new Ci;
            e.addComponent(i), i.setData(t), e.pageItems.push(i)
          })))
        }
      }]) && Ei(n.prototype, i), o && Ei(n, o), e
    }(f.a);

    function Ri(t) {
      return (Ri = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ji(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function $i(t, e) {
      return !e || "object" !== Ri(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Bi(t) {
      return (Bi = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function xi(t, e) {
      return (xi = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Mi = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = $i(this, Bi(e).call(this))).$element = r()(s.a.searchTotalResult), t.total = 0, t.panalType = Te.a.Enum.PRODUCT, t
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && xi(t, e)
      }(e, t), n = e, (i = [{
        key: "compileTemplate",
        value: function () {
          return (this.total > 1 ? a.a.search.searchTotalResults : a.a.search.searchTotalResult).replace(/{{ count }}/g, "<strong>" + this.total + "</strong>")
        }
      }, {
        key: "render",
        value: function () {
          var t = this.compileTemplate();
          this.$element.html(t)
        }
      }, {
        key: "setData",
        value: function (t, e) {
          "number" == typeof t && (this.total = t), e && (this.panalType = e)
        }
      }]) && ji(n.prototype, i), o && ji(n, o), e
    }(f.a);

    function Di(t) {
      return (Di = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Vi(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ni(t, e) {
      return !e || "object" !== Di(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Ui(t) {
      return (Ui = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function qi(t, e) {
      return (qi = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Hi = function (t) {
        function e() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (t = Ni(this, Ui(e).call(this))).data = null, t.productList = null, t.totalProduct = 0, t.pagination = "", t.sorting = "", t.breadcrumbs = "", t.eventType = "", t.displayType = "", t.$element = r()(s.a.products), t.settngs = {
            paginationType: o.a.getSettingValue("general.paginationType")
          }, t
        }
        var n, i, a;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && qi(t, e)
        }(e, t), n = e, (i = [{
          key: "init",
          value: function () {
            this.productPlaceholder = new Zn, this.addComponent(this.productPlaceholder), this.productList = new Ie, this.addComponent(this.productList);
            var t = this._getProductPaginationClass();
            this.pagination = new t, this.addComponent(this.pagination), u.a.isLoadPreviousPagePaginationType() && (this.loadPrevious = new Vn, this.addComponent(this.loadPrevious)), this.sorting = new qe, this.addComponent(this.sorting), this.limit = new Ye, this.addComponent(this.limit), this.displayType = new xe, this.addComponent(this.displayType);
            var e = this._getPageInfoClass();
            this.pageInfo = new e, this.addComponent(this.pageInfo), this.rebotsMeta = new On, this.addComponent(this.rebotsMeta), u.a.isSearchPage() && (this.searchResultPanels = new Pe.a, this.addComponent(this.searchResultPanels), this.collectionList = new di, this.addComponent(this.collectionList), this.collectionListPagination = new Gn(s.a.searchCollectionPagination, Te.a.Enum.COLLECTION), this.addComponent(this.collectionListPagination), this.pageList = new Fi, this.addComponent(this.pageList), this.pageListPagination = new Gn(s.a.searchPagePagination, Te.a.Enum.PAGE), this.addComponent(this.pageListPagination), this.searchResultTotal = new Mi, this.addComponent(this.searchResultTotal))
          }
        }, {
          key: "isRender",
          value: function () {
            return this.parent.isFetchedProductData
          }
        }, {
          key: "setData",
          value: function (t) {
            this.data = t, this.totalProduct = t.total_product, this.eventType = t.event_type, this.productList.setData(t.products), this.pagination.setData(t), this.loadPrevious && this.loadPrevious.setData(t), u.a.isSearchPage() && (this.searchResultPanels.setData(t, this.eventType), this.collectionList.setData(t, this.eventType), this.pageList.setData(t, this.eventType), t.hasOwnProperty("total_product") && this.searchResultTotal.setData(t.total_product)), this.productPlaceholder.setData(t), this.pageInfo.setData(t)
          }
        }, {
          key: "_getProductPaginationClass",
          value: function () {
            switch (o.a.getSettingValue("general.paginationType")) {
            case Tn.a.Type.DEFAULT:
              return Le.a;
            case Tn.a.Type.LOAD_MORE:
              return En;
            default:
              return jn
            }
          }
        }, {
          key: "_getPageInfoClass",
          value: function () {
            return u.a.isSearchPage() ? en : dn
          }
        }]) && Vi(n.prototype, i), a && Vi(n, a), e
      }(f.a),
      Wi = n(5);

    function Gi(t) {
      return (Gi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function zi(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ki(t) {
      return (Ki = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Yi(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t
    }

    function Qi(t, e) {
      return (Qi = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ji = function (t) {
      function e(t) {
        var n, i, r;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), i = this, (n = !(r = Ki(e).call(this)) || "object" !== Gi(r) && "function" != typeof r ? Yi(i) : r).filterTree = t, n.filterTree.mobileButton = Yi(n), n.isCollapsed = !0, n.label = a.a.refineMobile, n.$element = null, n
      }
      var n, i, l;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Qi(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t\t<button type="button">{{label}}</button>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{filterTreeMobileButton}}/g, p.a.filterTreeMobileButton).replace(/{{label}}/g, this.label)
        }
      }, {
        key: "render",
        value: function () {
          this.$element || (this.$element = r()(this.compileTemplate())), this.parent.isFetchedFilterData && (this.filterTree.filterOptions.size > 0 || this.$element.hide())
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvent
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element && this.filterTree && this.$element.on("click", this.onClick.bind(this))
        }
      }, {
        key: "onClick",
        value: function () {
          "function" == typeof this.filterTree.onClickMobileButton ? this.filterTree.onClickMobileButton() : this.toggleFilterTree(), r()("body").toggleClass(p.a.filterTreeOpenBody)
        }
      }, {
        key: "toggleFilterTree",
        value: function () {
          var t = r()("#" + this.filterTree.id);
          t && !t.hasClass("toggling") && (this.isCollapsed = !this.isCollapsed, o.a.getSettingValue("general.changeMobileButtonLabel") && (this.label = this.isCollapsed ? a.a.refineMobile : a.a.refineMobileCollapse, this.$element.text(this.label)), t.slideToggle(400, this.afterToggleFilterTree.bind(this)))
        }
      }, {
        key: "afterToggleFilterTree",
        value: function () {
          this.isCollapsed || this.filterTree.filterOptions.forEach((function (t) {
            t.displayType != Wi.a.DisplayType.BOX || t.isCollapsed || t.filterItems.forEach((function (t) {
              t.setBoxItemSize()
            }))
          }))
        }
      }]) && zi(n.prototype, i), l && zi(n, l), e
    }(f.a);

    function Zi(t) {
      return (Zi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Xi(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function tr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function er(t, e) {
      return !e || "object" !== Zi(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function nr(t) {
      return (nr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ir(t, e) {
      return (ir = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var rr = function (t) {
      function e() {
        return Xi(this, e), er(this, nr(e).apply(this, arguments))
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ir(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<div class="boost-pfs-filter-loading" style="display: none;"><span class="boost-pfs-filter-loading-icon"></span></div>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate()
        }
      }, {
        key: "setShow",
        value: function (t) {
          this.$element || (this.$element = r()(this.compileTemplate()), r()("body").append(this.$element)), this.isEnabled() && (t ? this.$element.show() : this.$element.hide())
        }
      }, {
        key: "isEnabled",
        value: function () {
          var t = u.a.isMobile();
          return !t && o.a.getSettingValue("general.showLoading") || t && o.a.getSettingValue("general.showMobileLoading")
        }
      }]) && tr(n.prototype, i), a && tr(n, a), e
    }(f.a);

    function or(t) {
      return (or = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ar(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function lr(t, e) {
      return !e || "object" !== or(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function sr(t) {
      return (sr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function cr(t, e) {
      return (cr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ur = function (t) {
        function e() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (t = lr(this, sr(e).call(this))).style = o.a.getSettingValue("general.styleScrollToTop"), t.$element = null, t
        }
        var n, i, a;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && cr(t, e)
        }(e, t), n = e, (i = [{
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<a href="javascript:void(0)" aria-label="Back to top" class="boost-pfs-filter-scroll-to-top {{style}}" style="display: inline;"></a>\n\t\t'
          }
        }, {
          key: "compileTemplate",
          value: function () {
            return this.getTemplate().replace(/{{style}}/g, this.style)
          }
        }, {
          key: "isRender",
          value: function () {
            return !this.$element
          }
        }, {
          key: "render",
          value: function () {
            !this.$element && this.isShow() && (this.$element = r()(this.compileTemplate()), r()("body").append(this.$element))
          }
        }, {
          key: "isBindEvents",
          value: function () {
            return !this.isBoundEvent
          }
        }, {
          key: "bindEvents",
          value: function () {
            this.$element && (this.$element.on("click", this.scrollToTop.bind(this)), r()(document).scroll(this.setVisibility.bind(this)))
          }
        }, {
          key: "scrollToTop",
          value: function () {
            r()("html,body").stop().animate({
              scrollTop: 0
            })
          }
        }, {
          key: "setVisibility",
          value: function () {
            r()(document).scrollTop() > 100 ? this.$element.show() : this.$element.hide()
          }
        }, {
          key: "isShow",
          value: function () {
            return o.a.getSettingValue("general.activeScrollToTop")
          }
        }]) && ar(n.prototype, i), a && ar(n, a), e
      }(f.a),
      pr = {
        FilterTreeType: {
          VERTICAL: "vertical",
          HORIZONTAL: "horizontal"
        }
      };
    n(56), n(49), n(50), n(199), n(130), n(98), n(200), n(55);

    function fr(t) {
      return (fr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function hr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function yr(t, e) {
      return !e || "object" !== fr(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function dr(t) {
      return (dr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function gr(t, e) {
      return (gr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var mr = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = yr(this, dr(e).call(this))).filterTreeType = t, i.clearType = n, i.requestInstantly = !0, i.label = i.clearType == e.ClearType.CLEAR_ALL ? a.a.clearAll : a.a.clear, i
      }
      var n, i, s;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && gr(t, e)
      }(e, t), n = e, s = [{
        key: "ClearType",
        get: function () {
          return {
            CLEAR_SINGLE_VALUE: "clear-single-value",
            CLEAR_OPTION_VALUES: "clear-option-values",
            CLEAR_ALL: "clear-all"
          }
        }
      }], (i = [{
        key: "getTemplate",
        value: function () {
          switch (this.clearType) {
          case e.ClearType.CLEAR_SINGLE_VALUE:
            return '\n\t\t\t\t\t<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearButton}}"></button>\n\t\t\t\t';
          case e.ClearType.CLEAR_OPTION_VALUES:
            return '\n\t\t\t\t\t<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearButton}}">{{label}}</button>\n\t\t\t\t';
          case e.ClearType.CLEAR_ALL:
            return '\n\t\t\t\t\t<button aria-label="{{adaLabel}}" class="{{class.button}} {{class.clearAllButton}}">{{label}}</button>\n\t\t\t\t';
          default:
            throw Error("Wrong filter clear type")
          }
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.buildAdaLabel(), this.getTemplate().replace(/{{label.clear}}/g, a.a.clear).replace(/{{class.button}}/g, p.a.button).replace(/{{class.clearButton}}/g, p.a.clearButton).replace(/{{class.clearAllButton}}/g, p.a.clearAllButton).replace(/{{adaLabel}}/g, this.adaLabel).replace(/{{label}}/g, this.label)
        }
      }, {
        key: "render",
        value: function () {
          this.$element || (this.$element = r()(this.compileTemplate())), this.isVisible() ? this.$element.show() : this.$element.hide()
        }
      }, {
        key: "buildAdaLabel",
        value: function () {
          switch (this.adaLabel = "", this.clearType) {
          case e.ClearType.CLEAR_SINGLE_VALUE:
            var t = this.parent;
            t && t.type && t.label && (this.adaLabel = a.a.ada.clearFilterItem.replace(/{{filterOption}}/g, t.type).replace(/{{filterItem}}/g, t.label));
            break;
          case e.ClearType.CLEAR_OPTION_VALUES:
            var n = this.parent;
            n && n.label && (this.adaLabel = a.a.ada.clearFilterOption.replace(/{{filterOption}}/g, n.label));
            break;
          case e.ClearType.CLEAR_ALL:
            this.adaLabel = a.a.ada.clearAllFilterItems
          }
        }
      }, {
        key: "isVisible",
        value: function () {
          var t = !0;
          switch (this.clearType) {
          case e.ClearType.CLEAR_OPTION_VALUES:
            var n = this.parent;
            if (n.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS) {
              var i = n.filterOptionId.replace(l.a.prefix + "_c_", l.a.prefix + "_ct_");
              t = l.a.queryParams[n.filterOptionId] || l.a.queryParams[i]
            } else t = l.a.queryParams[n.filterOptionId];
            break;
          case e.ClearType.CLEAR_ALL:
            t = !1, Object.keys(l.a.queryParams).forEach((function (e) {
              if (e.startsWith(l.a.prefix)) {
                var n = l.a.queryParams[e];
                u.a.isSearchPage() && e.startsWith(l.a.prefix + "_c_") && 0 == n || (t = !0)
              }
            }))
          }
          return !!t
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvent
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element && this.$element.on("click", this.onClick.bind(this))
        }
      }, {
        key: "onClick",
        value: function (t) {
          if (t && t.preventDefault(), this.requestInstantly) switch (this.clearType) {
          case e.ClearType.CLEAR_SINGLE_VALUE:
            this.onClearSingleValue();
            break;
          case e.ClearType.CLEAR_OPTION_VALUES:
            this.onClearOptionValues();
            break;
          case e.ClearType.CLEAR_ALL:
            this.onClearAll()
          } else switch (this.clearType) {
          case e.ClearType.CLEAR_OPTION_VALUES:
            this.onDeselectOptionValues()
          }
        }
      }, {
        key: "onClearSingleValue",
        value: function () {
          var t = this.parent,
            e = t.filterOptionId,
            n = t.filterItemId,
            i = l.a.queryParams[e];
          if (null != i) {
            Array.isArray(i) || (i = [i]);
            var r = i.indexOf(n),
              o = [];
            if (r > -1 && (o = i.filter((function (t, e) {
                return e != r
              }))), 0 == o.length ? (Ae.default.setParam(e, null), Ae.default.setParam(e + "_and_condition", null), Ae.default.setParam(e + "_show_exact_rating", null), Ae.default.setParam(e + "_exclude_from_value", null)) : Ae.default.setParam(e, o), u.a.isSearchPage() && e.startsWith(l.a.prefix + "_ct_")) {
              var a = e.replace(l.a.prefix + "_ct_", l.a.prefix + "_c_");
              Ae.default.setParam(a, null)
            }
            Ae.default.setParam("page", 1);
            var s = {
              filterOptionId: e,
              filterOptionValue: n
            };
            Ae.default.applyFilter("clear", s)
          }
        }
      }, {
        key: "onClearOptionValues",
        value: function () {
          var t = this.parent;
          t.filterTreeType == pr.FilterTreeType.HORIZONTAL && !o.a.getSettingValue("general.keepTabOpenState") && t.collapse && this.parent.collapse.onToggleHorizontal(), l.a.internalClick = !0;
          var e = t.filterOptionId;
          t.displayType != Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS || u.a.isSearchPage() || (e = e.replace(l.a.prefix + "_c_", l.a.prefix + "_ct_"));
          var n = {
            filterOptionId: e
          };
          Ae.default.setParam("page", 1), Ae.default.setParam(e, null), Ae.default.setParam(e + "_and_condition", null), Ae.default.setParam(e + "_show_exact_rating", null), Ae.default.setParam(e + "_exclude_from_value", null), Ae.default.applyFilter("clear", n)
        }
      }, {
        key: "onClearAll",
        value: function () {
          var t = [];
          Object.keys(l.a.queryParams).forEach((function (e) {
            e.startsWith(l.a.prefix) && t.push(e)
          })), t.forEach((function (t) {
            Ae.default.setParam(t, null)
          })), Ae.default.setParam("page", 1), Ae.default.applyFilter("clearAll", {})
        }
      }, {
        key: "onDeselectOptionValues",
        value: function () {
          this.parent.filterItems && this.parent.filterItems.forEach((function (t) {
            t.$element.removeClass("selected"), t.isSelected = !1
          }))
        }
      }]) && hr(n.prototype, i), s && hr(n, s), e
    }(f.a);

    function br(t) {
      return (br = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function vr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Sr(t, e) {
      return !e || "object" !== br(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Or(t) {
      return (Or = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Tr(t, e) {
      return (Tr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Pr = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = Sr(this, Or(e).call(this))).filterTreeType = t || pr.FilterTreeType.HORIZONTAL, i.applyType = n || e.ApplyType.APPLY_OPTION_VALUES, i
      }
      var n, i, l;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Tr(t, e)
      }(e, t), n = e, l = [{
        key: "ApplyType",
        get: function () {
          return {
            APPLY_OPTION_VALUES: "apply-option-values",
            APPLY_ALL: "apply-all"
          }
        }
      }], (i = [{
        key: "init",
        value: function () {
          this.label = this.filterTreeType == pr.FilterTreeType.HORIZONTAL && o.a.getSettingValue("general.requestInstantly") ? a.a.close : a.a.apply
        }
      }, {
        key: "getTemplate",
        value: function () {
          return this.applyType == e.ApplyType.APPLY_ALL ? '\n\t\t\t\t<button class="{{class.button}} {{class.applyAllButton}}">{{label.applyAll}}</button>\n\t\t\t' : '\n\t\t\t\t<button class="{{class.button}} {{class.applyButton}}">{{label.apply}}</button>\n\t\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{label.apply}}/g, this.label).replace(/{{label.applyAll}}/g, a.a.applyAll).replace(/{{class.button}}/g, p.a.button).replace(/{{class.applyButton}}/g, p.a.applyButton).replace(/{{class.applyAllButton}}/g, p.a.applyAllButton)
        }
      }, {
        key: "isRender",
        value: function () {
          return !(this.parent.filterType == Wi.a.FilterType.COLLECTION)
        }
      }, {
        key: "render",
        value: function () {
          this.$element || (this.$element = r()(this.compileTemplate()))
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvent
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element && this.$element.on("click", this.onClick.bind(this))
        }
      }, {
        key: "onClick",
        value: function (t) {
          if (t && t.preventDefault(), this.applyType == e.ApplyType.APPLY_ALL) this.onApplyAll();
          else {
            if (this.filterTreeType == pr.FilterTreeType.HORIZONTAL && (!o.a.getSettingValue("general.keepTabOpenState") && this.parent.collapse && this.parent.collapse.onToggleHorizontal(), o.a.getSettingValue("general.requestInstantly"))) return;
            this.onApplyOptionValues()
          }
        }
      }, {
        key: "onApplyOptionValues",
        value: function () {
          var t = [],
            e = this.parent.filterOptionId,
            n = this.parent.filterItems;
          this.parent.displayType == Wi.a.DisplayType.MULTI_LEVEL_TAG && (n = this.parent.allNestedFilterItems), n.forEach((function (e) {
            e.isSelected && t.push(e.value)
          })), Ae.default.setParam(e, t), Ae.default.setParam(e + "_and_condition", !!(this.parent.useAndCondition && t.length > 0) || null), Ae.default.setParam(e + "_show_exact_rating", !!(this.parent.showExactRating && t.length > 0) || null), Ae.default.setParam(e + "_exclude_from_value", !!(this.parent.excludePriceFromValue && t.length > 0) || null), Ae.default.setParam("page", 1);
          var i = {
            filterOptionId: e,
            filterOptionValue: t
          };
          Ae.default.applyFilter("filter", i)
        }
      }, {
        key: "onApplyAll",
        value: function () {
          this.filterTreeType == pr.FilterTreeType.HORIZONTAL && (this.parent.filterOptions && this.parent.filterOptions.forEach((function (t) {
            t.collapse && !t.collapse.isCollapsed && t.collapse.onToggleHorizontal()
          })), o.a.getSettingValue("general.requestInstantly")) || (this.parent.filterOptions && this.parent.filterOptions.forEach((function (t) {
            var e = [],
              n = t.filterOptionId;
            (t.displayType == Wi.a.DisplayType.MULTI_LEVEL_TAG ? t.allNestedFilterItems : t.filterItems).forEach((function (t) {
              t.isSelected && e.push(t.value)
            })), Ae.default.setParam(n, e), Ae.default.setParam(n + "_and_condition", !!(t.useAndCondition && e.length > 0) || null), Ae.default.setParam(n + "_show_exact_rating", !!(t.showExactRating && e.length > 0) || null), Ae.default.setParam(n + "_exclude_from_value", !!(t.excludePriceFromValue && e.length > 0) || null)
          })), Ae.default.setParam("page", 1), Ae.default.applyFilter("filter"))
        }
      }]) && vr(n.prototype, i), l && vr(n, l), e
    }(f.a);
    n(148);

    function wr(t) {
      return (wr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function _r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Cr(t, e) {
      return !e || "object" !== wr(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function kr(t) {
      return (kr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Er(t, e) {
      return (Er = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ir = function (t) {
      function e(t) {
        var n;
        if (function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), n = Cr(this, kr(e).call(this)), !t) throw Error("Pass filterTreeType into FilterOptionItem constructor.");
        return n.requestInstantly = !0, n.filterTreeType = t, n.$element = null, n.settings = {
          enable3rdCurrencySupport: o.a.getSettingValue("general.enable3rdCurrencySupport")
        }, n
      }
      var n, i, s;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Er(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          this.requestInstantly = this.filterTreeType == pr.FilterTreeType.VERTICAL || o.a.getSettingValue("general.requestInstantly")
        }
      }, {
        key: "getTemplate",
        value: function () {
          throw Error("Override this method")
        }
      }, {
        key: "compileTemplate",
        value: function () {
          throw Error("Override this method")
        }
      }, {
        key: "isRender",
        value: function () {
          var t = this.filterOption ? this.filterOption : this.parent,
            e = this.hasOwnProperty("docCount") && (this.docCount > 0 || null === this.docCount),
            n = t.filterType == Wi.a.FilterType.REVIEW_RATINGS && t.showExactRating,
            i = t.filterType == Wi.a.FilterType.COLLECTION && (t.keepValuesStatic || "all" == this.handle),
            r = t.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS && 1 != this.level,
            a = o.a.getSettingValue("general.showOutOfStockOption");
          return n || i || r || e || a
        }
      }, {
        key: "render",
        value: function () {
          this.$element || (this.$element = r()(this.compileTemplate())), this.isSelected = this.isAppliedFilter(), this.isSelected ? (this.$element.addClass("selected"), this.$element.find("button").attr("aria-checked", !0)) : (this.$element.removeClass("selected"), this.$element.find("button").removeAttr("aria-checked"))
        }
      }, {
        key: "buildCount",
        value: function () {
          var t = "";
          if (o.a.getSettingValue("general.showFilterOptionCount") && "box" != this.parent.displayType) {
            var e = !1;
            (this.docCount > 0 || o.a.getSettingValue("general.showOutOfStockOption") || this.parent.filterType == Wi.a.FilterType.REVIEW_RATINGS && this.parent.showExactRating) && (e = !0);
            var n = "all" == this.handle && 0 == this.docCount;
            !e || this.parent.keepValuesStatic || n || (t = "(" + this.docCount + ")")
          }
          return t
        }
      }, {
        key: "buildLabel",
        value: function () {
          var t = this.filterOption ? this.filterOption : this.parent,
            e = this.label,
            n = t.prefix;
          return "string" != typeof e ? "" : ("string" == typeof n && (n = n.replace(/\\/g, ""), e = e.replace(n, "").trim()), e = u.a.stripScriptTag(e), this.settings.enable3rdCurrencySupport || (e = u.a.stripHtml(e)), e.indexOf("boost-pfs-filter-icon-star") > -1 ? e : (t.displayAllValuesInUppercaseForm = t.displayAllValuesInUppercaseForm || !1, t.displayAllValuesInUppercaseForm ? e.toUpperCase() : o.a.getSettingValue("general.forceCapitalizeFilterOptionValues") ? u.a.capitalize(e, !0) : o.a.getSettingValue("general.capitalizeFirstLetterFilterOptionValues") ? u.a.capitalize(e, !0, !0) : o.a.getSettingValue("general.capitalizeFilterOptionValues") ? u.a.capitalize(e) : e))
        }
      }, {
        key: "buildPercentSaleLabel",
        value: function () {
          return this.from ? this.to ? this.from + "% - " + this.to + "%" : a.a.above + " " + this.from + "%" : a.a.under + " " + this.to + "%"
        }
      }, {
        key: "buildPriceListLabel",
        value: function () {
          return this.from ? this.to ? u.a.formatMoney(this.from, l.a.moneyFormat, !0) + " - " + u.a.formatMoney(this.to, l.a.moneyFormat, !0) : a.a.above + " " + u.a.formatMoney(this.from, l.a.moneyFormat, !0) : a.a.under + " " + u.a.formatMoney(this.to, l.a.moneyFormat, !0)
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvent
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element && this.$element.on("click", this.onClick.bind(this))
        }
      }, {
        key: "onClick",
        value: function (t) {
          t && t.preventDefault(), this.isDisabled() || (this.requestInstantly || this.parent.filterType == Wi.a.FilterType.COLLECTION ? this.onApplyFilter() : this.onSelectFilter())
        }
      }, {
        key: "isDisabled",
        value: function () {
          return this.parent.filterType == Wi.a.FilterType.COLLECTION ? !this.parent.keepValuesStatic && "all" != this.handle && 0 == this.docCount : 0 == this.docCount
        }
      }, {
        key: "isAppliedFilter",
        value: function () {
          var t = this.parent.filterOptionId;
          if (this.parent.filterType == Wi.a.FilterType.COLLECTION) {
            if (l.a.queryParams.collection_scope == this.collectionId) return !0
          } else {
            var e = l.a.queryParams[t];
            if (Array.isArray(e) && e.includes(this.value)) return !0
          }
          return !1
        }
      }, {
        key: "onSelectFilter",
        value: function () {
          var t = this;
          this.isSelected = !this.isSelected, this.$element.toggleClass("selected"), this.isSelected ? this.$element.find("button").attr("aria-checked", !0) : this.$element.find("button").removeAttr("aria-checked"), this.isSelected && this.parent.selectType == Wi.a.SelectType.SINGLE && this.parent.filterItems.forEach((function (e) {
            e != t && (e.$element && (e.$element.removeClass("selected"), t.$element.find("button").removeAttr("aria-checked")), e.isSelected = !1)
          }))
        }
      }, {
        key: "onApplyFilter",
        value: function () {
          var t = this,
            e = this.parent.filterType,
            n = this.parent.displayType,
            i = this.parent.selectType,
            r = this.parent.filterOptionId,
            o = "all" == this.handle && 0 == this.docCount && e == Wi.a.FilterType.COLLECTION;
          if (this.docCount > 0 || this.parent.keepValuesStatic || n == Wi.a.DisplayType.RANGE || o) {
            l.a.internalClick = !0;
            var a = "";
            if (e == Wi.a.FilterType.COLLECTION) {
              this.isSelected = !0, l.a.collectionId = this.collectionId, Ae.default.setParam("collection_scope", this.collectionId), u.a.isSearchPage() ? Ae.default.setParam(r, this.collectionId) : (c.a.setAddressBarPathAfterFilter("/collections/" + this.handle), c.a.setWindowTitleAfterFilter(this.label + " - " + l.a.shopName), Ae.default.setParam("sort", this.sortOrder));
              var s = [];
              Object.keys(l.a.queryParams).forEach((function (t) {
                t.startsWith(l.a.prefix) && !t.startsWith(l.a.prefix + "_c") && s.push(t)
              })), s.forEach((function (t) {
                Ae.default.setParam(t, null)
              })), a = "collection"
            } else {
              this.isSelected = !this.isSelected;
              var p = null;
              i == Wi.a.SelectType.SINGLE ? p = this.isSelected ? [this.value] : [] : (p = l.a.queryParams[r], Array.isArray(p) || (p = []), this.isSelected ? p.includes(this.value) || p.push(this.value) : p = p.filter((function (e) {
                return e !== t.value
              }))), Ae.default.setParam(r, p), Ae.default.setParam(r + "_and_condition", !!(this.parent.useAndCondition && p.length > 0) || null), Ae.default.setParam(r + "_show_exact_rating", !!(this.parent.showExactRating && p.length > 0) || null), Ae.default.setParam(r + "_exclude_from_value", !!(this.parent.excludePriceFromValue && p.length > 0) || null), a = "filter"
            }
            Ae.default.setParam("page", 1);
            var f = {
              filterOptionId: r,
              filterValue: this.value
            };
            Ae.default.applyFilter(a, f)
          }
        }
      }, {
        key: "setData",
        value: function (t) {
          switch (this.value = t.key, this.label = t.key, this.docCount = t.doc_count ? t.doc_count : 0, this.isRenderOnScroll = t.isRenderOnScroll, this.parent.filterType) {
          case Wi.a.FilterType.COLLECTION:
            this.collectionId = t.key, this.label = t.displayName ? t.displayName : t.label, this.handle = t.handle, this.href = u.a.isSearchPage() ? "javascript:void(0);" : "/collections/" + this.handle, this.sortOrder = t.sort_order ? t.sort_order : l.a.defaultSorting;
            break;
          case Wi.a.FilterType.REVIEW_RATINGS:
            this.from = parseFloat(t.from).toFixed(), this.value = this.from;
            break;
          case Wi.a.FilterType.STOCK:
            this.value = "in-stock" == t.key ? "true" : "false", this.label = t.label;
            break;
          case Wi.a.FilterType.PERCENT_SALE:
            this.from = t.from, this.to = t.to, this.label = this.buildPercentSaleLabel(), this.value = (this.from ? this.from : "") + ":" + (this.to ? this.to : "");
            break;
          case Wi.a.FilterType.PRICE:
          case Wi.a.FilterType.VARIANTS_PRICE:
            this.from = t.from, this.to = t.to, this.label = this.buildPriceListLabel(), this.value = (this.from ? this.from : "") + ":" + (this.to ? this.to : "")
          }
          this.label = this.buildLabel(), this.countLabel = this.buildCount(), this.isSelected = this.isAppliedFilter()
        }
      }]) && _r(n.prototype, i), s && _r(n, s), e
    }(f.a);

    function Lr(t) {
      return (Lr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ar(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Fr(t, e) {
      return !e || "object" !== Lr(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Rr(t) {
      return (Rr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function jr(t, e) {
      return (jr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var $r = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = Fr(this, Rr(e).call(this, t))).$element = null, n
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && jr(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return this.parent.filterType == Wi.a.FilterType.COLLECTION ? '\n\t\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t\t<a class="{{class.button}}" href="{{href}}">\n\t\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t' : '\n\t\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t\t<button role="checkbox" class="{{class.button}}">\n\t\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</li>\n\t\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.filterOptionItem}}/g, p.a.filterOptionItem).replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{class.button}}/g, p.a.button).replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "").replace(/{{label}}/g, this.label).replace(/{{href}}/g, this.href).replace(/{{countLabel}}/g, this.countLabel)
        }
      }]) && Ar(n.prototype, i), r && Ar(n, r), e
    }(Ir);

    function Br(t) {
      return (Br = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function xr(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function Mr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Dr(t, e) {
      return !e || "object" !== Br(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Vr(t, e, n) {
      return (Vr = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Nr(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function Nr(t) {
      return (Nr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ur(t, e) {
      return (Ur = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var qr = function (t) {
      function e() {
        return xr(this, e), Dr(this, Nr(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Ur(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t<button role="checkbox" class="{{class.button}}">\n\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t</button>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.filterOptionItem}}/g, p.a.filterOptionItem).replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "").replace(/{{class.button}}/g, p.a.button).replace(/{{label}}/g, this.label).replace(/{{countLabel}}/g, this.countLabel)
        }
      }, {
        key: "bindEvents",
        value: function () {
          Vr(Nr(e.prototype), "bindEvents", this).call(this), this.setBoxItemSize()
        }
      }, {
        key: "setBoxItemSize",
        value: function () {
          this.filterTreeType == pr.FilterTreeType.VERTICAL && this.$element && this.$element.css("width", this.parent.calculateBoxItemSize())
        }
      }]) && Mr(n.prototype, i), r && Mr(n, r), e
    }(Ir);

    function Hr(t) {
      return (Hr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Wr(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function Gr(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function zr(t, e) {
      return !e || "object" !== Hr(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Kr(t, e, n) {
      return (Kr = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Yr(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function Yr(t) {
      return (Yr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Qr(t, e) {
      return (Qr = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Jr = function (t) {
      function e() {
        return Wr(this, e), zr(this, Yr(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Qr(t, e)
      }(e, t), n = e, r = [{
        key: "SwatchType",
        get: function () {
          return {
            ONE_COLOR: "one_color",
            TWO_COLORS: "two_colors",
            IMAGE: "image"
          }
        }
      }], (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.filterOptionItem}} {{disabled}} {{swatchBorder}}">\n\t\t\t\t<span class="boost-pfs-filter-option-swatch-image" \n\t\t\t\t\tstyle="background-color: {{backgroundColor}}; \n\t\t\t\t\tbackground-image: {{backgroundImage}});" title="{{label}}">\n\t\t\t\t</span>\n\t\t\t\t<button role="checkbox" class="{{class.button}}">\n\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t</button>\n\t\t\t</li> \n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.filterOptionItem}}/g, p.a.filterOptionItem).replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "").replace(/{{class.button}}/g, p.a.button).replace(/{{label}}/g, this.label).replace(/{{countLabel}}/g, this.countLabel).replace(/{{backgroundColor}}/g, this.backgroundColor).replace(/{{backgroundImage}}/g, this.backgroundImage).replace(/{{swatchBorder}}/g, this.swatchBorder)
        }
      }, {
        key: "render",
        value: function () {
          this.buildSwatchSettings() || (this.swatchFileName = this.buildSwatchFileName(), this.swatchFileUrl = u.a.getFilePath(this.swatchFileName, l.a.swatchExtension, o.a.getSettingValue("general.swatchImageVersion")), this.backgroundImage = "url(" + this.swatchFileUrl + ");", this.backgroundColor = this.buildBackgroundColor()), this.swatchBorder = ["white", "#FFFFFF"].includes(this.backgroundColor) ? "has-border" : "", Kr(Yr(e.prototype), "render", this).call(this)
        }
      }, {
        key: "buildSwatchSettings",
        value: function () {
          var t = o.a.getSettingValue("swatch_settings"),
            n = !1;
          if (t && t[this.value]) switch (this.swatchSetting = t[this.value], this.swatchSetting.type) {
          case e.SwatchType.ONE_COLOR:
            this.swatchSetting.colorCodes.length > 0 && this.swatchSetting.colorCodes[0] && (this.backgroundImage = "none", this.backgroundColor = this.swatchSetting.colorCodes[0], n = !0);
            break;
          case e.SwatchType.TWO_COLORS:
            this.swatchSetting.colorCodes.length > 1 && this.swatchSetting.colorCodes[0] && this.swatchSetting.colorCodes[1] && (this.backgroundImage = "linear-gradient(to top left, " + this.swatchSetting.colorCodes[0] + " 50%, " + this.swatchSetting.colorCodes[1] + " 50%);", this.backgroundColor = "transparent", n = !0);
            break;
          case e.SwatchType.IMAGE:
            this.swatchSetting.imageUrl && (this.swatchFileUrl = this.swatchSetting.imageUrl, this.backgroundImage = "url(" + this.swatchFileUrl + ");", this.backgroundColor = this.buildBackgroundColor(), n = !0)
          }
          return n
        }
      }, {
        key: "buildSwatchFileName",
        value: function () {
          this.parent.filterOptionId;
          var t = this.parent.prefix,
            e = this.value;
          this.parent.filterType == Wi.a.FilterType.COLLECTION && (e = this.label);
          var n = this.parent.label.trim().toLowerCase().replace(/ /g, "_");
          if (o.a.getSettingValue("general.removePrefixFromSwatchFile") && t) {
            var i = t.replace(/\\/g, "");
            e = e.replace(i, "")
          }
          return n + "-" + u.a.slugify(e).replace(/\#/g, "")
        }
      }, {
        key: "buildBackgroundColor",
        value: function () {
          var t = u.a.slugify(this.label).split("-");
          return t[t.length - 1]
        }
      }]) && Gr(n.prototype, i), r && Gr(n, r), e
    }(Ir);

    function Zr(t) {
      return (Zr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Xr(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function to(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function eo(t, e) {
      return !e || "object" !== Zr(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function no(t, e, n) {
      return (no = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = io(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function io(t) {
      return (io = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ro(t, e) {
      return (ro = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var oo = function (t) {
      function e() {
        return Xr(this, e), eo(this, io(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ro(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{disabled}}">\n\t\t\t\t<button role="checkbox" class="{{class.button}}">\n\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t<span role="presentation" class="boost-pfs-filter-option-value">\n\t\t\t\t\t\t<i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n\t\t\t\t\t\t--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n\t\t\t\t\t\t--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n\t\t\t\t\t\t--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i><!--\n\t\t\t\t\t\t--><i style="color: {{starColor}}" class="{{class.filterOptionItemStar}} {{active}}"></i>\n\t\t\t\t\t\t<span>{{label}}</span>\n\t\t\t\t\t</span>\t\n\t\t\t\t\t<span class="boost-pfs-filter-option-amount">{{countLabel}}</span>\n\t\t\t\t</button>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          for (var t = this.getTemplate(), e = 0; e < this.from; e++) t = t.replace(/{{active}}/, "{{class.filterOptionItemStarActive}}");
          return (t = t.replace(/{{active}}/g, "")).replace(/{{class.filterOptionItem}}/g, p.a.filterOptionItem).replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{class.filterOptionItemStar}}/g, p.a.filterOptionItemStar).replace(/{{class.filterOptionItemStarActive}}/g, p.a.filterOptionItemStarActive).replace(/{{class.button}}/g, p.a.button).replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "").replace(/{{label}}/g, this.label).replace(/{{countLabel}}/g, this.countLabel).replace(/{{adaLabel}}/g, this.adaLabel).replace(/{{starColor}}/g, this.parent.starColor).replace(/{{class.button}}/g, p.a.button).replace(/\r?\n|\r/g, "")
        }
      }, {
        key: "render",
        value: function () {
          this.label = this.parent.showExactRating ? "" : a.a.ratingUp, this.adaLabel = this.from, 1 == this.from ? this.adaLabel += " " + a.a.ratingStar : this.adaLabel += " " + a.a.ratingStars, this.parent.showExactRating && (this.adaLabel += " " + a.a.ratingUp), no(io(e.prototype), "render", this).call(this)
        }
      }]) && to(n.prototype, i), r && to(n, r), e
    }(Ir);

    function ao(t) {
      return (ao = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function lo(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function so(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function co(t, e) {
      return !e || "object" !== ao(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function uo(t, e, n) {
      return (uo = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = po(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function po(t) {
      return (po = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function fo(t, e) {
      return (fo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ho = function (t) {
      function e() {
        return lo(this, e), co(this, po(e).apply(this, arguments))
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && fo(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t<div class="boost-pfs-filter-option-item-parent-category">\n\t\t\t\t\t<span role="button" aria-controls="sub-category-{{value}}" aria-expanded="true" class="sub-icon {{closeClass}}"></span>\n\t\t\t\t\t<a href="javascript:;" class="{{class.filterOptionItem}} {{class.filterOptionLabel}} boost-pfs-filter-option-main-cat">\n\t\t\t\t\t\t{{label}}\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t\t<ul class="boost-pfs-filter-option-item-sub-category-list">\n\t\t\t\t\t{{subItems}}\n\t\t\t\t</ul>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "getSubItemTemplate",
        value: function () {
          return '\n\t\t\t<li class="{{class.filterOptionItem}} {{class.filterOptionLabel}} {{selected}} boost-pfs-filter-option-item-sub-category">\n\t\t\t\t<a href="javascript:;">\n\t\t\t\t\t{{subLabel}}\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          var t = this,
            e = "";
          return Array.isArray(this.tags) && this.tags.forEach((function (n) {
            var i = t.isSubCategorySelected(n);
            e += t.getSubItemTemplate().replace(/{{subLabel}}/g, n).replace(/{{selected}}/g, i ? "selected" : "")
          })), this.getTemplate().replace(/{{subItems}}/g, e).replace(/{{class.filterOptionItem}}/g, p.a.filterOptionItem).replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{disabled}}/g, this.isDisabled() ? "disabled" : "").replace(/{{label}}/g, this.label).replace(/{{value}}/g, this.value).replace(/{{countLabel}}/g, this.countLabel)
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element.on("click", this.redirectToCollection.bind(this)), this.$element.find("ul > li").on("click", this.redirectToSubCategory.bind(this))
        }
      }, {
        key: "isSubCategorySelected",
        value: function (t) {
          if (!u.a.isSearchPage()) {
            var e = decodeURIComponent(window.location.pathname).split("/");
            if (e[e.length - 1] == u.a.slugify(t)) return this.isAnyTagSelected = !0, !0
          }
          return !1
        }
      }, {
        key: "redirectToCollection",
        value: function (t) {
          t.preventDefault(), t.stopPropagation();
          var e = "/collections/" + this.handle;
          u.a.setWindowLocation(e)
        }
      }, {
        key: "redirectToSubCategory",
        value: function (t) {
          t.preventDefault(), t.stopPropagation();
          var e = r()(t.currentTarget).find("a").html(),
            n = u.a.slugify(e),
            i = "/collections/" + this.handle + "/" + n;
          u.a.setWindowLocation(i)
        }
      }, {
        key: "setData",
        value: function (t) {
          uo(po(e.prototype), "setData", this).call(this, t), this.tags = t.tags
        }
      }]) && so(n.prototype, i), o && so(n, o), e
    }(Ir);

    function yo(t) {
      return (yo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function go(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function mo(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function bo(t, e) {
      return !e || "object" !== yo(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function vo(t, e, n) {
      return (vo = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = So(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function So(t) {
      return (So = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Oo(t, e) {
      return (Oo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var To = function (t) {
      function e() {
        return go(this, e), bo(this, So(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Oo(t, e)
      }(e, t), n = e, (i = [{
        key: "isRender",
        value: function () {
          return !1
        }
      }, {
        key: "setValue",
        value: function (t, e) {
          this.value = t + ":" + e, this.isSelected = this.min != t || this.max != e
        }
      }, {
        key: "setData",
        value: function (t) {
          vo(So(e.prototype), "setData", this).call(this, t), null != t.min && null != t.max && (this.min = t.min, this.max = t.max, this.key = this.parent.filterOptionId, this.value = t.min + ":" + t.max)
        }
      }]) && mo(n.prototype, i), r && mo(n, r), e
    }(Ir);
    n(154), n(122), n(170);

    function Po(t) {
      return (Po = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function wo(t, e) {
      return function (t) {
        if (Array.isArray(t)) return t
      }(t) || function (t, e) {
        if (!(Symbol.iterator in Object(t)) && "[object Arguments]" !== Object.prototype.toString.call(t)) return;
        var n = [],
          i = !0,
          r = !1,
          o = void 0;
        try {
          for (var a, l = t[Symbol.iterator](); !(i = (a = l.next()).done) && (n.push(a.value), !e || n.length !== e); i = !0);
        } catch (t) {
          r = !0, o = t
        } finally {
          try {
            i || null == l.return || l.return()
          } finally {
            if (r) throw o
          }
        }
        return n
      }(t, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance")
      }()
    }

    function _o(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Co(t, e) {
      return !e || "object" !== Po(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ko(t) {
      return (ko = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Eo(t, e) {
      return (Eo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Io = function (t) {
        function e(t) {
          var n;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (n = Co(this, ko(e).call(this))).filterTreeType = t, n.isExpanded = !1, n.label = a.a.viewMore, n.class = p.a.filterOptionViewMore, n.isVisible = !0, n.$element = null, n
        }
        var n, i, l;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Eo(t, e)
        }(e, t), n = e, l = [{
          key: "getViewMoreStateData",
          value: function (t) {
            return Lo.get(t)
          }
        }, {
          key: "setViewMoreStateData",
          value: function (t, e) {
            Lo.set(t, e)
          }
        }], (i = [{
          key: "init",
          value: function () {
            this.numberVisibleItems = this.getNumberVisibleItems()
          }
        }, {
          key: "getTemplate",
          value: function () {
            switch (this.filterTreeType) {
            case pr.FilterTreeType.VERTICAL:
              return '\n\t\t\t\t\t<div class="{{class.button}} {{class}}"><button>{{label}}</button></div>\n\t\t\t\t';
            case pr.FilterTreeType.HORIZONTAL:
              return '\n\t\t\t\t\t<div class="{{class.button}} {{class}}"><button aria-label="{{label}}"></button></div>\n\t\t\t\t';
            default:
              throw Error("Pass a filter tree type into the constructor")
            }
          }
        }, {
          key: "compileTemplate",
          value: function () {
            return this.getTemplate().replace(/{{class.button}}/g, p.a.button).replace(/{{class}}/g, this.class).replace(/{{label}}/g, this.label)
          }
        }, {
          key: "isRender",
          value: function () {
            return this.parent.displayType != Wi.a.DisplayType.RANGE && (this.parent.showMoreType == Wi.a.ShowMoreType.VIEWMORE || this.parent.showMoreType == Wi.a.ShowMoreType.VIEWMORE_SCROLLBAR)
          }
        }, {
          key: "render",
          value: function () {
            this.$element || (this.$element = r()(this.compileTemplate())), this.setVisibility()
          }
        }, {
          key: "bindEvents",
          value: function () {
            this.$element && (this.isBoundEvent || this.$element.on("click", this.onClick.bind(this)), this.parent.$filterOptionContentElement && this.parent.$filterOptionContentElement.addClass(p.a.filterHasViewMore), !this.isExpanded && e.getViewMoreStateData(this.parent.filterOptionId) ? this.onClick() : this.setFilterItemsVisibility())
          }
        }, {
          key: "onClick",
          value: function () {
            this.isExpanded = !this.isExpanded, e.setViewMoreStateData(this.parent.filterOptionId, this.isExpanded);
            var t = "";
            this.isExpanded ? (this.label = a.a.viewLess, this.class = p.a.filterOptionViewLess, t = p.a.filterOptionViewMore) : (this.label = a.a.viewMore, this.class = p.a.filterOptionViewMore, t = p.a.filterOptionViewLess), this.filterTreeType == pr.FilterTreeType.VERTICAL ? this.$element.find("button").html(this.label) : this.$element.removeClass(t).addClass(this.class), this.setFilterItemsVisibility()
          }
        }, {
          key: "getNumberVisibleItems",
          value: function () {
            var t = o.a.getSettingValue("general.startViewMore")[this.parent.displayType];
            if (this.filterTreeType == pr.FilterTreeType.HORIZONTAL) {
              var e = o.a.getSettingValue("general.filterHorizontalColumn");
              Number.isInteger(e) ? t *= e : t = o.a.getSettingValue("general.startViewMoreH")[this.parent.displayType]
            }
            return (!t || t <= 1) && (t = 5), t
          }
        }, {
          key: "setVisibility",
          value: function () {
            if (this.$element) {
              var t = this.parent.filterItems.size;
              this.parent.keepValuesStatic || o.a.getSettingValue("general.showOutOfStockOption") || (t = Array.from(this.parent.filterItems, (function (t) {
                var e = wo(t, 2);
                return {
                  key: e[0],
                  value: e[1]
                }
              })).filter((function (t) {
                return t.value.docCount > 0
              })).length), this.parent.$filterItemsContainerElement && (t = this.parent.$filterItemsContainerElement.find("li").length), this.isVisible = t > this.numberVisibleItems, this.isVisible ? this.$element.show() : this.$element.hide()
            } else this.isVisible = !1
          }
        }, {
          key: "setFilterItemsVisibility",
          value: function () {
            if (this.parent.$filterItemsContainerElement) {
              var t = this.parent.$filterItemsContainerElement.find("li");
              if (t.show(), !this.isExpanded) {
                var e = this.numberVisibleItems,
                  n = t.length;
                t.slice(e, n).hide()
              }
            }
          }
        }]) && _o(n.prototype, i), l && _o(n, l), e
      }(f.a),
      Lo = new Map,
      Ao = Io;

    function Fo(t) {
      return (Fo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ro(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function jo(t, e) {
      return !e || "object" !== Fo(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function $o(t) {
      return ($o = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Bo(t, e) {
      return (Bo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var xo = function (t) {
      function e() {
        var t;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (t = jo(this, $o(e).call(this))).$element = null, t.searchValue = "", t
      }
      var n, i, l;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Bo(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          return '\n\t\t\t<div class="{{class.filterOptionShowSearchBox}}-wrapper">\n\t\t\t\t<input aria-label="Search Options" class="{{class.filterOptionShowSearchBox}}" type="text" autocomplete="on" placeholder="{{label.searchOptions}}" />\n\t\t\t</div>\n        '
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.filterOptionShowSearchBox}}/g, p.a.filterOptionShowSearchBox).replace(/{{label.searchOptions}}/g, a.a.searchOptions)
        }
      }, {
        key: "isRender",
        value: function () {
          if (this.parent.filterTreeType == pr.FilterTreeType.HORIZONTAL) return !1;
          var t = this.parent.showSearchBoxFilterPC || o.a.getSettingValue("general.showSearchBoxFilterPCByDefault"),
            e = this.parent.showSearchBoxFilterMobile || o.a.getSettingValue("general.showSearchBoxFilterMobileByDefault"),
            n = [Wi.a.FilterType.PRICE, Wi.a.FilterType.PERCENT_SALE, Wi.a.FilterType.STOCK],
            i = [Wi.a.DisplayType.RANGE, Wi.a.DisplayType.MULTI_LEVEL_TAG, Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS],
            r = !n.includes(this.parent.filterType) && !i.includes(this.parent.displayType),
            a = u.a.isMobile();
          return r && (!a && t || a && e)
        }
      }, {
        key: "render",
        value: function () {
          this.$element || (this.$element = r()(this.compileTemplate()))
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvent
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element && (this.$element.find("input").on("keyup", this.onKeyUp.bind(this)), this.parent.$filterOptionContentElement && this.parent.$filterOptionContentElement.addClass(p.a.filterHasSearchBox))
        }
      }, {
        key: "onKeyUp",
        value: function (t) {
          this.setSearchValue(t), this.setFilterItemsList()
        }
      }, {
        key: "setSearchValue",
        value: function (t) {
          if (t && t.target) {
            var e = t.target.value;
            e = "function" == typeof e.toString ? e.toLowerCase().trim() : "", this.searchValue = e
          } else this.searchValue = ""
        }
      }, {
        key: "setFilterItemsList",
        value: function () {
          var t = this;
          if (this.parent.$filterItemsContainerElement) {
            if (this.searchValue) this.parent.filterItems.forEach((function (e) {
              e.$element && (e.label && e.label.toLowerCase().includes(t.searchValue) ? e.$element.appendTo(t.parent.$filterItemsContainerElement) : e.$element.detach())
            }));
            else {
              var e = 0,
                n = o.a.getSettingValue("general.scrollFirstLoadLength");
              this.parent.filterItems.forEach((function (i) {
                i.isRenderOnScroll = t.parent.isLoadMoreOnScroll && e >= n, i.$element && (i.isRenderOnScroll ? i.$element.detach() : i.$element.appendTo(t.parent.$filterItemsContainerElement)), e++
              })), this.parent.scrollbar.numberFilterItemsRendered = n
            }
            this.parent.viewMore && this.parent.viewMore.isRender() && (this.parent.viewMore.setVisibility(), this.parent.viewMore.setFilterItemsVisibility())
          }
        }
      }]) && Ro(n.prototype, i), l && Ro(n, l), e
    }(f.a);

    function Mo(t) {
      return (Mo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Do(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Vo(t, e) {
      return !e || "object" !== Mo(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function No(t) {
      return (No = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Uo(t, e) {
      return (Uo = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var qo = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = Vo(this, No(e).call(this))).tooltipText = "string" == typeof t ? u.a.escape(u.a.stripHtml(t)).trim() : null, n.$element = null, n.$popupElement = null, n
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Uo(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function (t) {
          switch (t) {
          case "popup":
            return '\n\t\t\t\t\t<div class="boost-pfs-filter-tooltip-wrapper">\n\t\t\t\t\t\t<div class="boost-pfs-filter-qtip-content">{{tooltipText}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t';
          default:
            return '\n\t\t\t\t\t<div class="{{class.filterOptionTooltip}}">\n\t\t\t\t\t\t<span class="boost-pfs-filter-tooltip-arrow"></span>\n\t\t\t\t\t</div>\n\t\t\t\t'
          }
        }
      }, {
        key: "compileTemplate",
        value: function (t) {
          return this.getTemplate(t).replace(/{{tooltipText}}/g, this.tooltipText).replace(/{{class.filterOptionTooltip}}/g, p.a.filterOptionTooltip)
        }
      }, {
        key: "isRender",
        value: function () {
          return !!this.tooltipText
        }
      }, {
        key: "render",
        value: function () {
          this.$element || (this.$element = r()(this.compileTemplate())), this.$popupElement || (this.$popupElement = r()(this.compileTemplate("popup")))
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvent
        }
      }, {
        key: "bindEvents",
        value: function () {
          this.$element && this.$popupElement && this.$element.on("mouseover", this.showTooltipPopup.bind(this))
        }
      }, {
        key: "showTooltipPopup",
        value: function () {
          var t = this.$element.position(),
            e = this.$popupElement.find(".boost-pfs-filter-qtip-content").outerWidth();
          this.$popupElement.css("left", t.left + "px"), e / 2 < t.left ? this.$popupElement.css("margin-left", -(e / 2 - 12) + "px") : e / 2 > t.left && this.$popupElement.css("margin-left", -t.left / 2 + "px")
        }
      }]) && Do(n.prototype, i), o && Do(n, o), e
    }(f.a);

    function Ho(t) {
      return (Ho = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Wo(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Go(t, e) {
      return !e || "object" !== Ho(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function zo(t) {
      return (zo = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ko(t, e) {
      return (Ko = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Yo = function (t) {
        function e() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (t = Go(this, zo(e).call(this))).placeHolderHeight = "", t.numberFilterItemsRendered = 0, t.$scrollElement = null, t
        }
        var n, i, r;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Ko(t, e)
        }(e, t), n = e, r = [{
          key: "getScrollStateData",
          value: function (t) {
            return Qo.get(t)
          }
        }, {
          key: "setScrollStateData",
          value: function (t, e) {
            Qo.set(t, e)
          }
        }, {
          key: "isEnabled",
          value: function (t, e, n) {
            var i = [Wi.a.DisplayType.RANGE],
              r = [Wi.a.FilterType.REVIEW_RATINGS, Wi.a.FilterType.STOCK, Wi.a.FilterType.PERCENT_SALE, Wi.a.FilterType.PRICE, Wi.a.FilterType.VARIANTS_PRICE],
              a = n == Wi.a.ShowMoreType.SCROLLBAR || n == Wi.a.ShowMoreType.VIEWMORE_SCROLLBAR,
              l = u.a.isMobile(),
              s = l && o.a.getSettingValue("general.activeFilterScrollbarMobile") || !l && o.a.getSettingValue("general.activeFilterScrollbarPC");
            return !i.includes(t) && !r.includes(e) && a && s
          }
        }], (i = [{
          key: "isBindEvents",
          value: function () {
            return !this.isBoundEvent
          }
        }, {
          key: "bindEvents",
          value: function () {
            if (this.parent.$element && e.isEnabled(this.parent.displayType, this.parent.filterType, this.parent.showMoreType)) {
              var t = this.parent.$element.find("." + p.a.filterOptionContentInner);
              if (t.length > 0 && (this.$scrollElement = t, (this.parent.isLoadMoreOnScroll || o.a.getSettingValue("general.keepScrollState")) && this.$scrollElement.on("scroll", this.onScroll.bind(this)), o.a.getSettingValue("general.keepScrollState"))) {
                var n = e.getScrollStateData(this.parent.filterOptionId);
                isNaN(n) || (this.$scrollElement[0].scrollTop = n)
              }
            }
          }
        }, {
          key: "onScroll",
          value: function () {
            if (o.a.getSettingValue("general.keepScrollState")) {
              var t = this.$scrollElement[0].scrollTop;
              e.setScrollStateData(this.parent.filterOptionId, t)
            }
            this.parent.isLoadMoreOnScroll && this.isScrollToBottom() && (this.parent.searchBox && this.parent.searchBox.searchValue || this.appendFilterItems())
          }
        }, {
          key: "isScrollToBottom",
          value: function () {
            return !!this.$scrollElement && this.$scrollElement[0].scrollHeight - this.$scrollElement.scrollTop() - this.$scrollElement.outerHeight() < 1
          }
        }, {
          key: "appendFilterItems",
          value: function () {
            var t = this;
            if (this.parent.$filterItemsContainerElement) {
              var e = o.a.getSettingValue("general.scrollFirstLoadLength");
              if (0 == this.numberFilterItemsRendered) this.numberFilterItemsRendered = e;
              else if (this.numberFilterItemsRendered == this.parent.filterItems.size) return;
              this.parent.$element.addClass("boost-pfs-filter-scrollbar-loading");
              var n = 0;
              this.parent.filterItems.forEach((function (i) {
                i.isRenderOnScroll && n < e && (t.parent.$filterItemsContainerElement.append(i.$element), i.isRenderOnScroll = !1, n++, t.numberFilterItemsRendered++)
              })), setTimeout(function () {
                this.parent.$element.removeClass("boost-pfs-filter-scrollbar-loading")
              }.bind(this), 200)
            }
          }
        }]) && Wo(n.prototype, i), r && Wo(n, r), e
      }(f.a),
      Qo = new Map,
      Jo = Yo;

    function Zo(t) {
      return (Zo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Xo(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function ta(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ea(t, e, n) {
      return e && ta(t.prototype, e), n && ta(t, n), t
    }

    function na(t, e) {
      return !e || "object" !== Zo(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ia(t, e, n) {
      return (ia = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ra(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function ra(t) {
      return (ra = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function oa(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && aa(t, e)
    }

    function aa(t, e) {
      return (aa = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var la = function (t) {
        function e(t) {
          var n;
          return Xo(this, e), (n = na(this, ra(e).call(this, t))).$element = null, n.$itemElement = null, n.$childContainerElement = null, n
        }
        return oa(e, t), ea(e, [{
          key: "init",
          value: function () {
            var t = this.filterOption ? this.filterOption.selectType : this.parent.selectType;
            this.requestInstantly = this.filterTreeType == pr.FilterTreeType.VERTICAL || t == Wi.a.SelectType.SINGLE || o.a.getSettingValue("general.requestInstantly")
          }
        }, {
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t'
          }
        }, {
          key: "getArrowTemplate",
          value: function () {
            return '\n\t\t\t<button class="{{class.button}} {{class.button}}-arrow" data-action="expand-filter-item" aria-label="{{label.ada.toggleMultiLevel}}">\n\t\t\t\t<span class="boost-pfs-arrow"></span>\n\t\t\t</button>\n\t\t'
          }
        }, {
          key: "compileArrowTemplate",
          value: function () {
            return 3 != this.level && this.children && this.children.length > 0 ? this.getArrowTemplate().replace(/{{label.ada.toggleMultiLevel}}/g, Labels.ada.toggleMultiLevel.replace(/{{filterItem}}/g, this.label)) : ""
          }
        }, {
          key: "compileTemplate",
          value: function () {
            return this.getTemplate().replace(/{{class.filterOptionItem}}/g, p.a.filterOptionItem).replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{label}}/g, this.label).replace(/{{href}}/g, this.href).replace(/{{arrow}}/g, this.compileArrowTemplate()).replace(/{{class.button}}/g, p.a.button).replace(/{{childItems}}/g, "")
          }
        }, {
          key: "render",
          value: function () {
            var t = this;
            if (this.$element || (this.$element = r()(this.compileTemplate()), this.$itemElement = this.$element.find("> ." + p.a.filterOptionItem), this.$itemClickElement = this.$itemElement.find('[data-action="select-filter-item"]'), this.$toggleClickElement = this.$itemElement.find('[data-action="expand-filter-item"]'), this.$childContainerElement = this.$element.find("> .boost-pfs-filter-option-multi-level-list"), this.$childContainerElement && this.children && this.children.length > 0 && this.children.forEach((function (e) {
                e.$element && t.$childContainerElement.append(e.$element)
              }))), this.$itemElement) {
              this.isSelected || this.isSelectedChild ? this.$itemElement.addClass("selected") : this.$itemElement.removeClass("selected");
              var n = e.getLevelOpenStateData(this),
                i = o.a.getSettingValue("general.openMultiLevelByDefault");
              n || Array.isArray(i) && i.includes(this.level) || null == n && this.isSelectedChild ? (this.$itemElement.addClass("boost-pfs-open"), e.setLevelOpenStateData(this, !0)) : e.setLevelOpenStateData(this, !1)
            }
          }
        }, {
          key: "bindEvents",
          value: function () {
            this.$itemClickElement && this.$itemClickElement.on("click", this.onClick.bind(this)), this.$toggleClickElement && this.$toggleClickElement.on("click", this.onClickToggle.bind(this))
          }
        }, {
          key: "onClick",
          value: function (t) {
            t && t.preventDefault(), this.setCollectionParams(), this.clearAllTagParams(), Ae.default.setParam("page", 1), this.children && this.children.length > 0 && e.setLevelOpenStateData(this, !0), this.requestInstantly && Ae.default.applyFilter("collection")
          }
        }, {
          key: "onClickToggle",
          value: function () {
            this.$itemElement.toggleClass("boost-pfs-open"), this.$itemElement.hasClass("boost-pfs-open") ? e.setLevelOpenStateData(this, !0) : e.setLevelOpenStateData(this, !1)
          }
        }, {
          key: "isAppliedFilter",
          value: function () {
            return l.a.collectionId == this.collectionId
          }
        }, {
          key: "setCollectionParams",
          value: function () {
            u.a.isSearchPage() ? Ae.default.setParam(this.filterOption.filterOptionId, this.collectionId) : (c.a.setAddressBarPathAfterFilter(this.href), c.a.setWindowTitleAfterFilter(this.label + " - " + l.a.shopName), Ae.default.setParam("sort", this.sortOrder)), l.a.collectionId = this.collectionId, Ae.default.setParam("collection_scope", this.collectionId)
          }
        }, {
          key: "clearAllTagParams",
          value: function () {
            var t = this.filterOption.filterOptionId.replace(l.a.prefix + "_c", l.a.prefix + "_ct");
            Ae.default.setParam(t, null), l.a.collectionTags = [];
            var e = [];
            Object.keys(l.a.queryParams).forEach((function (t) {
              t.startsWith(l.a.prefix) && !t.startsWith(l.a.prefix + "_c") && e.push(t)
            })), e.forEach((function (t) {
              Ae.default.setParam(t, null)
            }))
          }
        }, {
          key: "setData",
          value: function (t) {
            var n = this;
            ia(ra(e.prototype), "setData", this).call(this, t), this.filterOption = this.parent, this.level = 1, this.href = u.a.isSearchPage() ? "javascript:void(0);" : "/collections/" + this.handle, this.sortOrder = t.sort_order ? t.sort_order : l.a.defaultSorting, this.children = [], Array.isArray(t.tags) && t.tags.forEach((function (t) {
              if (t.tag) {
                var e = new sa(n.filterTreeType);
                n.addComponent(e), e.setData(t)
              }
            })), this.isSelected = this.isAppliedFilter(), this.isSelectedChild = this.children.some((function (t) {
              return t.isSelected || t.isSelectedChild
            })), this.filterOption.allNestedFilterItems.set(this.collectionId, this)
          }
        }], [{
          key: "getLevelOpenStateData",
          value: function (t) {
            var e = t.filterOption.filterOptionId,
              n = t.collectionId,
              i = t.tag,
              r = e + ":" + n + (i ? ":" + i : "");
            return ua.get(r)
          }
        }, {
          key: "setLevelOpenStateData",
          value: function (t, e) {
            var n = t.filterOption.filterOptionId,
              i = t.collectionId,
              r = t.tag,
              o = n + ":" + i + (r ? ":" + r : "");
            ua.set(o, e)
          }
        }]), e
      }(Ir),
      sa = function (t) {
        function e() {
          return Xo(this, e), na(this, ra(e).apply(this, arguments))
        }
        return oa(e, t), ea(e, [{
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-second-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n\t\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-third-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
          }
        }, {
          key: "onClick",
          value: function (t) {
            t && t.preventDefault(), this.collectionId == l.a.collectionId && o.a.getSettingValue("general.multiLevelCollectionSelectType") != Wi.a.SelectType.SINGLE || this.clearAllTagParams(), this.setCollectionParams(), this.setTagParams(), Ae.default.setParam("page", 1), this.children && this.children.length > 0 && la.setLevelOpenStateData(this, !0), this.requestInstantly && Ae.default.applyFilter("collection")
          }
        }, {
          key: "setTagParams",
          value: function () {
            if (u.a.isSearchPage() || o.a.getSettingValue("general.multiLevelCollectionSelectType") == Wi.a.SelectType.MULTIPLE) {
              Array.isArray(l.a.collectionTags) || (l.a.collectionTags = []);
              var t = l.a.collectionTags.indexOf(this.tag);
              t > -1 ? l.a.collectionTags.splice(t, 1) : l.a.collectionTags.push(this.tag), o.a.general.tagMode = "2";
              var e = this.filterOption.filterOptionId.replace(l.a.prefix + "_c_", l.a.prefix + "_ct_");
              Array.isArray(l.a.collectionTags) && l.a.collectionTags.length > 0 ? Ae.default.setParam(e, l.a.collectionTags) : Ae.default.setParam(e, null)
            } else l.a.collectionTags = this.tag, c.a.setAddressBarPathAfterFilter(this.href)
          }
        }, {
          key: "isAppliedFilter",
          value: function () {
            var t = Array.isArray(l.a.collectionTags) && l.a.collectionTags.includes(this.tag) || l.a.collectionTags == this.tag;
            return l.a.collectionId == this.collectionId && t
          }
        }, {
          key: "setData",
          value: function (t) {
            var e = this;
            this.tag = t.tag, this.slugifyTag = u.a.slugify(this.tag), this.label = t.displayName ? t.displayName : t.tag, this.filterOption = this.parent.filterOption, this.requestInstantly = this.parent.requestInstantly, this.collectionId = this.parent.collectionId, this.handle = this.parent.handle, this.level = 2, this.href = u.a.isSearchPage() || o.a.getSettingValue("general.multiLevelCollectionSelectType") == Wi.a.SelectType.MULTIPLE ? "javascript:void(0);" : "/collections/" + this.handle + "/" + this.slugifyTag, this.sortOrder = this.parent.sortOrder ? this.parent.sortOrder : l.a.defaultSorting, this.children = [], Array.isArray(t.subTags) && t.subTags.forEach((function (t) {
              if (t.tag) {
                var n = new ca(e.filterTreeType);
                e.addComponent(n), n.setData(t)
              }
            })), this.label = this.buildLabel(), this.isSelected = this.isAppliedFilter(), this.isSelectedChild = this.children.some((function (t) {
              return t.isSelected || t.isSelectedChild
            })), this.filterOption.allNestedFilterItems.set(this.collectionId + ":" + this.tag, this)
          }
        }]), e
      }(la),
      ca = function (t) {
        function e() {
          return Xo(this, e), na(this, ra(e).apply(this, arguments))
        }
        return oa(e, t), ea(e, [{
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-third-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t<a class="{{class.button}}" data-action="select-filter-item" href="{{href}}">\n\t\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
          }
        }, {
          key: "setData",
          value: function (t) {
            this.tag = t.tag, this.slugifyTag = u.a.slugify(this.tag), this.label = t.displayName ? t.displayName : t.tag, this.filterOption = this.parent.filterOption, this.requestInstantly = this.parent.requestInstantly, this.collectionId = this.parent.collectionId, this.handle = this.parent.handle, this.level = 3, this.href = u.a.isSearchPage() || o.a.getSettingValue("general.multiLevelCollectionSelectType") == Wi.a.SelectType.MULTIPLE ? "javascript:void(0);" : "/collections/" + this.handle + "/" + this.slugifyTag, this.filterOption.allNestedFilterItems.set(this.collectionId + ":" + this.tag, this), this.sortOrder = this.parent.sortOrder ? this.parent.sortOrder : l.a.defaultSorting, this.label = this.buildLabel(), this.isSelected = this.isAppliedFilter()
          }
        }]), e
      }(sa),
      ua = new Map,
      pa = la;

    function fa(t) {
      return (fa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ha(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function ya(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function da(t, e, n) {
      return e && ya(t.prototype, e), n && ya(t, n), t
    }

    function ga(t, e) {
      return !e || "object" !== fa(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ma(t) {
      return (ma = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ba(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && va(t, e)
    }

    function va(t, e) {
      return (va = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Sa = function (t) {
        function e(t) {
          var n;
          return ha(this, e), (n = ga(this, ma(e).call(this, t))).$element = null, n.$itemElement = null, n.$childContainerElement = null, n
        }
        return ba(e, t), da(e, [{
          key: "init",
          value: function () {
            this.filterOption ? this.filterOption.selectType : this.parent.selectType;
            this.requestInstantly = this.filterTreeType == pr.FilterTreeType.VERTICAL || o.a.getSettingValue("general.requestInstantly")
          }
        }, {
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<li class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-first-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t{{swatch}}\n\t\t\t\t\t<button class="{{class.button}}" data-action="select-filter-item">\n\t\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-second-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t'
          }
        }, {
          key: "getSwatchTemplate",
          value: function () {
            return '\n\t\t\t<span class="boost-pfs-filter-option-swatch-image" \n\t\t\t\tstyle="background-color: {{backgroundColor}}; \n\t\t\t\tbackground-image: url({{swatchFileUrl}});" title="{{label}}">\n\t\t\t</span>\n\t\t'
          }
        }, {
          key: "getArrowTemplate",
          value: function () {
            return '\n\t\t\t<button class="{{class.button}} {{class.button}}-arrow" data-action="expand-filter-item" aria-label="{{label.ada.toggleMultiLevel}}">\n\t\t\t\t<span class="boost-pfs-arrow"></span>\n\t\t\t</button>\n\t\t'
          }
        }, {
          key: "compileSwatchTemplate",
          value: function () {
            return this.getSwatchTemplate().replace(/{{backgroundColor}}/g, this.backgroundColor).replace(/{{swatchFileUrl}}/g, this.swatchFileUrl)
          }
        }, {
          key: "compileArrowTemplate",
          value: function () {
            return 3 != this.level && this.children && this.children.length > 0 ? this.getArrowTemplate().replace(/{{label.ada.toggleMultiLevel}}/g, Labels.ada.toggleMultiLevel.replace(/{{filterItem}}/g, this.label)) : ""
          }
        }, {
          key: "compileTemplate",
          value: function () {
            return this.getTemplate().replace(/{{class.filterOptionItem}}/g, p.a.filterOptionItem).replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{label}}/g, this.label).replace(/{{swatch}}/g, this.filterOption.displayTypeItem == Wi.a.DisplayType.SWATCH ? this.compileSwatchTemplate() : "").replace(/{{arrow}}/g, this.compileArrowTemplate()).replace(/{{class.button}}/g, p.a.button).replace(/{{childItems}}/g, "")
          }
        }, {
          key: "render",
          value: function () {
            var t = this;
            if (this.$element || (this.$element = r()(this.compileTemplate()), this.$itemElement = this.$element.find("> ." + p.a.filterOptionItem), this.$itemClickElement = this.$itemElement.find('[data-action="select-filter-item"]'), this.$toggleClickElement = this.$itemElement.find('[data-action="expand-filter-item"]'), this.$childContainerElement = this.$element.find("> .boost-pfs-filter-option-multi-level-list"), this.$childContainerElement && this.children && this.children.length > 0 && this.children.forEach((function (e) {
                e.$element && t.$childContainerElement.append(e.$element)
              }))), this.isSelected = this.isAppliedFilter(), this.isSelectedChild = !1, Array.isArray(this.children) && (this.isSelectedChild = this.children.some((function (t) {
                return t.isSelected || t.isSelectedChild
              }))), this.$itemElement) {
              this.isSelected || this.filterOption.selectType == Wi.a.SelectType.SINGLE && this.isSelectedChild ? this.$itemElement.addClass("selected") : this.$itemElement.removeClass("selected");
              var n = e.getLevelOpenStateData(this),
                i = o.a.getSettingValue("general.openMultiLevelByDefault");
              n || Array.isArray(i) && i.includes(this.level) || null == n && this.isSelectedChild ? (this.$itemElement.addClass("boost-pfs-open"), e.setLevelOpenStateData(this, !0)) : e.setLevelOpenStateData(this, !1)
            }
          }
        }, {
          key: "bindEvents",
          value: function () {
            this.$itemClickElement && this.$itemClickElement.on("click", this.onClick.bind(this)), this.$toggleClickElement && this.$toggleClickElement.on("click", this.onClickToggle.bind(this))
          }
        }, {
          key: "isAppliedFilter",
          value: function () {
            var t = l.a.queryParams[this.filterOption.filterOptionId];
            return !(!Array.isArray(t) || !t.includes(this.value))
          }
        }, {
          key: "onSelectFilter",
          value: function () {
            this.children && this.children.length > 0 && (this.$itemElement.addClass("boost-pfs-open"), e.setLevelOpenStateData(this, !0)), this.filterOption.selectType == Wi.a.SelectType.SINGLE && this.filterOption.allNestedFilterItems.forEach((function (t) {
              t.$itemElement && (t.$itemElement.removeClass("selected"), t.isSelected = !1)
            })), this.filterOption.selectType == Wi.a.SelectType.SINGLE ? (this.isSelected = !0, this.$itemElement.addClass("selected"), this.level > 1 && this.parent.$itemElement.addClass("selected"), this.level > 2 && this.parent.parent.$itemElement.addClass("selected")) : (this.isSelected = !this.isSelected, this.$itemElement.toggleClass("selected"))
          }
        }, {
          key: "onApplyFilter",
          value: function () {
            var t = this;
            if (this.isSelected && this.filterOption.selectType == Wi.a.SelectType.SINGLE) this.children && this.children.length > 0 && (this.$itemElement.addClass("boost-pfs-open"), e.setLevelOpenStateData(this, !0));
            else {
              this.children && this.children.length > 0 && e.setLevelOpenStateData(this, !0);
              var n = this.filterOption.filterOptionId;
              this.isSelected = !this.isSelected;
              var i = null;
              this.filterOption.selectType == Wi.a.SelectType.SINGLE ? i = this.isSelected ? [this.value] : [] : (i = l.a.queryParams[n], Array.isArray(i) || (i = []), this.isSelected ? i.includes(this.value) || i.push(this.value) : i = i.filter((function (e) {
                return e !== t.value
              }))), Ae.default.setParam(n, i), Ae.default.setParam(n + "_and_condition", !!(this.filterOption.useAndCondition && i.length > 0) || null), Ae.default.setParam("page", 1);
              var r = {
                filterOptionId: n,
                filterValue: this.value
              };
              Ae.default.applyFilter("filter", r)
            }
          }
        }, {
          key: "onClickToggle",
          value: function () {
            this.$itemElement.toggleClass("boost-pfs-open"), this.$itemElement.hasClass("boost-pfs-open") ? e.setLevelOpenStateData(this, !0) : e.setLevelOpenStateData(this, !1)
          }
        }, {
          key: "setData",
          value: function (t) {
            var e = this;
            this.value = t.tag, this.label = t.displayName ? t.displayName : t.tag, this.docCount = t.doc_count ? t.doc_count : 0, this.level = 1, this.id = this.value, this.filterOption = this.parent, this.label = this.buildLabel(), this.filterOption.displayTypeItem == Wi.a.DisplayType.SWATCH && this.setSwatchData(), this.children = [], Array.isArray(t.subTags) && t.subTags.forEach((function (t) {
              if (t.tag) {
                var n = new Oa(e.filterTreeType);
                e.addComponent(n), n.setData(t)
              }
            })), this.filterOption.allNestedFilterItems.set(this.value, this)
          }
        }, {
          key: "setSwatchData",
          value: function () {
            var t = this.filterOption.filterOptionId.replace("pf_t_", "").replace("pf_opt_", "");
            this.swatchFileName = t + "-" + u.a.slugify(this.label).replace(/\#/g, ""), this.swatchFileUrl = u.a.getFilePath(this.swatchFileName, l.a.swatchExtension, o.a.getSettingValue("general.swatchImageVersion"));
            var e = u.a.slugify(this.label).split("-");
            this.backgroundColor = e[e.length - 1]
          }
        }], [{
          key: "getLevelOpenStateData",
          value: function (t) {
            var e = t.filterOption.filterOptionId + ":" + t.value;
            return Pa.get(e)
          }
        }, {
          key: "setLevelOpenStateData",
          value: function (t, e) {
            var n = t.filterOption.filterOptionId + ":" + t.value;
            Pa.set(n, e)
          }
        }]), e
      }(Ir),
      Oa = function (t) {
        function e() {
          return ha(this, e), ga(this, ma(e).apply(this, arguments))
        }
        return ba(e, t), da(e, [{
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-second-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t{{swatch}}\n\t\t\t\t\t<button class="{{class.button}}" data-action="select-filter-item">\n\t\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t{{arrow}}\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-third-level-list">\n\t\t\t\t\t{{childItems}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
          }
        }, {
          key: "setData",
          value: function (t) {
            var e = this;
            this.value = t.tag, this.label = t.displayName ? t.displayName : t.tag, this.docCount = t.doc_count ? t.doc_count : 0, this.level = 2, this.parent && (this.requestInstantly = this.parent.requestInstantly, this.filterOption = this.parent.filterOption), this.label = this.buildLabel(), this.filterOption.displayTypeItem == Wi.a.DisplayType.SWATCH && this.setSwatchData(), this.children = [], Array.isArray(t.subTags) && t.subTags.forEach((function (t) {
              if (t.tag) {
                var n = new Ta(e.filterTreeType);
                e.addComponent(n), n.setData(t)
              }
            })), this.filterOption.allNestedFilterItems.set(this.value, this)
          }
        }]), e
      }(Sa),
      Ta = function (t) {
        function e() {
          return ha(this, e), ga(this, ma(e).apply(this, arguments))
        }
        return ba(e, t), da(e, [{
          key: "getTemplate",
          value: function () {
            return '\n\t\t\t<div class="boost-pfs-filter-option-multi-level-item boost-pfs-filter-option-third-level-item">\n\t\t\t\t<div class="{{class.filterOptionItem}} {{class.filterOptionLabel}}">\n\t\t\t\t\t{{swatch}}\n\t\t\t\t\t<button class="{{class.button}}" data-action="select-filter-item">\n\t\t\t\t\t\t<span class="boost-pfs-check-box"></span>\n\t\t\t\t\t\t<span class="boost-pfs-filter-option-value">{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
          }
        }, {
          key: "setData",
          value: function (t) {
            this.value = t.tag, this.label = t.displayName ? t.displayName : t.tag, this.docCount = t.doc_count ? t.doc_count : 0, this.level = 3, this.parent && (this.requestInstantly = this.parent.requestInstantly, this.filterOption = this.parent.filterOption), this.label = this.buildLabel(), this.filterOption.displayTypeItem == Wi.a.DisplayType.SWATCH && this.setSwatchData(), this.filterOption.allNestedFilterItems.set(this.value, this)
          }
        }]), e
      }(Oa),
      Pa = new Map,
      wa = Sa;

    function _a(t) {
      return (_a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ca(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ka(t, e) {
      return !e || "object" !== _a(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Ea(t) {
      return (Ea = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Ia(t, e) {
      return (Ia = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var La = function (t) {
        function e(t) {
          var n;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (n = ka(this, Ea(e).call(this))).filterTreeType = t, n.$clickElement = null, n.$toggleElement = null, n
        }
        var n, i, a;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Ia(t, e)
        }(e, t), n = e, a = [{
          key: "getCollapsedStateData",
          value: function (t) {
            return Fa.get(t)
          }
        }, {
          key: "setCollapsedStateData",
          value: function (t, e) {
            Fa.set(t, e)
          }
        }], (i = [{
          key: "init",
          value: function () {
            var t;
            if (this.isCollapsed = !1, this.filterTreeType == pr.FilterTreeType.HORIZONTAL) this.isCollapsed = !0;
            else if (o.a.getSettingValue("general.keepToggleState") && (t = e.getCollapsedStateData(this.parent.filterOptionId)), void 0 === t) {
              var n = u.a.isMobile();
              this.isCollapsed = n && (this.parent.isCollapseMobile || o.a.getSettingValue("general.collapseOnMobileByDefault")) || !n && (this.parent.isCollapsePC || o.a.getSettingValue("general.collapseOnPCByDefault"))
            } else this.isCollapsed = t
          }
        }, {
          key: "isBindEvents",
          value: function () {
            return !(this.isBoundEvent || !this.parent.$element || !this.parent.$filterOptionContentElement || !this.parent.$filterOptionTitleElement)
          }
        }, {
          key: "bindEvents",
          value: function () {
            this.$clickElement = this.parent.$filterOptionTitleElement, this.$toggleElement = this.parent.$filterOptionContentElement, this.filterTreeType == pr.FilterTreeType.VERTICAL ? this.$clickElement.on("click", this.onToggleVertical.bind(this)) : (this.$clickElement.on("click", this.onToggleHorizontal.bind(this)), Ra || (Ra = !0, r()("body").on("click", this.onClickOutSideHorizontal.bind(this))), this.parent.filterOptionId == Aa && (Aa = "", this.onToggleHorizontal())), this.$clickElement.attr("aria-expanded", !this.isCollapsed)
          }
        }, {
          key: "onToggleVertical",
          value: function () {
            this.isCollapsed = !this.isCollapsed, o.a.getSettingValue("general.keepToggleState") && e.setCollapsedStateData(this.parent.filterOptionId, this.isCollapsed), this.parent.$element.toggleClass("boost-pfs-filter-option-collapsed"), this.$clickElement.attr("aria-expanded", !this.isCollapsed), this.$toggleElement.slideToggle(400, this.afterToggle.bind(this))
          }
        }, {
          key: "onToggleHorizontal",
          value: function () {
            var t = !this.isCollapsed;
            this.calculateHorizontalColumn();
            var e = this.closeAllHorizontalTabs();
            t || (e ? Aa = this.parent.filterOptionId : (Aa = "", this.parent.$element.removeClass("boost-pfs-filter-option-collapsed"), this.$clickElement.attr("aria-expanded", !0), this.$toggleElement.show(), this.isCollapsed = !1)), this.afterToggle()
          }
        }, {
          key: "onClickOutSideHorizontal",
          value: function (t) {
            if (t && t.target) {
              var e = r()(t.target);
              e.closest(s.a.filterTreeHorizontal + " ." + p.a.filterOption).length > 0 || e.closest(s.a.filterTreeHorizontal + " ." + p.a.clearButton).length > 0 || e.closest(s.a.filterTreeHorizontal + " ." + p.a.clearAllButton).length > 0 || this.closeAllHorizontalTabs()
            }
          }
        }, {
          key: "closeAllHorizontalTabs",
          value: function () {
            var t = this.parent.parent,
              e = !1;
            return t.filterOptions.forEach((function (t) {
              t.$element && t.collapse && !t.collapse.isCollapsed && (t.$element.addClass("boost-pfs-filter-option-collapsed"), t.$filterOptionTitleElement.attr("aria-expanded", !1), t.collapse.isCollapsed = !0, t.collapse.$toggleElement.hide(), (t.allNestedFilterItems ? t.allNestedFilterItems : t.filterItems).forEach((function (n) {
                e || n.isAppliedFilter() != n.isSelected && (e = t)
              })))
            })), !!e && (e.applyButton.onApplyOptionValues(), !0)
          }
        }, {
          key: "afterToggle",
          value: function () {}
        }, {
          key: "calculateHorizontalColumn",
          value: function () {
            var t = this.parent.displayColumn,
              e = "left",
              n = this.parent.$filterOptionTitleElement.offset();
            if (1 != t && "1" != t || this.parent.displayType != FilterOptionEnum.DisplayType.RANGE || (t = 2), n && n.left) switch (t) {
            case 1:
            case "1":
              n.left + 250 > r()(window).width() && (e = "right");
              break;
            case 2:
            case "2":
              n.left + 532 > r()(window).width() && (e = n.left < 532 ? "center" : "right");
              break;
            case 3:
            case "3":
              n.left + 700 > r()(window).width() && (e = "right")
            }
            "left" == e ? (this.parent.$element.removeClass("boost-pfs-filter-option-right"), this.parent.$element.addClass("boost-pfs-filter-option-left")) : "center" == e ? (this.parent.$element.removeClass("boost-pfs-filter-option-left"), this.parent.$element.removeClass("boost-pfs-filter-option-right"), this.parent.$element.addClass("boost-pfs-filter-option-center")) : (this.parent.$element.removeClass("boost-pfs-filter-option-left"), this.parent.$element.addClass("boost-pfs-filter-option-right"))
          }
        }]) && Ca(n.prototype, i), a && Ca(n, a), e
      }(f.a),
      Aa = "",
      Fa = new Map,
      Ra = !1,
      ja = La;

    function $a(t) {
      return ($a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ba(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function xa(t, e) {
      return !e || "object" !== $a(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Ma(t) {
      return (Ma = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Da(t, e) {
      return (Da = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Va = function (t) {
      function e(t) {
        var n;
        ! function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = xa(this, Ma(e).call(this))).filterItems = new Map, n.clearButton = null, n.applyButton = null, n.searchBox = null, n.filterTreeType = t, n.$element = null, n.$filterOptionTitleElement = null, n.$filterOptionContentElement = null, n.$filterItemsContainerElement = null;
        var i = n.filterTreeType == pr.FilterTreeType.VERTICAL;
        return n.selector = {
          filterOptionTitle: "." + p.a.filterOptionTitle + " > button",
          filterOptionContent: "." + p.a.filterOptionContent,
          filterItemsContainer: "ul",
          clearButtonContainer: i ? "." + p.a.filterOptionTitle : "." + p.a.filterOptionContent,
          applyButtonContainer: "." + p.a.filterOptionContent,
          viewMoreContainer: "." + p.a.filterOptionContent,
          searchBoxContainer: "." + p.a.filterOptionContent,
          tooltipContainer: "." + p.a.filterOptionTitle + " > ." + p.a.filterOptionTitle + "-heading",
          numberFilterItemsContainer: "." + p.a.filterOptionTitle + "-count"
        }, n
      }
      var n, i, l;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Da(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          this.collapse = new ja(this.filterTreeType), this.addComponent(this.collapse), this.clearButton = new mr(this.filterTreeType, mr.ClearType.CLEAR_OPTION_VALUES), this.addComponent(this.clearButton), this.applyButton = new Pr(this.filterTreeType, Pr.ApplyType.APPLY_OPTION_VALUES), this.addComponent(this.applyButton), this.viewMore = new Ao(this.filterTreeType), this.addComponent(this.viewMore), this.scrollbar = new Jo, this.addComponent(this.scrollbar), this.searchBox = new xo, this.addComponent(this.searchBox), this.filterTooltip = new qo(this.tooltip), this.addComponent(this.filterTooltip)
        }
      }, {
        key: "getTemplate",
        value: function () {
          switch (this.filterTreeType) {
          case "vertical":
            return '\n\t\t\t\t<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">\n\t\t\t\t\t<div class="{{class.filterOptionTitle}}">\n\t\t\t\t\t\t<button aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">\n\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-text">\n\t\t\t\t\t\t\t\t{{blockTitle}}\n\t\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-count">\n\t\t\t\t\t\t\t\t\t{{numberAppliedFilterItems}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t{{tooltip}}\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<p class="boost-pfs-filter-selected-items-mobile"></p>\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="{{class.filterOptionContent}}">\n\t\t\t\t\t\t{{searchBox}}\n\t\t\t\t\t\t<div class="{{class.filterOptionContentInner}}">\n\t\t\t\t\t\t\t{{blockContent}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t{{viewMore}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t';
          case "horizontal":
            return '\n\t\t\t\t<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}} {{class.filterScrollbar}} {{displayColumn}}">\n\t\t\t\t\t<div class="{{class.filterOptionTitle}}">\n\t\t\t\t\t\t<button aria-label="{{ada.filterOptionTitle}}" tabindex="0" class="{{class.button}} {{class.filterOptionTitle}}-heading">\n\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-text">\n\t\t\t\t\t\t\t{{blockTitle}}\n\t\t\t\t\t\t\t\t<span class="{{class.filterOptionTitle}}-count">\n\t\t\t\t\t\t\t\t\t{{numberAppliedFilterItems}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t{{tooltip}}\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="{{class.filterOptionContent}}">\n\t\t\t\t\t\t<div class="{{class.filterOptionContentInner}}">\n\t\t\t\t\t\t\t{{blockContent}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t{{viewMore}}\n\t\t\t\t\t\t{{applyButton}}\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t';
          default:
            throw Error("filterTreeType is wrong")
          }
        }
      }, {
        key: "getBlockContentTemplate",
        value: function () {
          throw Error("Override this method")
        }
      }, {
        key: "compileBlockContentTemplate",
        value: function () {
          return this.getBlockContentTemplate()
        }
      }, {
        key: "compileTemplate",
        value: function () {
          var t = u.a.slugify(this.label),
            e = u.a.slugify(this.displayType.replace(/_/g, "-")),
            n = Jo.isEnabled(this.displayType, this.filterType, this.showMoreType) ? p.a.filterHasScrollbar : p.a.filterNoScrollbar,
            i = "boost-pfs-filter-option-column-" + this.displayColumn;
          return this.getTemplate().replace(/{{blockTitle}}/g, this.label).replace(/{{blockTypeClass}}/g, p.a.filterOption + "-" + e).replace(/{{blockId}}/g, p.a.filterOption + "-" + t).replace(/{{blockContent}}/g, this.compileBlockContentTemplate()).replace(/{{blockContentId}}/g, p.a.filterOptionContent + "-" + t).replace(/{{displayColumn}}/g, i).replace(/{{class.filterOption}}/g, p.a.filterOption).replace(/{{class.filterOptionContent}}/g, p.a.filterOptionContent).replace(/{{class.filterOptionContentInner}}/g, p.a.filterOptionContentInner).replace(/{{class.filterOptionTitle}}/g, p.a.filterOptionTitle).replace(/{{class.filterScrollbar}}/g, n).replace(/{{class.filterOptionItemList}}/g, p.a.filterOptionItemList).replace(/{{class.filterOptionItemListSingleList}}/g, p.a.filterOptionItemListSingleList).replace(/{{class.filterOptionItemListMultipleList}}/g, p.a.filterOptionItemListMultipleList).replace(/{{class.filterOptionItemListBox}}/g, p.a.filterOptionItemListBox).replace(/{{class.filterOptionItemListSwatch}}/g, p.a.filterOptionItemListSwatch).replace(/{{class.filterOptionItemListRating}}/g, p.a.filterOptionItemListRating).replace(/{{class.filterOptionMultiLevelTag}}/g, p.a.filterOptionMultiLevelTag).replace(/{{class.filterOptiontemListMultiLevelCollections}}/g, p.a.filterOptiontemListMultiLevelCollections).replace(/{{class.button}}/g, p.a.button).replace(/{{ada.filterOptionTitle}}/g, a.a.ada.filterOptionTitle.replace("{{filterOption}}", this.label)).replace(/{{tooltip}}/g, "").replace(/{{clearButton}}/g, "").replace(/{{applyButton}}/g, "").replace(/{{searchBox}}/g, "").replace(/{{viewMore}}/g, "").replace(/{{filterItems}}/g, "").replace(/\n/g, "").replace(/\t/g, "")
        }
      }, {
        key: "isRender",
        value: function () {
          if (this.status == Wi.a.Status.ACTIVE) {
            var t = o.a.getSettingValue("general.showSingleOption"),
              e = 0,
              n = this.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS || this.displayType == Wi.a.DisplayType.MULTI_LEVEL_TAG;
            return this.filterItems.forEach((function (t) {
              t.$element && t.$element.length && (e++, n && Array.isArray(t.children) && t.children.length > 0 && (e += t.children.length))
            })), t ? e > 1 : e > 0
          }
          return !1
        }
      }, {
        key: "isBindEvents",
        value: function () {
          return !this.isBoundEvent
        }
      }, {
        key: "render",
        value: function () {
          var t = this;
          if (!this.$element) {
            this.$element = r()(this.compileTemplate()), this.$filterOptionContentElement = this.$element.find(this.selector.filterOptionContent), this.$filterOptionTitleElement = this.$element.find(this.selector.filterOptionTitle), this.$filterItemsContainerElement = this.$element.find(this.selector.filterItemsContainer).html(""), this.filterItems.forEach((function (e) {
              e.isRenderOnScroll || t.$filterItemsContainerElement.append(e.$element)
            })), this.$element.find(this.selector.searchBoxContainer).prepend(this.searchBox.$element), this.$element.find(this.selector.viewMoreContainer).append(this.viewMore.$element), this.$element.find(this.selector.applyButtonContainer).append(this.applyButton.$element), this.$element.find(this.selector.clearButtonContainer).append(this.clearButton.$element);
            var e = this.$element.find(this.selector.tooltipContainer);
            e.append(this.filterTooltip.$element), e.append(this.filterTooltip.$popupElement), this.collapse.isCollapsed && (this.$element.addClass("boost-pfs-filter-option-collapsed"), this.$filterOptionContentElement.hide())
          }
          this.numberAppliedFilterItems = this.getNumberAppliedFilterItems(), this.$element.find(this.selector.numberFilterItemsContainer).html(this.numberAppliedFilterItems > 0 ? this.numberAppliedFilterItems : "")
        }
      }, {
        key: "getNumberAppliedFilterItems",
        value: function () {
          var t = 0,
            e = [Wi.a.DisplayType.LIST, Wi.a.DisplayType.BOX, Wi.a.DisplayType.SWATCH, Wi.a.DisplayType.RATING, Wi.a.DisplayType.MULTI_LEVEL_TAG];
          return this.filterItems && e.includes(this.displayType) && this.filterItems.forEach((function (e) {
            e.isSelected && t++
          })), t
        }
      }, {
        key: "setData",
        value: function (t) {
          var e = this;
          this.status = t.status, this.position = t.position, this.label = u.a.stripHtml(u.a.stripScriptTag(t.label)), this.filterOptionId = t.filterOptionId, this.filterType = t.filterType, this.displayType = t.displayType, this.selectType = t.selectType, this.valueType = t.valueType, this.displayTypeItem = t.displayTypeItem, this.manualValues = t.manualValues ? t.manualValues : [], this.prefix = t.prefix, this.isCollapsePC = t.isCollapsePC, this.isCollapseMobile = t.isCollapseMobile, this.showSearchBoxFilterPC = t.showSearchBoxFilterPC, this.showSearchBoxFilterMobile = t.showSearchBoxFilterMobile, this.keepValuesStatic = t.keepValuesStatic, this.activeCollectionAll = t.activeCollectionAll, this.tooltip = t.tooltip, this.showMoreType = null == t.showMoreType || "" == t.showMoreType ? Wi.a.ShowMoreType.SCROLLBAR : t.showMoreType, this.sortType = t.sortType, this.sortManualValues = t.sortManualValues, this.displayAllValuesInUppercaseForm = t.displayAllValuesInUppercaseForm, this.useAndCondition = t.useAndCondition, this.showExactRating = t.showExactRating, this.excludePriceFromValue = t.excludePriceFromValue, this.starColor = u.a.stripHtml(u.a.stripScriptTag(t.starColor)), this.displayColumn = t.displayColumn ? t.displayColumn : o.a.getSettingValue("general.filterHorizontalColumn"), this.children = [], this.filterItems = new Map;
          var n = [];
          t.values ? n = Array.isArray(t.values) ? t.values : [t.values] : t.manualValues && (n = Array.isArray(t.manualValues) ? t.manualValues : [t.manualValues]), this.isSortValues() && this.sortValues(n), this.modifyValues(n), this.markValuesAsNoRender(n), n.forEach((function (t) {
            var n = null;
            switch (e.displayType) {
            case Wi.a.DisplayType.LIST:
              n = new $r(e.filterTreeType);
              break;
            case Wi.a.DisplayType.BOX:
              n = new qr(e.filterTreeType);
              break;
            case Wi.a.DisplayType.SWATCH:
              n = new Jr(e.filterTreeType);
              break;
            case Wi.a.DisplayType.RATING:
              n = new oo(e.filterTreeType);
              break;
            case Wi.a.DisplayType.RANGE:
              n = new To(e.filterTreeType);
              break;
            case Wi.a.DisplayType.SUB_CATEGORY:
              n = new ho(e.filterTreeType);
              break;
            case Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
              n = new pa(e.filterTreeType);
              break;
            case Wi.a.DisplayType.MULTI_LEVEL_TAG:
              n = new wa(e.filterTreeType)
            }
            if (n) {
              e.addComponent(n), n.setData(t);
              var i = n.key ? n.key : n.value;
              e.filterItems.set(i, n)
            }
          }))
        }
      }, {
        key: "isSortValues",
        value: function () {
          if ([Wi.a.FilterType.REVIEW_RATINGS, Wi.a.FilterType.PERCENT_SALE].includes(this.filterType)) return !0;
          var t = [Wi.a.FilterType.STOCK],
            e = [Wi.a.DisplayType.RANGE, Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS],
            n = this.valueType == Wi.a.ValueType.ALL,
            i = this.valueType != Wi.a.ValueType.ALL && (this.sortManualValues || o.a.getSettingValue("general.sortManualValues")),
            r = this.displayType == Wi.a.DisplayType.RANGE && 0 == this.isNumberRangeSlider;
          return !t.includes(this.filterType) && (!e.includes(this.displayType) || r) && (n || i)
        }
      }, {
        key: "sortValues",
        value: function (t) {
          var e = this.sortType ? this.sortType : Wi.a.SortType.KEY_ASCENDING,
            n = e.split("-")[0],
            i = "key" == n ? "doc_count" : "key";
          this.filterType == Wi.a.FilterType.COLLECTION && "key" == n && (n = "label"), t && t.length > 0 && t.sort(function (t, e) {
            var r = -1;
            if (null != t[n] && null != e[n]) {
              var o = t[n].toString().toLowerCase(),
                a = e[n].toString().toLowerCase();
              if (0 == (r = this.naturalSortFunction(o, a)) && null != t[i] && null != e[i]) {
                var l = t[i].toString().toLowerCase(),
                  s = e[i].toString().toLowerCase();
                r = this.naturalSortFunction(l, s)
              }
            }
            return r
          }.bind(this)), (e.indexOf("desc") > -1 || this.filterType == Wi.a.FilterType.REVIEW_RATINGS || this.filterType == Wi.a.FilterType.PERCENT_SALE) && t.reverse()
        }
      }, {
        key: "naturalSortFunction",
        value: function (t, e) {
          function n(t) {
            for (var e, n, i = [], r = 0, o = -1, a = 0; e = (n = t.charAt(r++)).charCodeAt(0);) {
              var l = 46 == e || e >= 48 && e <= 57;
              l !== a && (i[++o] = "", a = l), i[o] += n
            }
            return i
          }
          for (var i = n(t), r = n(e), o = 0; i[o] && r[o]; o++)
            if (i[o] !== r[o]) {
              var a = Number(i[o]),
                l = Number(r[o]);
              return a == i[o] && l == r[o] ? a - l : i[o] > r[o] ? 1 : -1
            }
          return i.length - r.length
        }
      }, {
        key: "modifyValues",
        value: function (t) {
          if (this.filterType == Wi.a.FilterType.COLLECTION) {
            if (this.activeCollectionAll && !t.some((function (t) {
                return "all" == t.handle
              }))) {
              var e = {
                key: "0",
                label: a.a.collectionAll,
                handle: "all"
              };
              t.unshift(e)
            }
            if (t.forEach((function (t) {
                t.sort_order && (t.sort_order.endsWith("-desc") ? t.sort_order = t.sort_order.replace(/-desc$/, "-descending") : t.sort_order.endsWith("-asc") && (t.sort_order = t.sort_order.replace(/-asc$/, "-ascending")), t.sort_order.startsWith("alpha") && (t.sort_order = t.sort_order.replace(/alpha/, "title")))
              })), !this.keepValuesStatic && !o.a.getSettingValue("general.showOutOfStockOption"))
              for (var n = t.length - 1; n >= 0; n--) 0 == t[n].doc_count && t.splice(n, 1)
          }
        }
      }, {
        key: "markValuesAsNoRender",
        value: function (t) {
          var e = o.a.getSettingValue("general.scrollFirstLoadLength"),
            n = [Wi.a.DisplayType.LIST, Wi.a.DisplayType.BOX, Wi.a.DisplayType.SWATCH];
          u.a.isMobile() ? n = [Wi.a.DisplayType.LIST, Wi.a.DisplayType.SWATCH] : this.filterTreeType == pr.FilterTreeType.VERTICAL && (n = [Wi.a.DisplayType.LIST, Wi.a.DisplayType.BOX]), Array.isArray(t) && t.length > e && n.includes(this.displayType) && Jo.isEnabled(this.displayType, this.filterType, this.showMoreType) && (this.isLoadMoreOnScroll = !0, t.forEach((function (t, n) {
            t.isRenderOnScroll = n >= e
          })))
        }
      }]) && Ba(n.prototype, i), l && Ba(n, l), e
    }(f.a);

    function Na(t) {
      return (Na = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ua(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function qa(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Ha(t, e) {
      return !e || "object" !== Na(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Wa(t, e, n) {
      return (Wa = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ga(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function Ga(t) {
      return (Ga = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function za(t, e) {
      return (za = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ka = function (t) {
      function e() {
        return Ua(this, e), Ha(this, Ga(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && za(t, e)
      }(e, t), n = e, (i = [{
        key: "getBlockContentTemplate",
        value: function () {
          return this.selectType == Wi.a.SelectType.SINGLE ? '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSingleList}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t' : '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListMultipleList}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t'
        }
      }, {
        key: "prepareFilterOptionData",
        value: function (t) {
          if (("price" == t.filterType || "variants_price" == t.filterType) && t.values && jQ.isArray(t.values))
            for (var e = 0; e < t.values.length; e++) {
              var n = !1,
                i = !1;
              t.values[e].hasOwnProperty("to") && (n = !0, t.values[e].to = u.a.convertPriceBasedOnActiveCurrency(t.values[e].to)), t.values[e].hasOwnProperty("from") && (i = !0, t.values[e].from = u.a.convertPriceBasedOnActiveCurrency(t.values[e].from)), t.values[e].key = n && i ? t.values[e].from + "-" + t.values[e].to : n ? "*-" + t.values[e].to : t.values[e].from + "-*"
            }
          return t
        }
      }, {
        key: "setData",
        value: function (t) {
          t = this.prepareFilterOptionData(t), Wa(Ga(e.prototype), "setData", this).call(this, t)
        }
      }]) && qa(n.prototype, i), r && qa(n, r), e
    }(Va);

    function Ya(t) {
      return (Ya = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Qa(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function Ja(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Za(t, e) {
      return !e || "object" !== Ya(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Xa(t) {
      return (Xa = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function tl(t, e) {
      return (tl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var el = function (t) {
      function e() {
        return Qa(this, e), Za(this, Xa(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && tl(t, e)
      }(e, t), n = e, (i = [{
        key: "getBlockContentTemplate",
        value: function () {
          return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListBox}}">{{filterItems}}</ul>\n\t\t'
        }
      }, {
        key: "calculateBoxItemSize",
        value: function () {
          if (!o.a.getSettingValue("general.enableFilterOptionBoxStyle")) return "";
          var t = this.$element ? this.$element.width() : 0;
          if (!t || t < 0) return "100%";
          if (!this.boxItemSize) {
            var e = 4,
              n = o.a.getSettingValue("general.filterOptionBoxCharWidth") || 14;
            this.filterItems.forEach((function (t) {
              var i = t.label.length * n;
              e = Math.max(i, e)
            }));
            var i = 100 / (Math.floor(this.$element.width() / (e + 8)) || 1) - 2;
            i < 1 && (i = 100), this.boxItemSize = i + "%"
          }
          return this.boxItemSize
        }
      }]) && Ja(n.prototype, i), r && Ja(n, r), e
    }(Va);

    function nl(t) {
      return (nl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function il(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function rl(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ol(t, e) {
      return !e || "object" !== nl(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function al(t) {
      return (al = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ll(t, e) {
      return (ll = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var sl = function (t) {
      function e() {
        return il(this, e), ol(this, al(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ll(t, e)
      }(e, t), n = e, (i = [{
        key: "getBlockContentTemplate",
        value: function () {
          return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSwatch}} {{swatchStyle}}">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'
        }
      }, {
        key: "compileBlockContentTemplate",
        value: function () {
          return this.swatchStyle = this.buildSwatchStyle(), this.getBlockContentTemplate().replace(/{{swatchStyle}}/g, this.swatchStyle)
        }
      }, {
        key: "buildSwatchStyle",
        value: function () {
          var t = o.a.getSettingValue("general.swatchStyle");
          return t || (this.filterTreeType == pr.FilterTreeType.HORIZONTAL || u.a.isMobile() && "style2" == o.a.getSettingValue("general.filterTreeMobileStyle") ? "circle-list" : "circle-grid")
        }
      }]) && rl(n.prototype, i), r && rl(n, r), e
    }(Va);

    function cl(t) {
      return (cl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ul(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function pl(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function fl(t, e) {
      return !e || "object" !== cl(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function hl(t) {
      return (hl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function yl(t, e) {
      return (yl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var dl = function (t) {
      function e() {
        return ul(this, e), fl(this, hl(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && yl(t, e)
      }(e, t), n = e, (i = [{
        key: "getBlockContentTemplate",
        value: function () {
          return this.selectType == Wi.a.SelectType.MULTIPLE && this.showExactRating ? '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListRating}} {{class.filterOptionItemListMultipleList}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t' : '\n\t\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListRating}}">\n\t\t\t\t\t{{filterItems}}\n\t\t\t\t</ul>\n\t\t\t'
        }
      }]) && pl(n.prototype, i), r && pl(n, r), e
    }(Va);
    n(153);

    function gl(t) {
      return (gl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ml(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function bl(t, e) {
      return !e || "object" !== gl(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function vl(t) {
      return (vl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Sl(t, e) {
      return (Sl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ol = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = bl(this, vl(e).call(this))).filterTreeType = t, n.$element = null, n
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Sl(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          this.clearButton = new mr(this.filterTreeType, mr.ClearType.CLEAR_SINGLE_VALUE), this.addComponent(this.clearButton)
        }
      }, {
        key: "getTemplate",
        value: function () {
          switch (this.filterTreeType) {
          case pr.FilterTreeType.VERTICAL:
            return '\n\t\t\t\t\t<div class="refine-by-item {{class.filterOptionLabel}}">\n\t\t\t\t\t\t<a tabindex="-1" href="javascript:;">\n\t\t\t\t\t\t\t<span class="refine-by-type">\n\t\t\t\t\t\t\t\t<span>{{type}}</span><strong>{{label}}</strong>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t';
          case pr.FilterTreeType.HORIZONTAL:
            return '\n\t\t\t\t\t<div class="refine-by-item">\n\t\t\t\t\t\t<a tabindex="-1" href="javascript:;">\n\t\t\t\t\t\t\t<span class="{{class.filterOptionLabel}} refine-by-type">{{label}}</span>\n\t\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t';
          default:
            throw Error("Wrong filterTreeType")
          }
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.filterOptionLabel}}/g, p.a.filterOptionLabel).replace(/{{type}}/g, this.type ? this.type + ": " : "").replace(/{{label}}/g, this.label).replace(/{{clearButton}}/g, "")
        }
      }, {
        key: "render",
        value: function () {
          this.$element = r()(this.compileTemplate()), this.$element.find("a").append(this.clearButton.$element)
        }
      }, {
        key: "setData",
        value: function (t, e, n) {
          this.filterOption = t, this.filterItem = e, this.filterOptionId = t.filterOptionId, this.filterItemId = n, this.type = t.label, this.label = this.buildLabel()
        }
      }, {
        key: "buildLabel",
        value: function () {
          var t = this.filterItemId;
          if (this.filterOption) switch (this.filterOption.displayType) {
          case Wi.a.DisplayType.RANGE:
            t = this.buildLabelRange();
            break;
          case Wi.a.DisplayType.RATING:
            t = this.buildLabelRating();
            break;
          case Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
          case Wi.a.DisplayType.MULTI_LEVEL_TAG:
            t = this.buildLabelMultiLevel();
            break;
          default:
            if (this.filterItem) t = this.filterItem.label;
            else {
              var e = new Ir(this.filterOption.filterTreeType);
              e.filterOption = this.filterOption, e.label = this.filterItemId, t = e.buildLabel()
            }
          }
          return t
        }
      }, {
        key: "buildLabelRating",
        value: function () {
          var t = "";
          if (this.filterItem) {
            var e = this.filterItem.from;
            t = Math.ceil(e) + " ", 1 == Math.ceil(e) ? t += a.a.ratingStar : t += a.a.ratingStars, this.filterOption.showExactRating || (t += " " + a.a.ratingUp)
          }
          return t
        }
      }, {
        key: "buildLabelRange",
        value: function () {
          var t = "";
          if (this.filterOption)
            if (this.filterOption.isNumberRangeSlider)(e = this.filterItemId.split(":")) && 2 == e.length && (t = (n = this.filterOption.buildLabel(e[0])) == (i = this.filterOption.buildLabel(e[1])) ? n : n + " - " + i);
            else {
              var e = this.filterItemId,
                n = "",
                i = "";
              if (this.filterOption.currentMax - 1 > 0 && this.filterOption.currentMax - 1 < this.filterOption.valuesData.length ? (n = this.filterOption.valuesData[this.filterOption.currentMin].key, i = this.filterOption.valuesData[this.filterOption.currentMax - 1].key) : Array.isArray(e) && e.length > 0 && (n = e[0], i = e[e.length - 1]), this.filterOption.prefix) {
                var r = this.filterOption.prefix.replace(/\\/g, "");
                n = n.replace(r, "").trim(), i = i.replace(r, "").trim()
              }
              t = n == i ? n : n + " - " + i
            }
          return t
        }
      }, {
        key: "buildLabelMultiLevel",
        value: function () {
          var t = "";
          if (this.filterOption && this.filterItem && (this.filterOption.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS || this.filterOption.displayType == Wi.a.DisplayType.MULTI_LEVEL_TAG)) switch (this.filterItem.level) {
          case 1:
            this.type = this.filterOption.label, t = this.filterItem.buildLabel();
            break;
          case 2:
          case 3:
            this.filterOptionId = this.filterOptionId.replace(Globals.prefix + "_c_", Globals.prefix + "_ct_"), this.type = this.filterOption.label, t = this.filterItem.buildLabel()
          }
          return t || this.filterItemId
        }
      }]) && ml(n.prototype, i), o && ml(n, o), e
    }(f.a);

    function Tl(t) {
      return (Tl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Pl(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function wl(t, e) {
      return !e || "object" !== Tl(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function _l(t) {
      return (_l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Cl(t, e) {
      return (Cl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var kl = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = wl(this, _l(e).call(this))).refineByItems = [], n.clearAllButton = null, n.filterTreeType = t, n.$element = null, n
      }
      var n, i, o;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Cl(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          Settings.getSettingValue("general.separateRefineByFromFilter") && (r()(s.a.filterRefineByHorizontal).length > 0 ? this.filterTreeType = pr.FilterTreeType.HORIZONTAL : r()(s.a.filterRefineByVertical).length > 0 && (this.filterTreeType = pr.FilterTreeType.VERTICAL)), this.clearAllButton = new mr(this.filterTreeType, mr.ClearType.CLEAR_ALL), this.addComponent(this.clearAllButton)
        }
      }, {
        key: "getTemplate",
        value: function () {
          switch (this.filterTreeType) {
          case pr.FilterTreeType.VERTICAL:
            return '\n\t\t\t\t\t<div class="{{class.filterRefineBy}}">\n\t\t\t\t\t\t<div class="{{class.filterOptionTitle}}">\n\t\t\t\t\t\t\t<h3><span>{{label}}</span></h3>\n\t\t\t\t\t\t\t{{clearAllButton}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t';
          case pr.FilterTreeType.HORIZONTAL:
            return '\n\t\t\t\t\t<div class="boost-pfs-filter-pc {{class.filterRefineBy}}">\n\t\t\t\t\t\t<span>{{label}}</span>\n\t\t\t\t\t\t<div class="{{class.filterSelectedItems}}">{{refineByItems}}</div>\n\t\t\t\t\t\t{{clearAllButton}}\n\t\t\t\t\t</div>\n\t\t\t\t';
          default:
            throw Error("Wrong filterTreeType")
          }
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{class.filterRefineBy}}/g, p.a.filterRefineBy).replace(/{{class.filterOptionTitle}}/g, p.a.filterOptionTitle).replace(/{{class.filterSelectedItems}}/g, p.a.filterSelectedItems).replace(/{{label}}/g, a.a.refine).replace(/{{refineByItems}}/g, "").replace(/{{clearAllButton}}/g, "")
        }
      }, {
        key: "render",
        value: function () {
          var t = this;
          this.refineByItems && this.refineByItems.length > 0 ? (this.$element = r()(this.compileTemplate()), this.$refineByItemsContainer = this.$element.find("." + p.a.filterSelectedItems), this.refineByItems.forEach((function (e) {
            t.$refineByItemsContainer.append(e.$element)
          })), this.$clearAllButtonContainer = this.filterTreeType == pr.FilterTreeType.VERTICAL ? this.$element.find("." + p.a.filterOptionTitle) : this.$element, this.$clearAllButtonContainer.append(this.clearAllButton.$element)) : this.$element = null
        }
      }, {
        key: "setData",
        value: function () {
          var t = this;
          this.refineByItems = [];
          var e = Object.keys(l.a.queryParams).filter((function (t) {
            return t.startsWith(l.a.prefix)
          }));
          e && e.length > 0 && e.forEach((function (e) {
            var n = t.parent.filterOptions.get(e),
              i = e.startsWith(l.a.prefix + "_ct_");
            i && (n = t.parent.filterOptions.get(e.replace(l.a.prefix + "_ct_", l.a.prefix + "_c_")));
            var r = l.a.queryParams[e],
              o = e.startsWith(l.a.prefix + "_c_");
            if (o && !Array.isArray(r) && (r = [r]), n && r) {
              var a = n.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS || n.displayType == Wi.a.DisplayType.MULTI_LEVEL_TAG;
              if (n.displayType == Wi.a.DisplayType.RANGE) {
                var s = new Ol(t.filterTreeType),
                  c = "";
                c = n.isNumberRangeSlider ? r[0] : r, s.setData(n, null, c), t.refineByItems.push(s), t.addComponent(s)
              } else if (a) {
                var u = n.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS && Settings.getSettingValue("general.multiLevelCollectionSelectType") == Wi.a.SelectType.SINGLE || n.displayType == Wi.a.DisplayType.MULTI_LEVEL_TAG && n.selectType == Wi.a.SelectType.SINGLE;
                Object.values(r).forEach((function (e) {
                  var r = e;
                  i && (r = l.a.collectionId + ":" + e);
                  var a = n.allNestedFilterItems.get(r);
                  if (!(u && o && a && a.isSelectedChild)) {
                    var s = new Ol(t.filterTreeType);
                    s.setData(n, a, e), t.refineByItems.push(s), t.addComponent(s)
                  }
                }))
              } else Object.values(r).forEach((function (e) {
                var i = n.filterItems.get(e),
                  r = new Ol(t.filterTreeType);
                r.setData(n, i, e), t.refineByItems.push(r), t.addComponent(r)
              }))
            }
          }))
        }
      }]) && Pl(n.prototype, i), o && Pl(n, o), e
    }(f.a);

    function El(t) {
      return (El = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Il(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function Ll(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Al(t, e) {
      return !e || "object" !== El(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Fl(t) {
      return (Fl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Rl(t, e) {
      return (Rl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var jl = function (t) {
        function e() {
          return Il(this, e), Al(this, Fl(e).apply(this, arguments))
        }
        var n, i, r;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Rl(t, e)
        }(e, t), n = e, (i = [{
          key: "getBlockContentTemplate",
          value: function () {
            return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptionItemListSingleList}}">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'
          }
        }]) && Ll(n.prototype, i), r && Ll(n, r), e
      }(Va),
      $l = (n(96), n(104)),
      Bl = n.n($l);

    function xl(t) {
      return (xl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Ml(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function Dl(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Vl(t, e) {
      return !e || "object" !== xl(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Nl(t, e, n) {
      return (Nl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ul(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function Ul(t) {
      return (Ul = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ql(t, e) {
      return (ql = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Hl = function (t) {
      function e() {
        return Ml(this, e), Vl(this, Ul(e).apply(this, arguments))
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ql(t, e)
      }(e, t), n = e, (i = [{
        key: "init",
        value: function () {
          Nl(Ul(e.prototype), "init", this).call(this), this.requestInstantly = this.filterTreeType == pr.FilterTreeType.VERTICAL || o.a.getSettingValue("general.requestInstantly")
        }
      }, {
        key: "getBlockContentTemplate",
        value: function () {
          return this.hideInputElement ? '\n\t\t\t\t<div>\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider"></div>\n\t\t\t\t</div>\n\t\t\t' : "style3" == this.style ? '\n\t\t\t\t<div class="boost-pfs-filter-block-content-inner">\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider"></div>\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount">\n\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-min" type="text" readonly />\n\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-max" type="text" readonly />\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t' : '\n\t\t\t\t<div class="boost-pfs-filter-block-content-inner">\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount">\n\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-min" type="text" />\n\t\t\t\t\t\t<div class="boost-pfs-filter-option-range-amount-split"> - </div>\n\t\t\t\t\t\t<input class="boost-pfs-filter-option-range-amount-max" type="text" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="boost-pfs-filter-option-range-slider"></div>\n\t\t\t\t</div>\n\t\t\t\t'
        }
      }, {
        key: "isRender",
        value: function () {
          if (this.status == Wi.a.Status.ACTIVE) {
            var t = o.a.getSettingValue("general.oneValueRangeSlider");
            return !(this.isNumberRangeSlider ? this.rangeMax == this.rangeMin : this.valuesData.length <= 1) || t
          }
          return !1
        }
      }, {
        key: "render",
        value: function () {
          Nl(Ul(e.prototype), "render", this).call(this), this.$element.addClass("boost-pfs-filter-option-range-" + this.style), this.renderRangeValue(), this.renderInputField()
        }
      }, {
        key: "renderRangeValue",
        value: function () {
          this.setCurrentValues(), this.noUiSlider && this.noUiSlider.set([this.currentMin, this.currentMax])
        }
      }, {
        key: "renderInputField",
        value: function () {
          if (this.$element && !this.hideInputElement) {
            this.$minInputElement && this.$maxInputElement || (this.$minInputElement = this.$element.find(".boost-pfs-filter-option-range-amount-min"), this.$maxInputElement = this.$element.find(".boost-pfs-filter-option-range-amount-max"));
            var t = this.buildNumberLabel(this.currentMin),
              e = this.buildNumberLabel(this.currentMax);
            this.$minInputElement.val(t), this.$maxInputElement.val(e)
          }
        }
      }, {
        key: "renderTextLabelPosition",
        value: function () {
          var t = this.$element.find(".noUi-value"),
            e = 100 / (2 * this.valuesData.length);
          t.each((function (t, n) {
            var i = n.style.left;
            if ("string" == typeof i) {
              var r = parseFloat(i.replace("%", "")) + e;
              n.style.left = r + "%"
            }
          }))
        }
      }, {
        key: "bindEvents",
        value: function () {
          Nl(Ul(e.prototype), "bindEvents", this).call(this), this.$element && (this.$rangeSliderElement = this.$element.find(".boost-pfs-filter-option-range-slider"), this.noUiSlider = Bl.a.create(this.$rangeSliderElement[0], this.getSliderConfig()), this.noUiSlider.on("slide", this.onDrag.bind(this)), this.noUiSlider.on("change", this.onFinishDragging.bind(this)), this.hideInputElement || (this.$minInputElement.on("change", this.onChangeInput.bind(this, "min")), this.$maxInputElement.on("change", this.onChangeInput.bind(this, "max"))), this.isNumberRangeSlider || this.renderTextLabelPosition(), this.$element.find(".boost-pfs-filter-option-range-amount-min, .noUi-handle-lower").attr("aria-label", a.a.ada.minValue), this.$element.find(".boost-pfs-filter-option-range-amount-max, .noUi-handle-upper").attr("aria-label", a.a.ada.maxValue))
        }
      }, {
        key: "onChangeInput",
        value: function (t) {
          var e = "min" == t ? this.$minInputElement.val().trim() : this.currentMin.toString(),
            n = "max" == t ? this.$maxInputElement.val().trim() : this.currentMax.toString();
          this.thousandSeparator && (e = e.split(this.thousandSeparator).join(""), n = n.split(this.thousandSeparator).join("")), this.decimalSeparator && "." != this.decimalSeparator && (e = e.replace(this.decimalSeparator, "."), n = n.replace(this.decimalSeparator, ".")), !this.isNumberRangeSlider || null == e || null == n || "" == e || "" == n || isNaN(e) || isNaN(n) || (e = parseFloat(e)) > (n = parseFloat(n)) ? this.renderInputField() : (this.currentMin = Math.max(e, this.rangeMin), this.currentMax = Math.min(n, this.rangeMax), this.noUiSlider && this.noUiSlider.set([this.currentMin, this.currentMax]), this.onFinishDragging())
        }
      }, {
        key: "onDrag",
        value: function () {
          var t = this.noUiSlider.get();
          if (null != t)
            if (Array.isArray(t) && 2 == t.length) {
              if (this.isNumberRangeSlider) this.currentMin = t[0], this.currentMax = t[1];
              else {
                var e = Math.round(t[0]),
                  n = Math.round(t[1]);
                n <= e ? this.noUiSlider.set([this.currentMin, this.currentMax]) : (this.currentMin = e, this.currentMax = n)
              }
              this.renderInputField()
            } else "string" != typeof t && "number" != typeof t || (this.currentMin = t, this.currentMax = t)
        }
      }, {
        key: "onFinishDragging",
        value: function () {
          var t = this;
          if (this.isNumberRangeSlider) this.filterItems.forEach((function (e) {
            e.setValue(t.currentMin, t.currentMax)
          }));
          else {
            var e = [];
            if (this.currentMin != this.rangeMin || this.currentMax != this.rangeMax)
              for (var n = this.currentMin; n <= this.currentMax - 1; n++) e.push(this.valuesData[n].key);
            this.filterItems.forEach((function (t) {
              t.isSelected = e.includes(t.value)
            }))
          }
          if (this.requestInstantly) {
            var i = [];
            this.filterItems.forEach((function (t) {
              t.isSelected && i.push(t.value)
            })), Ae.default.setParam(this.filterOptionId, i), Ae.default.setParam("page", 1);
            var r = {
              filterOptionId: this.filterOptionId,
              filterOptionValue: i
            };
            Ae.default.applyFilter("filter", r)
          }
        }
      }, {
        key: "getSliderConfig",
        value: function () {
          var t = {
            start: this.isSingleHandle ? [this.currentMin] : [this.currentMin, this.currentMax],
            step: this.sliderStep,
            connect: !0,
            snap: !this.isNumberRangeSlider,
            animate: !0,
            animationDuration: 300,
            range: this.getSliderRange(),
            pips: this.getSliderPipsConfig()
          };
          if (this.isShowTooltip) {
            var e = {
              to: this.buildLabel.bind(this)
            };
            t.tooltips = [e, e]
          }
          return t
        }
      }, {
        key: "getSliderRange",
        value: function () {
          var t = {
            min: this.rangeMin,
            max: this.rangeMax
          };
          if (!this.isNumberRangeSlider)
            for (var e = 1; e < this.valuesData.length; e++) t[e * (100 / this.valuesData.length) + "%"] = e;
          return t
        }
      }, {
        key: "getSliderPipsConfig",
        value: function () {
          return {
            mode: "count",
            values: this.isNumberRangeSlider ? this.sliderRange + 1 : this.valuesData.length + 1,
            filter: function (t, e) {
              return 1 == e ? e : -1
            },
            format: {
              to: this.buildLabel.bind(this)
            }
          }
        }
      }, {
        key: "buildLabel",
        value: function (t) {
          var e = "";
          return this.isNumberRangeSlider ? e = this.isPriceFilter ? this.buildMoneyLabel(t) : this.buildNumberLabel(t, !0) : Number.isInteger(t) && t >= 0 && t < this.valuesData.length && (e = this.valuesData[t].key, e = this.buildTextLabel(e)), e
        }
      }, {
        key: "buildMoneyLabel",
        value: function (t) {
          var e = o.a.getSettingValue("general.enable3rdCurrencySupport"),
            n = this.buildNumberLabel(t, !0),
            i = this.moneyFormat.replace(/{{\s*(\w+)\s*}}/, n);
          return i = i.replace(/[A-Z][A-Z][A-Z]/, ""), e && (i = u.a.moneyWrapper(i)), i
        }
      }, {
        key: "buildNumberLabel",
        value: function (t, e) {
          if (o.a.getSettingValue("general.shortenPipsRange") && e) {
            var n = o.a.getSettingValue("general.formatPipsRange");
            if (Array.isArray(n) && n.length > 0)
              for (var i = 0, r = 0, a = n.length - 1; a >= 0; a--) {
                var l = n[a];
                if (t >= l.node) return i = Math.floor(t / l.node).toString(), (r = (r = Math.round(t % l.node)) > 0 ? r.toString() : "").length > l.fix && (r = r.substring(0, l.fix)), l.suffix ? i + this.decimalSeparator + r + l.symbol : i + l.symbol + r
              }
          }
          var s = !o.a.getSettingValue("general.removePriceDecimal");
          return u.a.formatNumberWithSeparator(t, this.precision, this.thousandSeparator, this.decimalSeparator, s)
        }
      }, {
        key: "buildTextLabel",
        value: function (t) {
          if (this.prefix) {
            var e = this.prefix.replace(/\\/g, "");
            t = t.replace(e, "").trim()
          }
          return t
        }
      }, {
        key: "setMoneyFormat",
        value: function () {
          if (this.isPriceFilter) {
            var t = o.a.getSettingValue("general.rangeSliderMoneyFormat");
            this.moneyFormat = t || "{{amount}}"
          }
        }
      }, {
        key: "setCurrentValues",
        value: function () {
          var t = this,
            e = this.rangeMin,
            n = this.rangeMax,
            i = null;
          if (l.a.queryParams.hasOwnProperty(this.filterOptionId))
            if (this.isNumberRangeSlider)(i = l.a.queryParams[this.filterOptionId][0].split(":")) && 2 == i.length && (e = i[0], n = i[1]);
            else if (i = l.a.queryParams[this.filterOptionId], Array.isArray(i)) {
            var r = this.valuesData.map((function (t) {
              return t.key
            }));
            e = this.rangeMax, n = this.rangeMin, i.forEach((function (i) {
              var o = r.indexOf(i);
              o >= t.rangeMin && o <= t.rangeMax && (o < e && (e = o), o + 1 > n && (n = o + 1))
            }))
          }
          this.currentMin = e, this.currentMax = n
        }
      }, {
        key: "setDisplayStyle",
        value: function () {
          var t = o.a.getSettingValue("general.rangeSlidersStyle3"),
            e = o.a.getSettingValue("general.rangeSlidersSingleHandle");
          this.isNumberRangeSlider ? Array.isArray(e) && e.includes(this.filterOptionId) ? (this.style = "style4", this.hideInputElement = !0, this.isSingleHandle = !0, this.currentMax = this.currentMin) : Array.isArray(t) && t.includes(this.filterOptionId) ? (this.style = "style3", this.hideInputElement = !1) : this.hideInputElement ? (this.style = "style2", this.isShowTooltip = !0) : this.style = "style1" : (this.style = "style5", this.hideInputElement = !0), o.a.getSettingValue("general.enable3rdCurrencySupport") && ["style1", "style3"].indexOf(this.style) > -1 && (this.style = "style2", this.hideInputElement = !0, this.isShowTooltip = !0)
        }
      }, {
        key: "prepareFilterOptionData",
        value: function (t) {
          return t.values.max && t.values.min && (t.values.max = Math.ceil(100 * t.values.max) / 100, t.values.min = Math.floor(100 * t.values.min) / 100), "price" != t.filterType && "variants_price" != t.filterType || !t.values || (t.values.min = u.a.convertPriceBasedOnActiveCurrency(t.values.min), t.values.max = u.a.convertPriceBasedOnActiveCurrency(t.values.max)), t
        }
      }, {
        key: "setData",
        value: function (t) {
          if (t = this.prepareFilterOptionData(t), Nl(Ul(e.prototype), "setData", this).call(this, t), ("price" == this.filterType || "variants_price" == this.filterType) && !o.a.getSettingValue("general.enable3rdCurrencySupport")) {
            var n = o.a.getSettingValue("general.rangeSliderMoneyFormat");
            n || (n = l.a.moneyFormat);
            var i = n.replace(/<.*?>/g, "").replace(/{{.*?}}/, "");
            1 == i.length && (this.label += " (" + i + ")")
          }
          if (this.isNumberRangeSlider = !Array.isArray(t.values), this.isPriceFilter = t.filterType == Wi.a.FilterType.PRICE || t.filterType == Wi.a.FilterType.VARIANTS_PRICE, this.isPriceFilter && this.setMoneyFormat(), this.isSortValues() && this.sortValues(t.values), this.valuesData = JSON.parse(JSON.stringify(t.values)), this.isNumberRangeSlider && null != t.values.min && null != t.values.max && t.values.min != t.values.max) {
            if (this.hideInputElement = t.hideTextBoxes, this.sliderRange = parseFloat(t.sliderRange), isNaN(this.sliderRange) && (this.sliderRange = 4), this.sliderStep = parseFloat(t.sliderStep), (isNaN(this.sliderStep) || this.sliderStep > t.values.max) && (this.sliderStep = 1), this.precision = 0, Math.floor(this.sliderStep) != this.sliderStep) {
              var r = this.sliderStep.toString().split(".");
              r.length > 1 && (this.precision = r[1].length)
            }
            this.thousandSeparator = t.sliderDelimiter ? t.sliderDelimiter : "", "." == this.thousandSeparator ? this.decimalSeparator = "," : this.decimalSeparator = ".", this.rangeMin = parseFloat(t.values.min), this.rangeMax = parseFloat(t.values.max), this.setCurrentValues(), this.setDisplayStyle()
          } else Array.isArray(t.values) && t.values.length > 1 ? (this.hideInputElement = !0, this.sliderStep = 1, this.rangeMin = 0, this.rangeMax = this.valuesData.length, this.setCurrentValues(), this.setDisplayStyle()) : this.status = Wi.a.Status.DISABLED
        }
      }]) && Dl(n.prototype, i), r && Dl(n, r), e
    }(Va);

    function Wl(t) {
      return (Wl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Gl(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function zl(t, e) {
      return !e || "object" !== Wl(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Kl(t) {
      return (Kl = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Yl(t, e) {
      return (Yl = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ql = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = zl(this, Kl(e).call(this, t))).allNestedFilterItems = new Map, n
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Yl(t, e)
      }(e, t), n = e, (i = [{
        key: "getBlockContentTemplate",
        value: function () {
          return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptiontemListMultiLevelCollections}} {{class.filterOptionItemListSingleList}} boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-first-level-list">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'
        }
      }]) && Gl(n.prototype, i), r && Gl(n, r), e
    }(Va);

    function Jl(t) {
      return (Jl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Zl(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Xl(t, e) {
      return !e || "object" !== Jl(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function ts(t) {
      return (ts = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function es(t, e) {
      return (es = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ns = function (t) {
      function e(t) {
        var n;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (n = Xl(this, ts(e).call(this, t))).allNestedFilterItems = new Map, n
      }
      var n, i, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && es(t, e)
      }(e, t), n = e, (i = [{
        key: "getBlockContentTemplate",
        value: function () {
          return '\n\t\t\t<ul class="{{class.filterOptionItemList}} {{class.filterOptiontemListMultiLevelCollections}} {{displayTypeClass}} boost-pfs-filter-option-multi-level-list boost-pfs-filter-option-first-level-list">\n\t\t\t\t{{filterItems}}\n\t\t\t</ul>\n\t\t'
        }
      }, {
        key: "compileBlockContentTemplate",
        value: function () {
          var t = this.getDisplayTypeClass();
          return this.getBlockContentTemplate().replace(/{{displayTypeClass}}/g, t)
        }
      }, {
        key: "getDisplayTypeClass",
        value: function () {
          var t = "";
          switch (this.displayTypeItem) {
          case Wi.a.DisplayType.LIST:
            t = this.selectType == Wi.a.SelectType.SINGLE ? p.a.filterOptionItemListSingleList : p.a.filterOptionItemListMultipleList;
            break;
          case Wi.a.DisplayType.BOX:
            t = p.a.filterOptionItemListBox;
            break;
          case Wi.a.DisplayType.SWATCH:
            t = p.a.filterOptionItemListSwatch;
            var e = o.a.getSettingValue("general.swatchStyle");
            t += " " + (e = e ? e.replace("grid", "list") : "circle-list")
          }
          return t
        }
      }]) && Zl(n.prototype, i), r && Zl(n, r), e
    }(Va);

    function is(t) {
      return (is = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function rs(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function os(t, e) {
      return !e || "object" !== is(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function as(t) {
      return (as = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ls(t, e) {
      return (ls = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ss = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = os(this, as(e).call(this))).id = t, i.idSelector = "#" + i.id, i.filterTreeType = n, i.isMobileOnly = !1, i.isDesktopOnly = !1, i.isRenderOnDOM = !0, i.collectionId = l.a.collectionId, i.clickedFilterOption = null, i.refineBy = null, i.filterOptions = new Map, i.$element = null, i.selector = {
          refineByWrapper: "." + p.a.filterRefineByWrapper,
          filterOptionsWrapper: "." + p.a.filterOptionsWrapper,
          clearAllButton: ".boost-pfs-filter-mobile-toolbar-bottom ." + p.a.clearAllButton,
          clearAllButtonContainer: ".boost-pfs-filter-mobile-toolbar-bottom",
          applyAllButton: ".boost-pfs-filter-mobile-toolbar-bottom ." + p.a.applyAllFilterOptionButton,
          applyAllButtonContainer: ".boost-pfs-filter-mobile-footer",
          closeFilter: "." + p.a.closeFilterButton + ",." + p.a.showResultFilterButton,
          filterHeader: ".boost-pfs-filter-mobile-toolbar",
          filterHeaderTop: ".boost-pfs-filter-mobile-toolbar .boost-pfs-filter-mobile-toolbar-top",
          filterHeaderBottom: ".boost-pfs-filter-mobile-toolbar .boost-pfs-filter-mobile-toolbar-bottom",
          filterFooter: ".boost-pfs-filter-mobile-footer"
        }, i
      }
      var n, i, c;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ls(t, e)
      }(e, t), n = e, (i = [{
        key: "getTemplate",
        value: function () {
          switch (this.filterTreeType) {
          case "vertical":
            return '\n\t\t\t\t\t<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n\t\t\t\t\t\t{{header}}\n\t\t\t\t\t\t<div class="{{class.filterRefineByWrapper}}">\n\t\t\t\t\t\t\t{{refineBy}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="{{class.filterOptionsWrapper}}">\n\t\t\t\t\t\t\t{{filterOptions}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t{{footer}}\n\t\t\t\t\t</div>\n\t\t\t\t';
          case "horizontal":
            return "top" == o.a.getSettingValue("general.refineByHorizontalPosition") ? '\n\t\t\t\t\t\t<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n\t\t\t\t\t\t\t{{header}}\n\t\t\t\t\t\t\t<div class="{{class.filterRefineByWrapper}}">\n\t\t\t\t\t\t\t\t{{refineBy}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="{{class.filterOptionsWrapper}}">\n\t\t\t\t\t\t\t\t{{filterOptions}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t{{footer}}\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t' : '\n\t\t\t\t\t\t<div class="boost-pfs-filter-tree-content" aria-live="polite" role="navigation" aria-label="{{label.productFilter}}">\n\t\t\t\t\t\t\t{{header}}\n\t\t\t\t\t\t\t<div class="{{class.filterOptionsWrapper}}">\n\t\t\t\t\t\t\t\t{{filterOptions}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="{{class.filterRefineByWrapper}}">\n\t\t\t\t\t\t\t\t{{refineBy}}\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t{{footer}}\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t';
          default:
            throw Error("filterTreeType is wrong")
          }
        }
      }, {
        key: "getHeaderTemplate",
        value: function () {
          return '\n\t\t\t<div class="boost-pfs-filter-mobile-toolbar">\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-top">\n\t\t\t\t\t<a href="javascript:;" class="{{class.closeFilterButton}}"><span>{{label.close}}</span></a>\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-header">{{label.refineMobile}}</div>\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-bottom">\n\t\t\t\t\t{{clearButton}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
        }
      }, {
        key: "getFooterTemplate",
        value: function () {
          return '\n\t\t\t<div class="boost-pfs-filter-mobile-footer">\n\t\t\t\t<button class="{{class.showResultFilterButton}}" type="button">{{label.showResult}}</button>\n\t\t\t</div>\n\t\t'
        }
      }, {
        key: "compileTemplate",
        value: function () {
          return this.getTemplate().replace(/{{header}}/g, this.getHeaderTemplate()).replace(/{{footer}}/g, this.getFooterTemplate()).replace(/{{label.productFilter}}/g, a.a.productFilter).replace(/{{label.showResult}}/g, a.a.showResult).replace(/{{label.refineMobile}}/g, a.a.refineMobile).replace(/{{label.apply}}/g, a.a.apply).replace(/{{label.close}}/g, a.a.close).replace(/{{label.back}}/g, a.a.back).replace(/{{class.filterOptionsWrapper}}/g, p.a.filterOptionsWrapper).replace(/{{class.filterRefineByWrapper}}/g, p.a.filterRefineByWrapper).replace(/{{class.closeFilterButton}}/g, p.a.closeFilterButton).replace(/{{class.showResultFilterButton}}/g, p.a.showResultFilterButton).replace(/{{refineBy}}/g, "").replace(/{{clearButton}}/g, "").replace(/{{applyButton}}/g, "").replace(/{{filterOptions}}/g, "")
        }
      }, {
        key: "init",
        value: function () {
          var t = r()(this.idSelector);
          if (1 == t.length)
            if (this.isMobileOnly = t[0].hasAttribute("data-is-mobile"), this.isDesktopOnly = t[0].hasAttribute("data-is-desktop"), this.isDesktopOnly && this.isMobileOnly || !this.isMobileOnly && !this.isDesktopOnly) this.isDesktopOnly = !1, this.isMobileOnly = !1;
            else {
              var e = u.a.isMobile();
              this.isRenderOnDOM = e && this.isMobileOnly || !e && this.isDesktopOnly
            }
          this.clearAllButton = new mr(this.filterTreeType, mr.ClearType.CLEAR_ALL), this.applyAllButton = new FilterApplyButton(this.filterTreeType, FilterApplyButton.ApplyType.APPLY_ALL)
        }
      }, {
        key: "isRender",
        value: function () {
          return this.parent.isFetchedFilterData && this.isRenderOnDOM && Pe.a.isPanelActive(Te.a.Enum.PRODUCT)
        }
      }, {
        key: "isLoopThroughChild",
        value: function () {
          return this.isRenderOnDOM && this.parent.isFetchedFilterData
        }
      }, {
        key: "render",
        value: function () {
          !0 === l.a.queryParams.build_filter_tree && this.filterOptions && (this.isRenderPartially ? this.renderPartially() : this.renderFull(), this.renderRefineBy(), this.renderExtraElements())
        }
      }, {
        key: "renderFull",
        value: function () {
          var t = this;
          this.$element = r()(this.compileTemplate()), this.$filterOptionsContainerElement = this.$element.find(this.selector.filterOptionsWrapper), this.filterOptions.forEach((function (e) {
            t.$filterOptionsContainerElement.append(e.$element)
          }))
        }
      }, {
        key: "renderPartially",
        value: function () {
          var t = this;
          this.$filterOptionsContainerElement = this.$element.find(this.selector.filterOptionsWrapper);
          var e = !1;
          this.clickedFilterOption.$element.siblings().remove(), this.filterOptions.forEach((function (n) {
            if (n.$element) {
              if (n == t.clickedFilterOption) return void(e = !0);
              e ? t.$filterOptionsContainerElement.append(n.$element) : n.$element.insertBefore(t.clickedFilterOption.$element)
            }
          }))
        }
      }, {
        key: "renderRefineBy",
        value: function () {
          o.a.getSettingValue("general.separateRefineByFromFilter") ? this.renderSeparateRefineBy() : this.renderAttachedRefineBy()
        }
      }, {
        key: "renderAttachedRefineBy",
        value: function () {
          this.refineBy && this.$element && (this.$refineByElementContainer = this.$element.find(this.selector.refineByWrapper), this.$refineByElementContainer.length > 0 && (this.$refineByElementContainer.first().html("").append(this.refineBy.$element), this.$refineByElement = this.refineBy.$element))
        }
      }, {
        key: "renderSeparateRefineBy",
        value: function () {
          if (this.refineBy) {
            var t = this.refineBy.filterTreeType == pr.FilterTreeType.VERTICAL ? s.a.filterRefineByVertical : s.a.filterRefineByHorizontal;
            r()(t).length > 0 && r()(t).first().html("").append(this.refineBy.$element)
          }
        }
      }, {
        key: "renderExtraElements",
        value: function () {
          0 == this.$element.find(this.selector.clearAllButton).length && this.$element.find(this.selector.clearAllButtonContainer).append(this.clearAllButton.$element), 0 == this.$element.find(this.selector.applyAllButton).length && this.$element.find(this.selector.applyAllButtonContainer).append(this.applyAllButton.$element)
        }
      }, {
        key: "bindEvents",
        value: function () {
          (this.isMobileOnly || this.isDesktopOnly) && (this.resizeTimer = null, r()(window).on("resize", function () {
            this.resizeTimer && clearTimeout(this.resizeTimer), this.resizeTimer = setTimeout(this.onScreenResize.bind(this), 500)
          }.bind(this))), this.$element && this.$element.find(this.selector.closeFilter).length > 0 && (this.$element.find(this.selector.closeFilter).off("click"), this.$element.find(this.selector.closeFilter).on("click", this.onCloseFilterTree.bind(this)))
        }
      }, {
        key: "onScreenResize",
        value: function () {
          var t = u.a.isMobile(),
            e = t && this.isMobileOnly || !t && this.isDesktopOnly;
          this.isRenderOnDOM != e && (this.isRenderOnDOM = e, this.isRenderOnDOM ? (this.isRenderPartially = !1, this.refresh(), r()(this.idSelector).first().html("").append(this.$element)) : this.$element && (this.$element.detach(), this.$element = null))
        }
      }, {
        key: "onCloseFilterTree",
        value: function () {
          var t = r()(this.idSelector);
          t && (this.mobileButton.isCollapsed = !0, t.removeClass(p.a.filterTreeMobileOpen), r()("body").removeClass(p.a.filterTreeOpenBody).removeClass("boost-pfs-body-no-scroll"), r()("html").removeClass(p.a.filterTreeOpenBody).removeClass("boost-pfs-body-no-scroll"))
        }
      }, {
        key: "setData",
        value: function (t) {
          var e = this;
          this.collectionId == l.a.collectionId ? this.clickedFilterOption = this.filterOptions.get(this.parent.clickedFilterOptionId) : (this.collectionId = l.a.collectionId, this.clickedFilterOption = null), this.isRenderPartially = !!(this.$element && this.clickedFilterOption && this.clickedFilterOption.$element), this.modifyOptionsData(t.options), this.children = [], this.filterOptions = new Map, t.options.forEach((function (t) {
            if (!(t.status != Wi.a.Status.ACTIVE || Array.isArray(t.values) && 0 == t.values.length && Array.isArray(t.manualValues) && 0 == t.manualValues.length)) {
              var n = null;
              if (e.clickedFilterOption && t.filterOptionId == e.clickedFilterOption.filterOptionId && (n = e.clickedFilterOption), null == n) {
                switch (t.displayType) {
                case Wi.a.DisplayType.LIST:
                  n = new Ka(e.filterTreeType);
                  break;
                case Wi.a.DisplayType.BOX:
                  n = new el(e.filterTreeType);
                  break;
                case Wi.a.DisplayType.RANGE:
                  n = new Hl(e.filterTreeType);
                  break;
                case Wi.a.DisplayType.SWATCH:
                  n = new sl(e.filterTreeType);
                  break;
                case Wi.a.DisplayType.RATING:
                  n = new dl(e.filterTreeType);
                  break;
                case Wi.a.DisplayType.SUB_CATEGORY:
                  n = new jl(e.filterTreeType);
                  break;
                case Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS:
                  n = new Ql(e.filterTreeType);
                  break;
                case Wi.a.DisplayType.MULTI_LEVEL_TAG:
                  n = new ns(e.filterTreeType)
                }
                if (!n) return;
                n.setData(t)
              }
              e.addComponent(n), e.filterOptions.set(t.filterOptionId, n)
            }
          })), o.a.getSettingValue("general.showRefineBy") && (this.refineBy = new kl(this.filterTreeType), this.addComponent(this.refineBy), this.refineBy.setData()), this.addComponent(this.clearAllButton), this.addComponent(this.applyAllButton)
        }
      }, {
        key: "modifyOptionsData",
        value: function (t) {
          var e = o.a.getSettingValue("general.advancedRangeSliders");
          t.forEach((function (t) {
            if (Array.isArray(e) && e.includes(t.filterOptionId) && t.selectType == Wi.a.SelectType.MULTIPLE && (t.displayType = Wi.a.DisplayType.RANGE), t.filterType == Wi.a.FilterType.MULTI_LEVEL_TAG) {
              switch (t.displayType) {
              case Wi.a.DisplayType.LIST:
                t.displayTypeItem = Wi.a.DisplayType.LIST;
                break;
              case Wi.a.DisplayType.BOX:
                t.displayTypeItem = Wi.a.DisplayType.BOX;
                break;
              case Wi.a.DisplayType.SWATCH:
                t.displayTypeItem = Wi.a.DisplayType.SWATCH;
                break;
              default:
                return
              }
              t.displayType = Wi.a.DisplayType.MULTI_LEVEL_TAG
            }(u.a.isVendorPage() && t.filterType == Wi.a.FilterType.VENDOR || u.a.isTypePage() && t.filterType == Wi.a.FilterType.PRODUCT_TYPE) && (t.status = Wi.a.Status.DISABLED), t.displayType == Wi.a.DisplayType.SUB_CATEGORY && (t.status = Wi.a.Status.DISABLED)
          }))
        }
      }]) && rs(n.prototype, i), c && rs(n, c), e
    }(f.a);

    function cs(t) {
      return (cs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function us(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function ps(t, e) {
      return !e || "object" !== cs(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function fs(t, e, n) {
      return (fs = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = hs(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function hs(t) {
      return (hs = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function ys(t, e) {
      return (ys = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var ds = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = ps(this, hs(e).call(this, t, n))).style = "style2", i.selector.clearAllButtonContainer = ".boost-pfs-filter-mobile-toolbar-right", i.selector.backButton = ".boost-pfs-filter-back-btn", i.selector.refineByOnTitle = ".boost-pfs-filter-selected-items-mobile", i.selector.headerTitle = ".boost-pfs-filter-mobile-toolbar-middle", i.style2ActiveFilterOption = null, i
      }
      var n, i, s;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && ys(t, e)
      }(e, t), n = e, s = [{
        key: "isActive",
        value: function (t) {
          return t == pr.FilterTreeType.VERTICAL && "style2" == o.a.getSettingValue("general.filterTreeMobileStyle")
        }
      }], (i = [{
        key: "init",
        value: function () {
          fs(hs(e.prototype), "init", this).call(this), r()(this.idSelector).length > 0 && (r()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style2").addClass("boost-pfs-filter-tree-mobile-sticky"), o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && r()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"))
        }
      }, {
        key: "getHeaderTemplate",
        value: function () {
          return '\n\t\t\t<div class="boost-pfs-filter-mobile-toolbar">\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-top">\n\t\t\t\t\t<a href="javascript:;" class="{{class.closeFilterButton}}"><span>{{label.close}}</span></a>\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-items">\n\t\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-left">\n\t\t\t\t\t\t<a href="javascript:void(0)" class="boost-pfs-filter-back-btn" aria-label="{{label.back}}"></a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-middle">{{label.refineMobile}}</div>\n\t\t\t\t\t<div class="boost-pfs-filter-mobile-toolbar-right">\n\t\t\t\t\t\t{{clearButton}}\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
        }
      }, {
        key: "render",
        value: function () {
          var t = this;
          if (fs(hs(e.prototype), "render", this).call(this), this.$element && u.a.isMobile()) {
            var n = null;
            this.filterOptions.forEach((function (e) {
              t.style2ActiveFilterOption && t.style2ActiveFilterOption.filterOptionId == e.filterOptionId && (n = e)
            })), this.style2ActiveFilterOption = n, this.renderFilterTreeHeader(), this.renderFilterTreeFooter(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear(), this.renderRefineByOnTitle()
          }
        }
      }, {
        key: "bindEvents",
        value: function () {
          var t = this;
          fs(hs(e.prototype), "bindEvents", this).call(this), this.$element && u.a.isMobile() && (this.$element.find(this.selector.backButton).on("click", this.closeFilterOption.bind(this)), this.filterOptions.forEach((function (e) {
            e.$filterOptionTitleElement && (e.$filterOptionTitleElement.off("click"), e.$filterOptionTitleElement.on("click", t.openFilterOption.bind(t, e)))
          })))
        }
      }, {
        key: "renderFilterTreeHeader",
        value: function () {
          this.style2ActiveFilterOption ? (this.$element.find(this.selector.headerTitle).html(this.style2ActiveFilterOption.label), this.$element.find(this.selector.backButton).show()) : (this.$element.find(this.selector.headerTitle).html(a.a.refineMobile), this.$element.find(this.selector.backButton).hide()), this.mathHeightToolbarHeader()
        }
      }, {
        key: "renderFilterTreeFooter",
        value: function () {
          var t = this.parent && this.parent.data ? " (" + this.parent.data.total_product + ")" : "";
          this.$element.find("." + p.a.showResultFilterButton).html(a.a.showResult + t)
        }
      }, {
        key: "renderFilterOptionCollapse",
        value: function () {
          var t = this;
          this.filterOptions.forEach((function (e) {
            if (e.$filterOptionTitleElement && e.$filterOptionContentElement && e.collapse) {
              e.$element.removeClass("boost-pfs-filter-option-collapsed");
              var n = e.$element.find(".boost-pfs-filter-option-title"),
                i = e.$filterOptionContentElement;
              t.style2ActiveFilterOption ? e == t.style2ActiveFilterOption ? (n.hide(), i.show()) : (n.hide(), i.hide()) : (n.show(), i.hide())
            }
          }))
        }
      }, {
        key: "renderFilterOptionClear",
        value: function () {
          var t = this.clearAllButton.$element,
            e = this.$element.find(this.selector.clearAllButtonContainer);
          e && (t && (null == this.style2ActiveFilterOption && l.a.hasFilterOptionParam ? e.append(t) : t.detach()), this.filterOptions.forEach((function (t) {
            t.clearButton && t.clearButton.$element && t.clearButton.$element.detach()
          })), this.style2ActiveFilterOption && this.style2ActiveFilterOption.clearButton && this.style2ActiveFilterOption.clearButton.$element && e.append(this.style2ActiveFilterOption.clearButton.$element))
        }
      }, {
        key: "renderRefineByOnTitle",
        value: function () {
          var t = this;
          this.filterOptions.forEach((function (e) {
            if (e.$element) {
              var n = "";
              if (e.filterOptionId.startsWith(l.a.prefix + "_c_")) {
                var i = e.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS ? e.allNestedFilterItems : e.filterItems;
                if (i && i.size > 0) {
                  var r = "",
                    o = [];
                  i.forEach((function (t) {
                    t.isSelected && (2 == t.level || 3 == t.level ? o.push(t.label) : r = t.label)
                  })), n = r && o.length > 0 ? r + ": " + o.join(", ") : r
                }
              } else if (t.refineBy && t.refineBy.refineByItems) {
                var a = [];
                t.refineBy.refineByItems.forEach((function (t) {
                  if (t.filterOptionId == e.filterOptionId) {
                    var n = t.label;
                    n && a.push(n)
                  }
                })), n = a.join(", ")
              }
              var s = n ? "<span>" + n + "</span>" : "";
              e.$element.find(t.selector.refineByOnTitle).html(s)
            }
          }))
        }
      }, {
        key: "openFilterOption",
        value: function (t) {
          this.style2ActiveFilterOption = t, this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear(), this.mathHeightToolbarHeader()
        }
      }, {
        key: "closeFilterOption",
        value: function () {
          this.style2ActiveFilterOption = null, this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear()
        }
      }, {
        key: "onClickMobileButton",
        value: function (t) {
          t && (t.stopImmediatePropagation(), t.stopPropagation()), this.style2ActiveFilterOption = null;
          var e = r()(this.idSelector);
          e && (this.mobileButton.isCollapsed = !this.mobileButton.isCollapsed, this.mobileButton.isCollapsed ? (e.removeClass(p.a.filterTreeMobileOpen), r()("body").removeClass("boost-pfs-body-no-scroll"), r()("html").removeClass("boost-pfs-body-no-scroll")) : (e.addClass(p.a.filterTreeMobileOpen), r()("body").addClass("boost-pfs-body-no-scroll"), r()("html").addClass("boost-pfs-body-no-scroll"))), this.mobileButton.afterToggleFilterTree()
        }
      }, {
        key: "mathHeightToolbarHeader",
        value: function () {
          var t = r()(".boost-pfs-filter-mobile-toolbar").height();
          r()(".boost-pfs-filter-options-wrapper").css("top", t + "px")
        }
      }]) && us(n.prototype, i), s && us(n, s), e
    }(ss);

    function gs(t) {
      return (gs = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ms(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function bs(t, e) {
      return !e || "object" !== gs(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function vs(t, e, n) {
      return (vs = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Ss(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function Ss(t) {
      return (Ss = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Os(t, e) {
      return (Os = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Ts = function (t) {
      function e(t, n) {
        var i;
        return function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, e), (i = bs(this, Ss(e).call(this, t, n))).style = "style3", i.selector.refineByOnTitle = ".boost-pfs-filter-selected-items-mobile", i
      }
      var n, i, a;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && Os(t, e)
      }(e, t), n = e, a = [{
        key: "isActive",
        value: function (t) {
          return t == pr.FilterTreeType.VERTICAL && "style3" == o.a.getSettingValue("general.filterTreeMobileStyle")
        }
      }], (i = [{
        key: "init",
        value: function () {
          vs(Ss(e.prototype), "init", this).call(this), r()(this.idSelector).length > 0 && (r()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style3").addClass("boost-pfs-filter-tree-mobile-sticky"), o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && r()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"))
        }
      }, {
        key: "render",
        value: function () {
          var t = this;
          vs(Ss(e.prototype), "render", this).call(this), this.$element && u.a.isMobile() && this.filterOptions.forEach((function (e) {
            if (e.$element && t.refineBy && t.refineBy.refineByItems) {
              var n = [];
              t.refineBy.refineByItems.forEach((function (t) {
                if (t.filterOptionId == e.filterOptionId) {
                  var i = t.buildLabel();
                  i && n.push(i)
                }
              })), e.$element.find(t.selector.refineByOnTitle).html(n.join(", "))
            }
          }))
        }
      }, {
        key: "renderFilterTreeFooter",
        value: function () {
          var t = this.parent && this.parent.data ? " (" + this.parent.data.total_product + ")" : "";
          this.$element.find("." + p.a.showResultFilterButton).html(Labels.showResult + t)
        }
      }, {
        key: "onClickMobileButton",
        value: function (t) {
          t && (t.stopImmediatePropagation(), t.stopPropagation());
          var e = r()(this.idSelector);
          e && (this.mobileButton.isCollapsed = !this.mobileButton.isCollapsed, this.mobileButton.isCollapsed ? (e.removeClass(p.a.filterTreeMobileOpen), r()("body").removeClass("boost-pfs-body-no-scroll"), r()("html").removeClass("boost-pfs-body-no-scroll")) : (e.addClass(p.a.filterTreeMobileOpen), r()("body").addClass("boost-pfs-body-no-scroll"), r()("html").addClass("boost-pfs-body-no-scroll"))), this.mobileButton.afterToggleFilterTree()
        }
      }]) && ms(n.prototype, i), a && ms(n, a), e
    }(ss);

    function Ps(t) {
      return (Ps = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function ws(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function _s(t, e) {
      return !e || "object" !== Ps(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function Cs(t, e, n) {
      return (Cs = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, n) {
        var i = function (t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = ks(t)););
          return t
        }(t, e);
        if (i) {
          var r = Object.getOwnPropertyDescriptor(i, e);
          return r.get ? r.get.call(n) : r.value
        }
      })(t, e, n || t)
    }

    function ks(t) {
      return (ks = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function Es(t, e) {
      return (Es = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Is = function (t) {
        function e(t, n) {
          var i;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (i = _s(this, ks(e).call(this, t, n))).style = "style4", i.selector.clearAllButtonContainer = ".boost-pfs-filter-mobile-toolbar-right", i.selector.backButton = ".boost-pfs-filter-back-btn", i.selector.refineByOnTitle = ".boost-pfs-filter-selected-items-mobile", i.selector.headerTitle = ".bc-sf-filter-mobile-toolbar-header", i.selector.headerClose = ".boost-pfs-filter-close", i.style4ActiveFilterOption = null, o.a.activeFilterScrollbarMobile = !1, i
        }
        var n, i, s;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && Es(t, e)
        }(e, t), n = e, s = [{
          key: "isActive",
          value: function (t) {
            return t == pr.FilterTreeType.VERTICAL && "style4" == o.a.getSettingValue("general.filterTreeMobileStyle")
          }
        }], (i = [{
          key: "init",
          value: function () {
            Cs(ks(e.prototype), "init", this).call(this), r()(this.idSelector).length > 0 && (r()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-style4").addClass("boost-pfs-filter-tree-mobile-sticky"), o.a.getSettingValue("general.filterTreeMobileStyleFullWidth") && r()(this.idSelector).addClass("boost-pfs-filter-tree-mobile-full-width-style"))
          }
        }, {
          key: "getHeaderTemplate",
          value: function () {
            return '\n      <div class="boost-pfs-filter-mobile-toolbar">\n                <div class="bc-sf-filter-mobile-toolbar-header">{{label.refineMobile}}</div>\n        <div class="boost-pfs-filter-mobile-toolbar-items">\n          <div class="boost-pfs-filter-mobile-toolbar-left">\n            <a href="javascript:;" class="{{class.closeFilterButton}}"><span>{{label.close}}</span></a>\n            <a href="javascript:;" class="boost-pfs-filter-back-btn">{{label.apply}}</a>\n          </div>\n          <div class="boost-pfs-filter-mobile-toolbar-right">\n            {{clearButton}}\n          </div>\n        </div>\n      </div>\n    '
          }
        }, {
          key: "render",
          value: function () {
            var t = this;
            if (Cs(ks(e.prototype), "render", this).call(this), this.$element && u.a.isMobile()) {
              var n = null;
              this.filterOptions.forEach((function (e) {
                t.style4ActiveFilterOption && t.style4ActiveFilterOption.filterOptionId == e.filterOptionId && (n = e)
              })), this.style4ActiveFilterOption = n, this.renderFilterTreeHeader(), this.renderFilterTreeFooter(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear(), this.renderRefineByOnTitle()
            }
          }
        }, {
          key: "bindEvents",
          value: function () {
            var t = this;
            Cs(ks(e.prototype), "bindEvents", this).call(this), this.$element && u.a.isMobile() && (this.$element.find(this.selector.backButton).on("click", this.closeFilterOption.bind(this)), this.filterOptions.forEach((function (e) {
              e.$filterOptionTitleElement && (e.$filterOptionTitleElement.off("click"), e.$filterOptionTitleElement.on("click", t.openFilterOption.bind(t, e)))
            })))
          }
        }, {
          key: "renderFilterTreeHeader",
          value: function () {
            this.style4ActiveFilterOption ? (this.$element.find(this.selector.headerTitle).html(this.style4ActiveFilterOption.label), this.$element.find(this.selector.backButton).show(), this.$element.find(this.selector.headerClose).hide()) : (this.$element.find(this.selector.headerTitle).html(a.a.refineMobile), this.$element.find(this.selector.backButton).hide(), this.$element.find(this.selector.headerClose).show())
          }
        }, {
          key: "renderFilterTreeFooter",
          value: function () {
            var t = this.parent && this.parent.data ? " (" + this.parent.data.total_product + ")" : "";
            this.$element.find("." + p.a.showResultFilterButton).html(a.a.showResult + '<span class="boost-pfs-number-result">' + t + "</span>")
          }
        }, {
          key: "renderFilterOptionCollapse",
          value: function () {
            var t = this;
            this.filterOptions.forEach((function (e) {
              if (e.$filterOptionTitleElement && e.$filterOptionContentElement && e.collapse) {
                e.$element.removeClass("boost-pfs-filter-option-collapsed");
                var n = e.$element.find(".boost-pfs-filter-option-title"),
                  i = e.$filterOptionContentElement;
                t.style4ActiveFilterOption ? e == t.style4ActiveFilterOption ? (n.hide(), i.show()) : (n.hide(), i.hide()) : (n.show(), i.hide())
              }
            }))
          }
        }, {
          key: "renderFilterOptionClear",
          value: function () {
            var t = this.clearAllButton.$element,
              e = this.$element.find(this.selector.clearAllButtonContainer);
            e && (t && (null == this.style4ActiveFilterOption && l.a.hasFilterOptionParam ? e.append(t) : t.detach()), this.filterOptions.forEach((function (t) {
              t.clearButton && t.clearButton.$element && t.clearButton.$element.detach()
            })), this.style4ActiveFilterOption && this.style4ActiveFilterOption.clearButton && this.style4ActiveFilterOption.clearButton.$element && e.append(this.style4ActiveFilterOption.clearButton.$element))
          }
        }, {
          key: "renderRefineByOnTitle",
          value: function () {
            var t = this;
            this.filterOptions.forEach((function (e) {
              if (e.$element) {
                var n = "";
                if (e.filterOptionId.startsWith(l.a.prefix + "_c_")) {
                  var i = e.displayType == Wi.a.DisplayType.MULTI_LEVEL_COLLECTIONS ? e.allNestedFilterItems : e.filterItems;
                  if (i && i.size > 0) {
                    var r = "",
                      o = [];
                    i.forEach((function (t) {
                      t.isSelected && (2 == t.level || 3 == t.level ? o.push(t.label) : r = t.label)
                    })), n = r && o.length > 0 ? r + ": " + o.join(", ") : r
                  }
                } else if (t.refineBy && t.refineBy.refineByItems) {
                  var a = [];
                  t.refineBy.refineByItems.forEach((function (t) {
                    if (t.filterOptionId == e.filterOptionId) {
                      var n = t.label;
                      n && a.push(n)
                    }
                  })), n = a.join(", ")
                }
                var s = n ? "<span>" + n + "</span>" : "";
                e.$element.find(t.selector.refineByOnTitle).html(s)
              }
            }))
          }
        }, {
          key: "openFilterOption",
          value: function (t) {
            this.style4ActiveFilterOption = t, this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear();
            var e = r()(".boost-pfs-filter-mobile-toolbar").height();
            r()(".boost-pfs-filter-options-wrapper").css("top", e + "px")
          }
        }, {
          key: "closeFilterOption",
          value: function () {
            this.style4ActiveFilterOption = null, this.renderFilterTreeHeader(), this.renderFilterOptionCollapse(), this.renderFilterOptionClear()
          }
        }, {
          key: "onClickMobileButton",
          value: function (t) {
            t && (t.stopImmediatePropagation(), t.stopPropagation()), this.style4ActiveFilterOption = null;
            var e = r()(this.idSelector);
            e && (this.mobileButton.isCollapsed = !this.mobileButton.isCollapsed, this.mobileButton.isCollapsed ? (e.removeClass(p.a.filterTreeMobileOpen), r()("html").removeClass("boost-pfs-body-no-scroll"), r()("body").removeClass("boost-pfs-body-no-scroll")) : (e.addClass(p.a.filterTreeMobileOpen), r()("html").addClass("boost-pfs-body-no-scroll"), r()("body").addClass("boost-pfs-body-no-scroll"))), this.mobileButton.afterToggleFilterTree()
          }
        }]) && ws(n.prototype, i), s && ws(n, s), e
      }(ss),
      Ls = {
        newFilterTree: function (t, e) {
          return Ts.isActive(e) ? new Ts(t, e) : ds.isActive(e) ? new ds(t, e) : Is.isActive(e) ? new Is(t, e) : new ss(t, e)
        }
      };

    function As(t) {
      return (As = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function Fs(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function Rs(t, e) {
      return !e || "object" !== As(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function js(t) {
      return (js = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function $s(t, e) {
      return ($s = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Bs = function (t) {
        function e() {
          var t;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), (t = Rs(this, js(e).call(this))).filterTrees = [], t.filterMobileButton = null, t.filterResult = null, t.filterLoadingIcon = null, t.filterScrollToTop = null, t.data = null, t.fromCache = !1, t.eventType = "", t.error = "", t.isFetchedFilterData = !1, t
        }
        var n, i, o;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && $s(t, e)
        }(e, t), n = e, (i = [{
          key: "beforeInit",
          value: function () {
            this.isBadUrl() && (this.isInit = !0, u.a.setWindowLocation(window.location.pathname))
          }
        }, {
          key: "isBadUrl",
          value: function () {
            try {
              var t = decodeURIComponent(u.a.getWindowLocation().search).split("&"),
                e = !1;
              if (t.length > 0)
                for (var n = 0; n < t.length; n++) {
                  var i = t[n],
                    r = (i.match(/</g) || []).length,
                    o = (i.match(/>/g) || []).length,
                    a = (i.match(/alert\(/g) || []).length,
                    l = (i.match(/execCommand/g) || []).length;
                  if (r > 0 && o > 0 || r > 1 || o > 1 || a || l) {
                    e = !0;
                    break
                  }
                }
              return e
            } catch (t) {
              return !0
            }
          }
        }, {
          key: "init",
          value: function () {
            this.initFilterTrees(), this.initFilterMobileButton(), this.filterResult = new Hi, this.addComponent(this.filterResult), this.filterLoadingIcon = new rr, this.addComponent(this.filterLoadingIcon), this.filterScrollToTop = new ur, this.addComponent(this.filterScrollToTop), this.filterLoadingIcon.setShow(!0)
          }
        }, {
          key: "afterInit",
          value: function () {
            Ae.default.updateParamsFromUrl(), Ae.default.getFilterData("init", this.setData.bind(this), this.errorFilterCallback.bind(this))
          }
        }, {
          key: "initFilterTrees",
          value: function () {
            var t = this;
            r()(s.a.filterTree).each((function (e, n) {
              var i = r()(n),
                o = "";
              if (i.hasClass(p.a.filterTreeVertical) ? o = pr.FilterTreeType.VERTICAL : i.hasClass(p.a.filterTreeHorizontal) && (o = pr.FilterTreeType.HORIZONTAL), o) {
                var a = p.a.filterTree + (0 == e ? "" : (e + 1).toString());
                i.attr("id", a);
                var l = Ls.newFilterTree(a, o);
                t.addComponent(l), t.filterTrees.push(l)
              }
            }))
          }
        }, {
          key: "initFilterMobileButton",
          value: function () {
            if (r()(s.a.filterTreeMobileButton).length > 0) {
              var t = r()(s.a.filterTreeMobileButton).first().attr("data-filter-tree-id");
              this.filterMobileButton = null;
              for (var e = this.filterTrees.length, n = 0; n < e; n++) this.filterMobileButton || 0 != r()("#" + this.filterTrees[n].id).not("[data-is-desktop]").length && (t && this.filterTrees[n].id == t || !t && this.filterTrees[n].filterTreeType == pr.FilterTreeType.VERTICAL) && (this.filterMobileButton = new Ji(this.filterTrees[n]), this.addComponent(this.filterMobileButton))
            }
          }
        }, {
          key: "isRender",
          value: function () {
            return this.isFetchedFilterData || this.isFetchedProductData
          }
        }, {
          key: "render",
          value: function () {
            this.isFetchedFilterData && (this.filterTrees.forEach((function (t) {
              r()(t.idSelector).length > 0 && !t.isRenderPartially && r()(t.idSelector).first().html("").append(t.$element)
            })), r()(s.a.filterTreeMobileButton).length > 0 && "init" == this.eventType && this.filterMobileButton && r()(s.a.filterTreeMobileButton).first().html("").append(this.filterMobileButton.$element))
          }
        }, {
          key: "setData",
          value: function (t, e, n) {
            this.isFetchedFilterData = !1, this.isFetchedProductData = !1, this.data = JSON.parse(JSON.stringify(t)), this.fromCache = t.from_cache, this.error = t.error;
            var i = JSON.parse(JSON.stringify(l.a.queryParams));
            l.a.queryParams = i, void 0 !== l.a.activeCurrencyPrices && r.a.extend(l.a.queryParams, l.a.activeCurrencyPrices), this.eventType = e || t.event_type, this.clickedFilterOptionId = n && n.filterOptionId && "clear" != e ? n.filterOptionId : "", (t = this.modifyData(t)).filter && t.filter.options && -1 == l.a.imutableFilterTree.indexOf(this.eventType) && (this.isFetchedFilterData = !0, this.filterTrees.forEach((function (e) {
              e.setData(t.filter)
            }))), (t.products || t.collections || t.pages) && (this.isFetchedProductData = !0, this.filterResult.setData(t)), this.refresh(), this.filterLoadingIcon.setShow(!1)
          }
        }, {
          key: "modifyData",
          value: function (t) {
            return t
          }
        }, {
          key: "errorFilterCallback",
          value: function () {
            if (!u.a.isiOS() && !u.a.isSafari() && !u.a.isBackButton()) {
              var t = u.a.getWindowLocation().href.split("?")[0],
                e = u.a.isSearchPage() && l.a.queryParams.hasOwnProperty("q") ? "&q=" + l.a.queryParams.q : "";
              window.location.replace(t + "?view=boost-pfs-original" + e)
            }
          }
        }]) && Fs(n.prototype, i), o && Fs(n, o), e
      }(f.a),
      xs = [{
        name: "getSettingValue",
        mapToFunction: function (t, e) {
          return o.a.getSettingValue(t, e)
        }
      }, {
        name: "getSortingList",
        mapToFunction: function () {
          return u.a.FilterResult.getSortingList()
        }
      }, {
        name: "buildToolbarLink",
        mapToFunction: function (t, e, n) {
          return u.a.buildToolbarLink(t, e, n)
        }
      }, {
        name: "optimizeImage",
        mapToFunction: function (t, e) {
          return u.a.optimizeImage(t, e)
        }
      }, {
        name: "buildProductItemUrl",
        mapToFunction: function (t, e) {
          return u.a.buildProductItemUrl(t, e)
        }
      }, {
        name: "refreshProperties",
        mapToFunction: function () {
          BoostPFS.prototype.selector = s.a, BoostPFS.prototype.queryParams = l.a.queryParams
        }
      }],
      Ms = [{
        name: "beforeBuildSearchBox",
        mapToFunction: "beforeBindEvents",
        mapArguments: ["id"],
        component: Jt
      }, {
        name: "afterBuildSearchBox",
        mapToFunction: "afterBindEvents",
        mapArguments: ["id"],
        component: Jt
      }, {
        name: "customizeSuggestion",
        mapToFunction: "customizeAutoCompleteResizeMenu",
        mapArguments: ["$uiMenuElement", "$element", "id"],
        component: Jt
      }, {
        name: "afterShowSearchBoxMobile",
        mapToFunction: "afterShowSearchBoxMobile",
        mapArguments: ["inputMobileId"],
        component: Dt
      }, {
        name: "afterCloseSuggestionMobile",
        mapToFunction: "afterCloseInstantSearchMobile",
        mapArguments: ["inputMobileId", "@0"],
        component: Dt
      }, {
        name: "customizeSuggetionProductTitle",
        mapToFunction: "customizeProductTitle",
        mapArguments: ["title", "currentTerm", "data"],
        component: R
      }, {
        name: "buildProductGridItem",
        mapToFunction: "compileTemplate",
        mapArguments: ["data", "index", "totalProduct"],
        component: ce
      }, {
        name: "buildProductListItem",
        mapToFunction: "compileTemplate",
        mapArguments: ["data", "index", "totalProduct"],
        component: de
      }, {
        name: "buildProductCollageItem",
        mapToFunction: "compileTemplate",
        mapArguments: ["data", "index", "totalProduct"],
        component: Oe
      }, {
        name: "prepareProductData",
        mapToFunction: "prepareProductData",
        mapArguments: ["data"],
        component: Ie
      }, {
        name: "buildExtrasProductList",
        mapToFunction: "afterRender",
        mapArguments: ["data", "eventType"],
        component: Ie
      }, {
        name: "buildAdditionalElements",
        mapToFunction: "afterRender",
        mapArguments: ["data", "totalProduct", "eventType"],
        component: Bs
      }, {
        name: "buildPagination",
        mapToFunction: "render",
        mapArguments: ["totalProduct", "paginationType"],
        component: Le.a
      }, {
        name: "buildFilterDisplayType",
        mapToFunction: "render",
        mapArguments: [],
        component: xe
      }, {
        name: "buildFilterSorting",
        mapToFunction: "compileTemplate",
        mapArguments: [],
        component: qe
      }, {
        name: "buildFilterShowLimit",
        mapToFunction: "compileTemplate",
        mapArguments: [],
        component: Ye
      }, {
        name: "buildBreadcrumb",
        mapToFunction: "buildBreadcrumb",
        mapArguments: ["collectionData", "data"],
        component: dn
      }],
      Ds = function (t, e) {
        BoostPFS.prototype.hasOwnProperty(t) || (BoostPFS.prototype[t] = e)
      },
      Vs = function (t, e, n, i) {
        if (BoostPFS.prototype.hasOwnProperty(t)) {
          i.prototype[e] = function () {
            var e, i = [];
            if (n && n.length > 0)
              for (var r = 0; r < n.length; r++) {
                var o = n[r];
                if (this.hasOwnProperty(o)) i.push(this[o]);
                else if (0 == o.indexOf("@")) {
                  var a = parseInt(o.substr(1));
                  void 0 !== arguments[a] ? i.push(arguments[a]) : i.push(null)
                } else i.push(null)
              }
            return (e = BoostPFS.prototype[t]).call.apply(e, [BoostPFS.instance].concat(i))
          }
        }
      },
      Ns = {
        mapLegacyFunctions: function () {
          xs.forEach((function (t) {
            Ds(t.name, t.mapToFunction)
          })), Ms.forEach((function (t) {
            Vs(t.name, t.mapToFunction, t.mapArguments, t.component)
          }))
        },
        mapLegacyFunctionCall: Ds,
        mapLegacyFunctionOverride: Vs
      },
      Us = (n(129), n(51)),
      qs = {
        UserAction: {
          VIEW_PRODUCT: "view_product",
          QUICK_VIEW: "quick_view",
          ADD_TO_CART: "add_to_cart",
          BUY_NOW: "buy_now"
        },
        Action: {
          FILTER: "filter",
          SEARCH: "search",
          SUGGEST: "suggest"
        }
      },
      Hs = "boostPFSAnalytics",
      Ws = "",
      Gs = "",
      zs = null,
      Ks = function () {
        o.a.getSettingValue("search.enableSuggestion") && r()("." + p.a.searchSuggestionWrapper).length > 0 && r()("." + p.a.searchSuggestionWrapper).each((function (t, e) {
          e.addEventListener("click", Xs, !0), document.addEventListener("keydown", Xs, !0)
        }))
      },
      Ys = function () {
        s.a.trackingProduct && r()(s.a.products).length > 0 && document.addEventListener("click", Zs, !0)
      },
      Qs = function () {
        var t = rc(Hs);
        Array.isArray(t) && (t.forEach((function (t) {
          ac(t), t.pid == boostPFSAppConfig.general.product_id && (zs = t)
        })), u.a.isProductPage() && (s.a.trackingAddToCart && r()(s.a.trackingAddToCart).length > 0 && r()(s.a.trackingAddToCart)[0].addEventListener("click", tc, !0), s.a.trackingBuyNow && r()(s.a.trackingBuyNow).length > 0 && r()(s.a.trackingBuyNow)[0].addEventListener("click", ec, !0)))
      },
      Js = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (function (t) {
          var e = 16 * Math.random() | 0;
          return ("x" == t ? e : 3 & e | 8).toString(16)
        }))
      },
      Zs = function (t) {
        if (t && t.target) {
          var e = r()(t.target),
            n = u.a.isSearchPage() ? qs.Action.SEARCH : qs.Action.FILTER,
            i = qs.UserAction.VIEW_PRODUCT;
          s.a.trackingQuickView && e.closest(s.a.trackingQuickView).length > 0 && (i = qs.UserAction.QUICK_VIEW), s.a.trackingAddToCart && e.closest(s.a.trackingAddToCart).length > 0 && (i = qs.UserAction.ADD_TO_CART), s.a.trackingBuyNow && e.closest(s.a.trackingBuyNow).length > 0 && (i = qs.UserAction.BUY_NOW);
          var o = "",
            a = e.closest(s.a.trackingProduct);
          if (a.length > 0 ? o = a.attr("data-id") : zs && (i != qs.UserAction.ADD_TO_CART && i != qs.UserAction.BUY_NOW || (o = zs.pid)), o) {
            var l = nc(o, i, n);
            ic(l), ac(l), zs = i == qs.UserAction.QUICK_VIEW ? l : null
          }
        }
      },
      Xs = function (t) {
        if (t && t.target && ("keydown" != t.type || 13 == t.keyCode)) {
          var e = r()(t.target).closest("." + p.a.searchSuggestionItem + "-product");
          if (e) {
            var n = e.attr("data-id");
            if (n) {
              var i = nc(n, qs.UserAction.VIEW_PRODUCT, qs.Action.SUGGEST);
              ic(i)
            }
          }
        }
      },
      tc = function (t) {
        var e = {
          tid: l.a.shopDomain,
          pid: boostPFSAppConfig.general.product_id.toString(),
          u: qs.UserAction.ADD_TO_CART,
          ct: Ws
        };
        ic(e), ac(e)
      },
      ec = function (t) {
        var e = {
          tid: l.a.shopDomain,
          pid: boostPFSAppConfig.general.product_id.toString(),
          u: qs.UserAction.BUY_NOW
        };
        ic(e), ac(e)
      },
      nc = function (t, e, n) {
        var i = new Date,
          r = Ws,
          o = e == qs.UserAction.QUICK_VIEW ? qs.UserAction.VIEW_PRODUCT : e,
          a = "";
        if (n == qs.Action.FILTER ? a += "collection_scope=" + l.a.collectionId : a += "q=" + l.a.currentTerm, n == qs.Action.FILTER || n == qs.Action.SEARCH) {
          var s = Object.keys(l.a.queryParams).filter((function (t) {
            return t.startsWith(l.a.prefix)
          }));
          s && s.length > 0 && s.forEach((function (t) {
            var e = l.a.queryParams[t];
            Array.isArray(e) ? e.forEach((function (e) {
              a += "&" + t + "=" + encodeURIComponent(e)
            })) : a += "&" + t + "=" + encodeURIComponent(e)
          }))
        }
        return {
          tid: l.a.shopDomain,
          ct: r,
          pid: t,
          t: i.toISOString(),
          u: o,
          a: n,
          qs: a,
          r: document.referrer
        }
      },
      ic = function (t) {
        var e = rc(Hs);
        Array.isArray(e) || (e = []);
        var n = e.filter((function (e) {
          return e.pid != t.productId
        }));
        n.push(t), oc(Hs, n)
      },
      rc = function (t) {
        try {
          return JSON.parse(localStorage.getItem(t))
        } catch (t) {
          return null
        }
      },
      oc = function (t, e) {
        try {
          null != e ? localStorage.setItem(t, JSON.stringify(e)) : localStorage.setItem(t, "")
        } catch (t) {}
      },
      ac = function (t, e) {
        if (e || t.ct) {
          t.sid = Gs;
          var n = new XMLHttpRequest;
          n.open("POST", Us.a.getApiUrl("analytics")), n.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), n.onload = function () {
            n.readyState > 3 && 200 == n.status && function (t) {
              var e = rc(Hs);
              if (Array.isArray(e)) {
                var n = e.filter((function (e) {
                  return e.pid != t
                }));
                oc(Hs, n)
              }
            }(t.pid)
          }, n.send(JSON.stringify(t))
        } else setTimeout((function () {
          ! function (t) {
            var e = new XMLHttpRequest;
            e.open("GET", "/cart.js"), e.onload = function () {
              if (e.readyState > 3 && 200 == e.status) {
                var n = JSON.parse(e.responseText),
                  i = n.item_count <= 0 ? "" : n.token;
                Ws = i, t && (t.ct = i, ac(t, !0))
              }
            }, e.send()
          }(t)
        }), 1e3)
      },
      lc = {
        init: function () {
          window.XMLHttpRequest && (Ws = "", (Gs = rc("boostPFSSessionId")) || (Gs = Js(), oc("boostPFSSessionId", Gs)), Ks(), Ys(), Qs())
        }
      };

    function sc(t) {
      return (sc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function cc(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function uc(t, e) {
      return !e || "object" !== sc(e) && "function" != typeof e ? function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
      }(t) : e
    }

    function pc(t) {
      return (pc = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function fc(t, e) {
      return (fc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var hc = function (t) {
        function e() {
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), uc(this, pc(e).call(this))
        }
        var n, i, a;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && fc(t, e)
        }(e, t), n = e, (i = [{
          key: "init",
          value: function () {
            var t = this;
            if (r()('input[name="' + o.a.getSettingValue("search.termKey") + '"]:not([data-disable-instant-search])').each((function (e, n) {
                var i = new Jt("boost-pfs-search-box-" + e, r()(n));
                t.addComponent(i)
              })), u.a.isMobile() && (window.onpageshow = function (t) {
                t.persisted && window.location.reload()
              }, o.a.getSettingValue("search.suggestionMobileStyle") !== y.Mobile.SuggestionType.STYLE_2)) {
              var e = Nt.instantSearchMobile();
              this.addComponent(e)
            }
          }
        }]) && cc(n.prototype, i), a && cc(n, a), e
      }(f.a),
      yc = {
        inject: function (t) {
          t.jQ = r.a, t.noUiSlider = Bl.a, t.Analytics = lc, t.Class = p.a, t.Globals = l.a, t.Labels = a.a, t.Navigation = c.a, t.Selector = s.a, t.Settings = o.a, t.Utils = u.a, t.FunctionMapper = Ns, t.Api = Us.a, t.FilterApi = Ae.default, t.InstantSearchApi = h.default, t.FilterTreeEnum = pr, t.FilterOptionEnum = Wi.a, t.InstantSearchEnum = y, t.Filter = Bs, t.FilterTree = ss, t.FilterStyle = Ls, t.FilterTreeStyle2 = ds, t.FilterTreeStyle3 = Ts, t.FilterTreeStyle4 = Is, t.FilterOption = Va, t.FilterOptionList = Ka, t.FilterOptionBox = el, t.FilterOptionSwatch = sl, t.FilterOptionMultiLevelCollections = Ql, t.FilterOptionMultiLevelTag = ns, t.FilterOptionRangeSlider = Hl, t.FilterOptionRating = dl, t.FilterOptionSubCategory = jl, t.FilterApplyButton = Pr, t.FilterClearButton = mr, t.FilterCollapse = ja, t.FilterScrollbar = Jo, t.FilterSearchBox = xo, t.FilterTooltip = qo, t.FilterViewMore = Ao, t.FilterOptionItem = Ir, t.FilterOptionItemList = $r, t.FilterOptionItemBox = qr, t.FilterOptionItemSwatch = Jr, t.FilterOptionItemMultiLevelCollections = pa, t.FilterOptionItemSecondLevelCollections = sa, t.FilterOptionItemThirdLevelCollections = ca, t.FilterOptionItemMultiLevelTag = wa, t.FilterOptionItemSecondLevelTag = Oa, t.FilterOptionItemThirdLevelTag = Ta, t.FilterOptionItemRangeSlider = To, t.FilterOptionItemRating = oo, t.FilterOptionItemSubCategory = ho, t.FilterRefineBy = kl, t.FilterRefineByItem = Ol, t.FilterLoadingIcon = rr, t.FilterMobileButton = Ji, t.FilterScrollToTop = ur, t.FilterResult = Hi, t.ProductList = Ie, t.ProductListPlaceholder = Zn, t.ProductItem = ie, t.ProductGridItem = ce, t.ProductListItem = de, t.ProductCollageItem = Oe, t.Breadcrumb = cn, t.PageInfoCollection = dn, t.PageInfoSearch = en, t.ProductDisplayType = xe, t.ProductLimit = Ye, t.ProductSorting = qe, t.RobotsMeta = On, t.SearchResultPanels = Pe.a, t.SearchResultPanelItem = Te.a, t.SearchResultTotal = Mi, t.ProductPagination = Tn.a, t.ProductPaginationDefault = Le.a, t.ProductPaginationInfinite = jn, t.ProductPaginationLoadMore = En, t.ProductPaginationLoadPrevious = Vn, t.SearchDisplayPagination = Gn, t.SearchInput = Jt, t.InstantSearch = hc, t.InstantSearchMobile = Dt, t.InstantSearchResult = kt, t.InstantSearchStyle = Nt, t.InstantSearchResultStyle2 = Rt, t.InstantSearchResultBlock = it, t.InstantSearchResultBlockDym = J, t.InstantSearchResultBlockEmpty = Ot, t.InstantSearchResultBlockLoading = dt, t.InstantSearchResultBlockViewAll = ct, t.InstantSearchResultItem = O, t.InstantSearchResultItemCollection = D, t.InstantSearchResultItemPage = W, t.InstantSearchResultItemPopular = k, t.InstantSearchResultItemProduct = R, t.AutocompleteMenuCustom = Wt, t.InstantSearchResultRedirect = qt
        }
      };

    function dc(t) {
      return (dc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
      })(t)
    }

    function gc(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }

    function mc(t) {
      return (mc = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t)
      })(t)
    }

    function bc(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t
    }

    function vc(t, e) {
      return (vc = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t
      })(t, e)
    }
    var Sc = function (t) {
        function e() {
          var t, n, i;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
          }(this, e), n = this, (t = !(i = mc(e).call(this)) || "object" !== dc(i) && "function" != typeof i ? bc(n) : i).search = null, t.filter = null, Oc = bc(t), t
        }
        var n, i, p;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && vc(t, e)
        }(e, t), n = e, p = [{
          key: "inject",
          value: function (t) {
            yc.inject(t)
          }
        }, {
          key: "instance",
          get: function () {
            return Oc
          }
        }, {
          key: "jQ",
          get: function () {
            return r.a
          }
        }, {
          key: "Globals",
          get: function () {
            return l.a
          }
        }, {
          key: "Labels",
          get: function () {
            return a.a
          }
        }, {
          key: "Selector",
          get: function () {
            return s.a
          }
        }, {
          key: "Settings",
          get: function () {
            return o.a
          }
        }, {
          key: "Utils",
          get: function () {
            return u.a
          }
        }], (i = [{
          key: "init",
          value: function () {
            Ns.mapLegacyFunctions(), o.a.init(), a.a.init(), s.a.init(), l.a.init(), c.a.init(), this.initOTP(), this.initADA()
          }
        }, {
          key: "initSearchBox",
          value: function (t) {
            if (o.a.getSettingValue("search.enableSuggestion") && !u.a.isGLHMobile()) {
              if (this.search = new hc, this.addComponent(this.search), t) {
                var e = new Jt(t);
                this.search.addComponent(e)
              }
              this.search.refresh()
            }
          }
        }, {
          key: "initFilter",
          value: function () {
            o.a.getSettingValue("general.enableFilter") && !u.a.isGLHMobile() && (this.filter = new Bs, this.addComponent(this.filter), this.filter.refresh())
          }
        }, {
          key: "initAnalytics",
          value: function () {
            o.a.getSettingValue("general.enableTrackingOrderRevenue") && !u.a.isGLHMobile() && lc.init()
          }
        }, {
          key: "initOTP",
          value: function () {
            window.BoostOTP && "function" == typeof window.BoostOTP.init && r()(window).on("load", (function () {
              BoostOTP.init()
            }))
          }
        }, {
          key: "initADA",
          value: function () {
            r()("body").on("keyup", (function (t) {
              t && 9 == t.keyCode && r()("body").addClass(Class.adaWrapper)
            })), r()("body").on("click", (function (t) {
              (!t || !t.originalEvent || t.originalEvent.screenX && t.originalEvent.screenY) && r()("body").removeClass(Class.adaWrapper)
            }))
          }
        }]) && gc(n.prototype, i), p && gc(n, p), e
      }(f.a),
      Oc = null,
      Tc = e.default = Sc
  },
  6: function (t, e, n) {
    "use strict";
    var i = {
      filterTree: ".boost-pfs-filter-tree",
      filterTreeVertical: ".boost-pfs-filter-tree-v",
      filterTreeHorizontal: ".boost-pfs-filter-tree-h",
      filterTreeMobileButton: ".boost-pfs-filter-tree-mobile-button",
      filterRefineByVertical: ".boost-pfs-filter-refine-by-wrapper-v",
      filterRefineByHorizontal: ".boost-pfs-filter-refine-by-wrapper-h",
      products: ".boost-pfs-filter-products",
      collections: ".boost-pfs-search-result-collections",
      pages: ".boost-pfs-search-result-pages",
      searchBoxMobile: "#boost-pfs-search-box-mobile",
      searchTopPanels: ".boost-pfs-search-result-panel-controls",
      searchCollectionPagination: ".boost-pfs-search-result-collection-pagination",
      searchPagePagination: ".boost-pfs-search-result-page-pagination",
      searchPanelsProductShow: ".boost-pfs-search-panel-product-show",
      searchPanelsCollectionShow: ".boost-pfs-search-panel-collection-show",
      searchPanelsPageShow: ".boost-pfs-search-panel-page-show",
      searchTotalResult: ".boost-pfs-search-total-result",
      topShowLimit: ".boost-pfs-filter-top-show-limit",
      topSorting: ".boost-pfs-filter-top-sorting",
      topDisplayType: ".boost-pfs-filter-top-display-type",
      pagination: ".boost-pfs-filter-bottom-pagination,.boost-pfs-filter-top-pagination",
      bottomPagination: ".boost-pfs-filter-bottom-pagination",
      loadMore: ".boost-pfs-filter-load-more",
      loadMoreButtonContainer: ".boost-pfs-filter-load-more-button-container",
      btnLoadPreviousPageWrapperSelector: ".boost-pfs-filter-btn-load-previous-page-wrapper",
      btnLoadPreviousPageSelector: ".boost-pfs-filter-btn-load-previous-page",
      loadMoreLoading: ".boost-pfs-filter-load-more-loading",
      topNotification: ".boost-pfs-filter-top-notification",
      breadcrumb: ".boost-pfs-filter-breadcrumb",
      scrollToTop: ".boost-pfs-filter-scroll-to-top",
      otpProductItem: "",
      otpButtons: "",
      otpTopCartLink: 'header a[href="/cart"]',
      otpTopCartCount: "#CartCount",
      otpTopCartSubtotal: "",
      mostPopular: ".boost-pfs-most-popular",
      recentlyViewed: ".boost-pfs-recently-viewed",
      trackingProduct: ".boost-pfs-filter-products > *",
      trackingQuickView: ".boost-pfs-quickview-btn",
      trackingAddToCart: 'form[action="/cart/add"] *[type="submit"]',
      trackingBuyNow: ".shopify-payment-button, #dynamic-checkout-cart",
      init: function () {
        var t = i;
        "undefined" != typeof boostPFSConfig && boostPFSConfig.hasOwnProperty("selector") && null !== boostPFSConfig.selector && (t = Utils.mergeObject(t, boostPFSConfig.selector)), "undefined" != typeof boostPFSFilterConfig && boostPFSFilterConfig.hasOwnProperty("selector") && null !== boostPFSFilterConfig.selector && (t = Utils.mergeObject(t, boostPFSFilterConfig.selector)), "undefined" != typeof boostPFSInstantSearchConfig && boostPFSInstantSearchConfig.hasOwnProperty("selector") && null !== boostPFSInstantSearchConfig.selector && (t = Utils.mergeObject(t, boostPFSInstantSearchConfig.selector)), i = t
      }
    };
    e.a = i
  },
  7: function (t, e, n) {
    "use strict";
    n.r(e);
    n(14), n(15), n(16), n(36), n(23), n(154), n(44), n(34), n(10), n(67), n(96), n(84), n(129), n(48), n(11), n(62), n(19), n(40), n(189), n(46), n(13), n(20), n(57), n(37), n(55), n(38), n(24), n(12), n(103);
    var i = n(0),
      r = n.n(i),
      o = n(1),
      a = n(2),
      l = n(3),
      s = n(51),
      c = n(39),
      u = n(59),
      p = n(5);

    function f(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = new Array(t.length); e < t.length; e++) n[e] = t[e];
          return n
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t)
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance")
      }()
    }
    var h = null,
      y = {
        eventType: "",
        eventInfo: {}
      },
      d = function (t, e, n) {
        if (v(t), b && b.forEach((function (e) {
            "function" == typeof e && e(t)
          })), "function" == typeof k.beforeCall && k.beforeCall(t, y.eventInfo), "function" != typeof k.beforeCallAsync) g(t, e, n);
        else {
          k.beforeCallAsync((function () {
            g(t, e, n)
          }), t, y.eventInfo)
        }
      },
      g = function t(e, n, i, a) {
        a = void 0 !== a ? a : 0, h = n, o.a.queryParams.callback = "BoostPFSFilterCallback", o.a.queryParams.event_type = e;
        var c = s.a.getApiUrl("filter");
        l.a.isSearchPage() && (c = s.a.getApiUrl("search"), o.a.hasOwnProperty("searchDisplay") && o.a.searchDisplay && "products" !== o.a.searchDisplay && (c += "/" + o.a.searchDisplay));
        var u = document.createElement("script");
        u.type = "text/javascript";
        var p = (new Date).getTime(),
          f = JSON.parse(JSON.stringify(o.a.queryParams));
        o.a.queryParams = f, u.src = c + "?t=" + p + "&" + r.a.param(o.a.queryParams), u.id = "boost-pfs-filter-script", u.async = !0;
        var y;
        u.addEventListener("error", (function (e) {
          "function" == typeof document.getElementById(u.id).remove ? document.getElementById(u.id).remove() : document.getElementById(u.id).outerHTML = "", a < 2 ? (a++, y && clearTimeout(y), y = setTimeout(t("resend", n, i, a), 2e3)) : "function" == typeof i && i()
        })),
        document.getElementsByTagName("head")[0].appendChild(u),
        u.addEventListener("load", (function (t) {
          "function" == typeof document.getElementById(u.id).remove ? document.getElementById(u.id).remove() : document.getElementById(u.id).outerHTML = "";

          var changeTextObj = $(".boost-pfs-filter-option-value:contains('AboveHM')");
          var removeTextObj = $(".refine-by-type:contains('AboveHM')");
          var changeText ='';
          var removeText ='';

          changeTextObj.each(function(index, element){
              changeText = '';
              changeText = $(element).text();
              changeText = changeText.replace('AboveHM ','');
              changeText = changeText.replace('円','円 ～');
              $(element).text(changeText);
          });

          removeTextObj.each(function(index, element){
              removeText = '';
              removeText = $(element).text();
              removeText = removeText.replace('AboveHM ','');
              removeText = removeText.replace('円','円 ～');
              $(element).text(removeText);
          });

        }))
      },
      m = function (t) {
        "function" == typeof h && h(t, y.eventType, y.eventInfo)
      },
      b = [],
      v = function (t) {
        var e = mergeObject({}, o.a.queryParams);
        e = O(e, t), e = T(e, t), e = S(e, t), (e = s.a.setApiLocaleParams(e)).hasOwnProperty("currency") && delete e.currency, e.hasOwnProperty("currency_rate") && delete e.currency_rate, o.a.queryParams = e
      },
      S = function (t, e) {
        var n = Object.keys(t);
        return n = n.filter((function (t) {
          return (0 == t.indexOf("pf_p_") || 0 == t.indexOf("pf_vp_")) && !t.includes("_exclude_from_value")
        })), o.a.activeCurrencyPrices = [], n.length && n.forEach((function (e) {
          var n = [];
          Array.isArray(t[e]) && t[e].forEach((function (t) {
            var e = t.split(":");
            e = e.map((function (t, e) {
              var n = 0 == e;
              return 0 == t.length ? "" : l.a.revertPriceToDefaultCurrency(t, n)
            })), n.push(e.join(":"))
          })), o.a.activeCurrencyPrices[e] = t[e], t[e] = n
        })), t
      },
      O = function (t, e) {
        var n = c.a.getHistoryState(),
          i = 0;
        "history" == e ? i = n && n.param && n.param.hasOwnProperty("collection_scope") ? parseInt(n.param.collection_scope) : parseInt(boostPFSConfig.general.collection_id) : null != o.a.collectionId ? i = parseInt(o.a.collectionId) : boostPFSConfig.general.collection_id && (i = parseInt(boostPFSConfig.general.collection_id)), o.a.collectionId = i, t.collection_scope = i;
        var r = null;
        ("history" == e ? r = n && n.param && n.param.hasOwnProperty("tag") ? n.param.tag : boostPFSConfig.general.collectionTags : o.a.collectionTags ? r = o.a.collectionTags : boostPFSConfig.general.collectionTags && (r = boostPFSConfig.general.collectionTags), o.a.collectionTags = r, t.tag = r, 1 == a.a.getSettingValue("general.availableAfterFiltering") ? (t.product_available = !0 === l.a.checkExistFilterOptionParam() || o.a.productAvailable, t.variant_available = !0 === l.a.checkExistFilterOptionParam() || o.a.variantAvailable) : (t.product_available = o.a.productAvailable, t.variant_available = o.a.variantAvailable), a.a.getSettingValue("general.showOutOfStockOption") && (t.zero_options = !0), t.build_filter_tree = !(void 0 !== e && o.a.imutableFilterTree.indexOf(e) > -1), t.check_cache = !(!1 !== l.a.checkExistFilterOptionParam() || 1 != t.page || t.sort != o.a.defaultSorting || t.limit != a.a.getSettingValue("general.limit") || l.a.isSearchPage() || l.a.isVendorPage() || l.a.isTypePage()), "" != a.a.getSettingValue("general.priceMode") && (t.price_mode = a.a.getSettingValue("general.priceMode")), "" != a.a.getSettingValue("general.tagMode") && (t.tag_mode = a.a.getSettingValue("general.tagMode")), a.a.getSettingValue("general.sortingAvailableFirst") && (t.sort_first = "available"), l.a.isVendorPage() && t.hasOwnProperty("q")) && (t[a.a.getSettingValue("general.vendorParam")] = [t.q], delete t.q);
        l.a.isTypePage() && t.hasOwnProperty("q") && (t[a.a.getSettingValue("general.typeParam")] = [t.q], delete t.q);
        return t
      },
      T = function (t, e) {
        if (l.a.isSearchPage()) {
          t.q = l.a.getSearchTerm(), "q" != o.a.searchTermKey && delete t[o.a.searchTermKey];
          var n = a.a.getSettingValue("search.enableFuzzy");
          !0 !== n && (t.fuzzy = n), !1 !== a.a.getSettingValue("search.reduceMinMatch") && (t.reduce_min_match = a.a.getSettingValue("search.reduceMinMatch")), a.a.getSettingValue("search.fullMinMatch") && (t.full_min_match = !0), a.a.getSettingValue("general.sortingAvailableFirst") && (t.sort_first = "available"), a.a.getSettingValue("search.enablePlusCharacterSearch") && (t.enable_plus_character_search = !0)
        }
        return t
      },
      P = function (t) {
        var e = "";
        e = t ? "string" == typeof t && 2 == t.split("?").length ? t.split("?")[1] : "" : l.a.getWindowLocation().search;
        var n = new URLSearchParams(e),
          i = {},
          r = a.a.getSettingValue("general.urlScheme");
        return n.forEach((function (t, e) {
          var n = c.a.longParamMap.get(e);
          n || (n = e);
          var s = o.a.imutableFilterTree.includes(n) || n == o.a.searchTermKey || n.startsWith(o.a.prefix) && n.includes("_and_condition") || n.startsWith(o.a.prefix) && n.includes("_show_exact_rating") || n.startsWith(o.a.prefix) && n.includes("_exclude_from_value"),
            u = n.startsWith(o.a.prefix);
          if (s) i[n] = t, o.a.hasFilterOptionParam = !0;
          else if (u) {
            var f = n.startsWith(o.a.prefix + "_c_"),
              h = n.startsWith(o.a.prefix + "_ct_");
            if (f) {
              if (!l.a.isSearchPage()) return;
              i.collection_scope = t
            } else if (h) {
              var y = a.a.getSettingValue("general.multiLevelCollectionSelectType");
              i.tag_mode = y == p.a.SelectType.MULTIPLE ? "2" : "1", n = "tag"
            }
            switch (r) {
            case 2:
              i[n] = t.split(",");
              break;
            case 1:
            default:
              i.hasOwnProperty(n) ? i[n].push(t) : i[n] = [t]
            }
            f ? o.a.collectionId = i.collection_scope : h && (o.a.collectionTags = i.tag), o.a.hasFilterOptionParam = !0
          }
        })), i
      },
      w = function (t) {
        t._ = o.a.prefix, t.shop = t.hasOwnProperty("shop") ? t.shop : o.a.shopDomain, t.page = t.hasOwnProperty("page") ? parseInt(t.page) : 1;
        var e = a.a.getSettingValue("general.limit");
        return "default" == a.a.getSettingValue("general.paginationType") || a.a.getSettingValue("general.paginationTypeAdvanced") ? t.limit = t.hasOwnProperty("limit") ? t.limit : e : t.limit = (t.hasOwnProperty("limit") ? t.limit : e) * t.page, l.a.isSearchPage() && (o.a.defaultSorting = "best-selling"), t.sort = t.hasOwnProperty("sort") ? t.sort : o.a.defaultSorting, t.display = t.hasOwnProperty("display") ? t.display : a.a.getSettingValue("general.defaultDisplay"), t = _(t)
      },
      _ = function (t) {
        return t = C(t)
      },
      C = function (t) {
        if ("undefined" != typeof boostPFSConfig && void 0 !== boostPFSConfig.general.currencies && boostPFSConfig.general.currencies.length > 1) {
          var e = boostPFSConfig.general.current_currency.toLowerCase().trim();
          t.currency = e, "undefined" != typeof Shopify && void 0 !== Shopify.currency && void 0 !== Shopify.currency.rate && (t.currency_rate = Shopify.currency.rate)
        }
        return t
      },
      k = {
        BoostPFSFilterCallback: function (t) {
          k.setDefaultValueForExcludedFields(t), "function" == typeof k.afterCall && k.afterCall(t, y.eventType, y.eventInfo), "function" != typeof k.afterCallAsync ? m(t) : k.afterCallAsync(t, m, y.eventType, y.eventInfo)
        },
        getFilterData: d,
        updateParamsFromUrl: function (t) {
          var e = P(t);
          e = w(e), o.a.queryParams = e
        },
        setParam: function (t, e) {
          null == e || Array.isArray(e) && 0 == e.length ? delete o.a.queryParams[t] : Array.isArray(e) ? o.a.queryParams[t] = f(new Set(e)) : o.a.queryParams[t] = e;
          var n = t.startsWith(o.a.prefix + "_c_"),
            i = t.startsWith(o.a.prefix + "_ct_"),
            r = o.a.queryParams[t];
          if ((n || "collection_scope" == t) && (o.a.queryParams.collection_scope = r, o.a.collectionId = r, !r)) {
            var a = t.replace(o.a.prefix + "_c_", o.a.prefix + "_ct_");
            delete o.a.queryParams[a], o.a.queryParams.tag = null, o.a.collectionTags = null
          }
          i && (o.a.queryParams.tag = r, o.a.collectionTags = r)
        },
        setDefaultValueForExcludedFields: function (t) {
          if (Array.isArray(t.products)) {
            var e = (new Date).toISOString();
            t.products.forEach((function (t) {
              t.hasOwnProperty("variants") || (t.variants = []), t.hasOwnProperty("images_info") || (t.images_info = []), t.hasOwnProperty("collections") || (t.collections = []), t.hasOwnProperty("tags") || (t.tags = []), t.hasOwnProperty("skus") || (t.skus = []), t.hasOwnProperty("options_with_values") || (t.options_with_values = []), t.hasOwnProperty("barcodes") || (t.barcodes = []), t.hasOwnProperty("created_at") || (t.created_at = e), t.hasOwnProperty("updated_at") || (t.updated_at = e), t.hasOwnProperty("published_at") || (t.published_at = e)
            }))
          }
        },
        addBeforeApplyFilter: function (t) {
          b.push(t)
        },
        applyFilter: function (t, e) {
          y.eventType = t, y.eventInfo = e, u.default.instance.filter.filterLoadingIcon.setShow(!0), d(t, u.default.instance.filter.setData.bind(u.default.instance.filter), u.default.instance.filter.errorFilterCallback.bind(u.default.instance.filter)), c.a.updateAddressBar()
        },
        callFilterApi: g,
        callbackFilterApi: m,
        beforeCall: null,
        afterCall: null,
        beforeCallAsync: null,
        afterCallAsync: null
      };
    e.default = k
  },
  74: function (t, e, n) {
    "use strict";
    n.r(e);
    n(23), n(10), n(96), n(122), n(129), n(197), n(11), n(24), n(12);
    var i = n(0),
      r = n.n(i),
      o = n(1),
      a = n(2),
      l = n(3),
      s = n(51),
      c = function t(e, n, i, o) {
        n = void 0 !== n ? n : 0, o = void 0 !== o ? o : "";
        var a = p(e, i);
        a.q && (e = a.q, delete a.q), "" != o && (a.prev_query = o);
        var l = document.createElement("script");
        l.type = "text/javascript", l.src = s.a.getApiUrl("suggestion") + "?q=" + e + "&" + r.a.param(a), l.async = !0, l.addEventListener("error", (function (e) {
          r()(this).remove(), n < 3 && (n++, t(a.q, i, o, n))
        })), document.getElementsByTagName("head")[0].appendChild(l), l.addEventListener("load", (function (t) {
          r()(this).remove()
        }))
      },
      u = function (t) {
        var e = o.a.suggestionCache;
        if (t.hasOwnProperty("prev_query")) {
          var n = t.prev_query;
          if (e.hasOwnProperty(n)) {
            var i, a = e[n],
              s = ["collections", "did_you_mean", "pages", "suggestions", "suggest_query"],
              c = s.length;
            for (i = 0; i < c; i++) t[s[i]] = l.a.getValueInObjectArray(s[i], a);
            t.prev_total_product = l.a.getValueInObjectArray("total_product", a), a[l.a.findIndexArray("products", a, "key")].values = t.products, a.push({
              key: "local_cache",
              values: !0
            }), a.push({
              key: "suggest_total_product",
              values: t.total_product
            }), o.a.suggestionCache[n] = a
          }
        }
        window.suggestionCallback(r.a.map(t, (function (t, e) {
          return {
            key: e,
            values: t
          }
        })))
      },
      p = function (t, e) {
        var n = {};
        n.shop = o.a.shopDomain, n.t = (new Date).getTime(), a.a.getSettingValue("search.enableDefaultResult") || (n.enable_default_result = !1);
        var i = a.a.getSettingValue("search.enableFuzzy");
        !0 !== i && (n.fuzzy = i), a.a.getSettingValue("search.fullMinMatch") && (n.full_min_match = !0), !1 !== a.a.getSettingValue("search.reduceMinMatch") && (n.reduce_min_match = a.a.getSettingValue("search.reduceMinMatch")), a.a.getSettingValue("search.enablePlusCharacterSearch") && (n.enable_plus_character_search = !0), 1 == a.a.getSettingValue("search.productAvailable") && (n.product_available = !0);
        var r, l = a.a.getSettingValue("search.suggestionBlocks"),
          c = l.length;
        for (r = 0; r < c; r++) {
          n[l[r].type.slice(0, -1) + "_limit"] = l[r].number
        }
        n.dym_limit = a.a.getSettingValue("search.suggestionDymLimit");
        var u = a.a.getSettingValue("search.skipFields");
        u.length > 0 && (param.skipFields = u), n.callback = "BoostPFSInstantSearchCallback", n.event_type = e;
        var p = "suggest_dym" == e ? ["products"] : a.a.getSettingValue("search.suggestionTypes");
        return n.suggest_types = p, n = s.a.setApiLocaleParams(n), Object.assign(n, o.a.instantSearchQueryParams)
      },
      f = {
        BoostPFSInstantSearchCallback: function (t) {
          f.setDefaultValueForExcludedFields(t), "function" == typeof f.afterCall && f.afterCall(t), "function" != typeof f.afterCallAsync ? u(t) : f.afterCallAsync(t, u)
        },
        getSuggestionData: function (t, e, n, i) {
          if ("function" == typeof f.beforeCall && f.beforeCall(t), "function" != typeof f.beforeCallAsync) c(t, 0, n, i);
          else {
            f.beforeCallAsync(t, (function () {
              c(t, 0, n, i)
            }))
          }
        },
        prepareSuggestionParams: p,
        setDefaultValueForExcludedFields: function (t) {
          if (Array.isArray(t.products)) {
            var e = (new Date).toISOString();
            t.products.forEach((function (t) {
              t.hasOwnProperty("variants") || (t.variant = []), t.hasOwnProperty("images_info") || (t.images_info = []), t.hasOwnProperty("collections") || (t.collections = []), t.hasOwnProperty("tags") || (t.tags = []), t.hasOwnProperty("skus") || (t.skus = []), t.hasOwnProperty("options_with_values") || (t.options_with_values = []), t.hasOwnProperty("barcodes") || (t.barcodes = []), t.hasOwnProperty("created_at") || (t.created_at = e), t.hasOwnProperty("updated_at") || (t.updated_at = e), t.hasOwnProperty("published_at") || (t.published_at = e)
            }))
          }
        },
        callInstantSearchApi: c,
        callbackInstantSearchApi: u,
        beforeCall: null,
        afterCall: null,
        beforeCallAsync: null,
        afterCallAsync: null
      };
    e.default = f
  },
  8: function (t, e, n) {
    "use strict";
    var i = n(3),
      r = n(2),
      o = function (t, e, n) {
        return boostPFSConfig.hasOwnProperty(t) && boostPFSConfig[t].hasOwnProperty(e) ? boostPFSConfig[t][e] : n
      },
      a = {
        productFilter: "Product filter",
        refine: "Refine By",
        refineMobile: "Refine By",
        refineMobileCollapse: "Hide Filter",
        clear: "Clear",
        clearAll: "Clear All",
        apply: "Apply",
        applyAll: "Apply All",
        close: "Close",
        back: "Back",
        loadMore: "Load more {{ amountProduct }} Products",
        loadMoreTotal: "{{ from }} - {{ to }} of {{ total }} Products",
        loadPreviousPage: "Load Previous Page",
        searchOptions: "Search options",
        collectionAll: "All",
        viewMore: "View More",
        viewLess: "View Less",
        under: "Under",
        above: "Above",
        ratingStar: "Star",
        ratingStars: "Stars",
        ratingUp: "& Up",
        showResult: "Show Results",
        showLimit: "Show",
        sortingList: {
          "best-selling": "Best Selling",
          manual: "Featured",
          "price-ascending": "Lowest Price",
          "price-descending": "Highest Price",
          "title-ascending": "Alphabetically, A-Z",
          "title-descending": "Alphabetically, Z-A",
          "created-descending": "Date, New to Old",
          "created-ascending": "Date, Old to New",
          "published-descending": "Date, New to Old",
          "published-ascending": "Date, Old to New",
          "sale-descending": "% Off",
          relevance: "Relevance"
        },
        search: {
          generalTitle: "Search",
          resultHeader: 'Search Results for "{{ terms }}"',
          resultEmpty: 'Sorry, nothing found for "{{ terms }}". Check out these items instead?',
          resultNumber: 'Showing {{ count }} results for "{{ terms }}"',
          searchPanelProduct: "Products",
          searchPanelCollection: "Collections",
          searchPanelPage: "Pages",
          searchTotalResult: "Showing {{ count }} result",
          searchTotalResults: "Showing {{ count }} results"
        },
        suggestion: {
          placeholder: "Search",
          popularHeader: "Popular Suggestions",
          productHeader: "Products",
          didYouMeanHeader: "Did you mean",
          viewAll: "View all {{ count }} product(s)",
          suggestQuery: "Showing results for {{ terms }}.",
          didYouMean: "Did you mean: {{ terms }}?",
          searchBoxPlaceholder: "Search"
        },
        error: {
          noFilterResult: "Sorry, no products matched your selection",
          noSearchResult: "Sorry, no products matched the keyword",
          noProducts: "No products found in this collection",
          noSuggestionProducts: 'Sorry, nothing found for "{{ terms }}"',
          noSuggestionResult: 'Sorry, nothing found for "{{ terms }}"'
        },
        action_list: {
          qvBtnLabel: "Quick View",
          qvAddToCartBtnLabel: "Add To Cart",
          qvSoldOutLabel: "Sold Out",
          qvSaleLabel: "Sale",
          qvQtyLeftLabel: "Hurry, there are only {{item}} item(s) left!",
          qvNotifyMeSuccessfullyLabel: "Thanks! We will notify you when this product becomes available!",
          qvNotifyMeErrorLabel: "Please provide a valid email address.",
          qvNotifyMeMessageLabel: "Notify me when {{item}} becomes available",
          qvNotifyMeFormBodyLabel: "Please notify me when {{item}} becomes available.",
          atcAvailableLabel: "Add To Cart",
          atcSelectOptionsLabel: "Select Options",
          atcSoldOutLabel: "Sold Out",
          atcAddingToCartBtnLabel: "Adding...",
          atcAddedToCartBtnLabel: "Added!",
          atcPopupAddedToCartLabel: "has been added to shopping cart",
          atcPopupSubtotalLabel: "Cart Subtotal",
          atcPopupCheckoutLabel: "Checkout",
          atcPopupGoToCartLabel: "Your Cart",
          atcPopupTotalItemsLabel: "item(s)",
          atcPopupCrossSellHeadingLabel: "Frequently bought with",
          atcMiniCartCountItemLabel: "item(s) in your shopping cart",
          atcMiniCartTotalItemsLabel: "Total Items",
          atcMiniCartSubtotalLabel: "Subtotal",
          atcMiniCartCheckoutLabel: "Process Checkout",
          atcMiniCartViewCartLabel: "View and edit cart",
          atcMiniCartEmptyCartLabel: "Your Cart Is Currently Empty",
          atcMiniCartRemoveItemLabel: "Remove This Item",
          atcMiniCartShopingCartLabel: "Shopping Cart"
        },
        mostPopular: {
          popularProductsHeading: "Popular products"
        },
        recentlyViewed: {
          recentProductHeading: "Recently viewed products"
        },
        ada: {
          toggleMultiLevel: "Expand/Collapse {{filterItem}}",
          filterOption: "Filter by {{filterOption}}",
          clearFilterOption: "Clear filter by {{filterOption}}",
          clearFilterItem: "Clear filter by {{filterOption}} {{filterItem}}",
          clearAllFilterItems: "Clear all filters",
          filterOptionTitle: "Filter by {{filterOption}}",
          minValue: "Min value",
          maxValue: "Max value"
        },
        init: function () {
          var t = {
              refine: o("label", "refine", "Refine By"),
              refineMobile: o("label", "refine_mobile", "Refine By"),
              refineMobileCollapse: o("label", "refine_mobile_collapse", "Hide Filter"),
              clear: o("label", "clear", "Clear"),
              clearAll: o("label", "clear_all", "Clear All"),
              apply: o("label", "apply", "Apply"),
              applyAll: o("label", "apply_all", "Apply All"),
              close: o("label", "close", "Close"),
              loadMore: o("label", "load_more", "Load more {{ amountProduct }} Products"),
              loadMoreTotal: o("label", "load_more_total", "{{ from }} - {{ to }} of {{ total }} Products"),
              loadPreviousPage: o("label", "load_previous_page", "Load Previous Page"),
              searchOptions: "Search options",
              collectionAll: "All",
              viewMore: "View More",
              viewLess: "View Less",
              under: "Under",
              above: "Above",
              ratingStar: "Star",
              ratingStars: "Stars",
              ratingUp: "& Up",
              showResult: "Show Results",
              showLimit: "Show",
              sortingList: {
                "best-selling": o("label", "sorting_best_selling", "Best Selling"),
                manual: o("label", "sorting_featured", "Featured"),
                "price-ascending": o("label", "sorting_price_ascending", "Lowest Price"),
                "price-descending": o("label", "sorting_price_descending", "Highest Price"),
                "title-ascending": o("label", "sorting_title_ascending", "Alphabetically, A-Z"),
                "title-descending": o("label", "sorting_title_descending", "Alphabetically, Z-A"),
                "created-descending": o("label", "sorting_date_descending", "Date, New to Old"),
                "created-ascending": o("label", "sorting_date_ascending", "Date, Old to New"),
                "published-descending": o("label", "sorting_date_descending", "Date, New to Old"),
                "published-ascending": o("label", "sorting_date_ascending", "Date, Old to New"),
                "sale-descending": o("label", "sorting_sale_descending", "% Off"),
                relevance: o("label", "sorting_relevance", "Relevance")
              },
              search: {
                seoTitleOne: o("label", "search_seo_title_one", "Search result: {{ count }} result for &quot;{{ terms }}&quot;"),
                seoTitleOther: o("label", "search_seo_title_other", "Search results: {{ count }} results for &quot;{{ terms }}&quot;"),
                generalTitle: o("label", "search_general_title", "Search"),
                resultHeader: o("label", "search_result_header", 'Search Results for "{{ terms }}"'),
                resultEmpty: o("label", "search_result_empty", 'Sorry, nothing found for "{{ terms }}". Check out these items instead?'),
                resultNumber: o("label", "search_result_number", 'Showing {{ count }} results for "{{ terms }}"'),
                searchPanelProduct: o("label", "search_panel_product", "Products ({% raw %}{{ count }}{% endraw %})"),
                searchPanelCollection: o("label", "search_panel_collection", "Collections ({% raw %}{{ count }}{% endraw %})"),
                searchPanelPage: o("label", "search_panel_page", "Pages ({% raw %}{{ count }}{% endraw %})"),
                searchTotalResult: o("label", "search_total_result_one", "Showing {{ count }} result"),
                searchTotalResults: o("label", "search_total_result_other", "Showing {{ count }} results")
              },
              suggestion: {
                placeholder: o("label_suggestion", "suggestion_placeholder", "Search"),
                popularHeader: o("label_suggestion", "suggestion_popular_header", "Popular Suggestions"),
                productHeader: o("label_suggestion", "suggestion_product_header", "Products"),
                didYouMeanHeader: o("label_suggestion", "suggestion_did_you_mean_header", "Did you mean"),
                viewAll: o("label_suggestion", "suggestion_view_all", "View all {{ count }} product(s)"),
                suggestQuery: o("label_suggestion", "suggestion_suggest_query", "Showing results for {{ terms }}."),
                didYouMean: o("label_suggestion", "suggestion_did_you_mean", "Did you mean: {{ terms }}?"),
                searchBoxPlaceholder: o("label_suggestion", "suggestion_placeholder", "Search")
              },
              error: {
                noFilterResult: o("label_error", "error_no_filter_result", "Sorry, no products matched your selection"),
                noSearchResult: o("label_error", "error_no_search_result", "Sorry, no products matched the keyword"),
                noProducts: o("label_error", "error_no_products", "No products found in this collection"),
                noSuggestionProducts: 'Sorry, nothing found for "{{ terms }}"',
                noSuggestionResult: 'Sorry, nothing found for "{{ terms }}"'
              }
            },
            e = i.a.mergeObject(a, t);
          void 0 !== r.a.label && (e = i.a.mergeObject(e, r.a.label)), a = e
        }
      };
    e.a = a
  },
  9: function (t, e, n) {
    "use strict";
    n(23), n(34), n(73), n(24);

    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i)
      }
    }
    var r = function () {
      function t() {
        ! function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, t), this.isInit = !1, this.isRendered = !1, this.isBoundEvent = !1, this.children = [], this.parent = null
      }
      var e, n, r;
      return e = t, (n = [{
        key: "refresh",
        value: function () {
          this._callAllInit(), this._callAllRender(), this._callAllBindEvents()
        }
      }, {
        key: "beforeInit",
        value: function () {}
      }, {
        key: "init",
        value: function () {}
      }, {
        key: "afterInit",
        value: function () {}
      }, {
        key: "isLoopThroughChild",
        value: function () {
          return !0
        }
      }, {
        key: "isRender",
        value: function () {
          return !0
        }
      }, {
        key: "beforeRender",
        value: function () {}
      }, {
        key: "render",
        value: function () {}
      }, {
        key: "afterRender",
        value: function () {}
      }, {
        key: "isBindEvents",
        value: function () {
          return !0
        }
      }, {
        key: "beforeBindEvents",
        value: function () {}
      }, {
        key: "bindEvents",
        value: function () {}
      }, {
        key: "afterBindEvents",
        value: function () {}
      }, {
        key: "addComponent",
        value: function (t) {
          t.parent = this, this.children.push(t)
        }
      }, {
        key: "removeComponent",
        value: function (t) {
          if (this.children && this.children.length > 0) {
            var e = this.children.indexOf(t); - 1 !== e && this.children.splice(e, 1)
          }
        }
      }, {
        key: "_callAllInit",
        value: function () {
          this.isInit || (this.beforeInit(), this.init()), this.children && this.children.length > 0 && this.isLoopThroughChild() && this.children.forEach((function (t) {
            t._callAllInit()
          })), this.isInit || (this.afterInit(), this.isInit = !0)
        }
      }, {
        key: "_callAllRender",
        value: function () {
          this.isRender() && this.beforeRender(), this.children && this.children.length > 0 && this.isLoopThroughChild() && this.children.forEach((function (t) {
            t._callAllRender()
          })), this.isRender() && (this.render(), this.afterRender(), this.isRendered = !0)
        }
      }, {
        key: "_callAllBindEvents",
        value: function () {
          this.isBindEvents() && this.beforeBindEvents(), this.children && this.children.length > 0 && this.isLoopThroughChild() && this.children.forEach((function (t) {
            t._callAllBindEvents()
          })), this.isBindEvents() && (this.bindEvents(), this.afterBindEvents(), this.isBoundEvent = !0)
        }
      }]) && i(e.prototype, n), r && i(e, r), t
    }();
    e.a = r
  }
});
/* Start Boost-P001: 1.2.1-1.4.8 */
!function(){function e(e){try{e||(e=function(){for(var e=window.location.href.replace(/%3C/g,"&lt;").replace(/%3E/g,"&gt;"),t=[],o=0;o<e.length;o++)t.push(e.charAt(o));var n=t.join("").split("&lt;").join("%3C").split("&gt;").join("%3E"),a="",r=n.replace(/#.*$/,"");return r.split("?").length>1&&(a=r.split("?")[1]).length>0&&(a="?"+a),{pathname:window.location.pathname,href:n,search:a}}().search);var t=decodeURIComponent(e).split("&"),o=!1,n=new RegExp(["onabort","popstate","afterprint","beforeprint","beforeunload","blur","canplay","canplaythrough","change","click","contextmenu","copy","cut","dblclick","drag","dragend","dragenter","dragleave","dragover","dragstart","drop","durationchange","ended","error","focus","focusin","focusout","fullscreenchange","fullscreenerror","hashchange","input","invalid","keydown","keypress","keyup","load","loadeddata","loadedmetadata","loadstart","mousedown","mouseenter","mouseleave","mousemove","mouseover","mouseout","mouseout","mouseup","offline","online","pagehide","pageshow","paste","pause","play","playing","progress","ratechange","resize","reset","scroll","search","seeked","seeking","select","show","stalled","submit","suspend","timeupdate","toggle","touchcancel","touchend","touchmove","touchstart","unload","volumechange","waiting","wheel"].join("=|on"));if(t.length>0)for(var a=0;a<t.length;a++){var r=t[a];if([(r.match(/</g)||[]).length,(r.match(/>/g)||[]).length,(r.match(/alert\(/g)||[]).length,(r.match(/console\.log\(/g)||[]).length,(r.match(/execCommand/g)||[]).length,(r.match(/document\.cookie/g)||[]).length,(r.match(/href="javascript:/g)||[]).length,n.test(r)].some(function(e){return e>0})){o=!0;break}}return o}catch{return!0}}BoostPFS.inject(this),"undefined"!=typeof Filter&&(Filter.prototype.isBadUrl=e,Filter.prototype.beforeInit=function(){e()&&(this.isInit=!0,window.location.href=window.location.pathname)})}();
/* End Boost-P001: 1.2.1-1.4.8 */
